// ═══════════════════════════════════════════════════════════════
// v3.3.769 — البوابة الخارجية (/portal)
// واجهة عامة (ويب/موبايل) لأطراف خارجية: دخول بالجوال + كلمة سر،
// معزولة تمامًا عن النظام الرئيسي (توكن خاص في localStorage، بلا Google،
// بلا قوائم النظام). تُدخل عملاء محتملين مباشرة وتعرض إدخالات الحساب فقط.
// ═══════════════════════════════════════════════════════════════
import React, { useState, useEffect, useCallback, useRef } from "react";
import { createPortal } from "react-dom"; // v3.4.168 — الطبقات الثابتة تُرسم على body (خارج حاوية التمرير) لتستقبل اللمسات على iOS
// v3.3.846 — خريطة العروض العقارية داخل البوابة (نسخة CSP + worker وRTL يُضبطان في LandOffersPage)
import maplibregl from "maplibre-gl/dist/maplibre-gl-csp";
import "maplibre-gl/dist/maplibre-gl.css";
import { buildStyle, DEFAULT_CENTER } from "./LandOffersPage";

const TOKEN_KEY = "portal_token";
import WaMedia, { isPlaceholderBody } from "../components/WaMedia"; // v3.4.091 — مرفقات واتس الأعمال
import { FiUsers, FiEdit3, FiHome, FiMap, FiBarChart2, FiMessageCircle, FiRadio, FiPhoneIncoming, FiClock, FiFileText, FiTag, FiCheckSquare, FiUserCheck } from "react-icons/fi"; /* v3.4.465 FiCheckSquare/FiUserCheck */
import { PortalTasks, PortalVisitors } from "./PortalEmployeeViews"; // v3.4.465 /* v3.4.443 FiTag (عقار) */ // v3.4.192 FiClock (الدوام)
import HrAttendancePanel from "../components/HrAttendancePanel"; // v3.4.192 — الموارد البشرية للموظف // v3.4.096 — أيقونات الشريط السفلي — v3.4.156 مكالماتي
import { FaWhatsapp } from "react-icons/fa";
// v3.4.192 — واجهة الموارد البشرية للموظف (نفس التوكن): /api/portal/hr/...
const hrApi = async (path, opts = {}) => {
  const token = localStorage.getItem(TOKEN_KEY);
  const res = await fetch(`/api/portal/hr${path}`, { method: opts.method || "GET", headers: { "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) }, body: opts.body ? JSON.stringify(opts.body) : undefined });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || "حدث خطأ");
  return data;
};
// v3.4.198 — جلب مستند طلب (ملف) بنفس التوكن
const hrBlob = async (path) => { const token = localStorage.getItem(TOKEN_KEY); const res = await fetch(`/api/portal/hr${path}`, { headers: token ? { Authorization: `Bearer ${token}` } : {} }); if (!res.ok) throw new Error("تعذر فتح المستند"); return res.blob(); };
const api = async (path, opts = {}) => {
  const token = localStorage.getItem(TOKEN_KEY);
  const res = await fetch(`/api/portal${path}`, {
    method: opts.method || "GET",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: opts.body ? JSON.stringify(opts.body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || "حدث خطأ");
  return data;
};

const inputS = {
  width: "100%", padding: "13px 14px", border: "1.5px solid #e2e8f0", borderRadius: 10,
  fontFamily: "inherit", fontSize: 15, outline: "none", boxSizing: "border-box", background: "#fff",
};
const labelS = { display: "block", fontSize: 13, fontWeight: 700, color: "#475569", marginBottom: 6 };
const btnPrimary = {
  width: "100%", padding: "14px", background: "linear-gradient(135deg,#0f766e,#14b8a6)", color: "#fff",
  border: "none", borderRadius: 10, fontFamily: "inherit", fontSize: 15.5, fontWeight: 800, cursor: "pointer",
};

// v3.4.467 — قائمة «عرض كـ»: مجموعات حسب نوع المستخدم بترتيب ثابت، أبجديًا داخل كل مجموعة، والموقوفة معطّلة في آخرها
const VIEW_AS_ORDER = [["gm", "مدير عام"], ["sales_manager", "مديرة مبيعات"], ["supervisor", "مشرف"], ["employee", "موظف شركة"], ["marketer", "مسوّق"], ["ext_marketer", "مسوّق خارجي"], ["rep", "مندوب"]];
function viewAsOptions(list) {
  const st = { color: "#0f172a" };
  const byName = (a, b) => String(a.display_name || a.phone || "").localeCompare(String(b.display_name || b.phone || ""), "ar");
  const active = (list || []).filter(u => u.is_active !== false), inactive = (list || []).filter(u => u.is_active === false).sort(byName);
  const known = VIEW_AS_ORDER.map(([k]) => k);
  const groups = [...VIEW_AS_ORDER, ...[...new Set(active.map(u => u.account_type || "rep"))].filter(t => !known.includes(t)).map(t => [t, t])];
  return [
    ...groups.map(([k, l]) => { const us = active.filter(u => (u.account_type || "rep") === k).sort(byName);
      return us.length ? <optgroup key={k} label={l + " (" + us.length + ")"} style={st}>{us.map(u => <option key={u.id} value={u.is_self ? "" : u.id} disabled={!!u.is_self} style={st}>{u.display_name || u.phone}{u.is_self ? " — الحساب الحالي" : ""}</option>)}</optgroup> : null; }),
    inactive.length ? <optgroup key="_inactive" label={"⛔ موقوفة (" + inactive.length + ") — تُفعَّل من إدارة الحسابات"} style={st}>{inactive.map(u => <option key={"x" + u.id} value="" disabled style={st}>{u.display_name || u.phone}</option>)}</optgroup> : null,
  ];
}

// v3.4.232 — تجربة ويب على الشاشات العريضة: يتابع عرض النافذة (≥ 900px = سطح مكتب)
function useIsDesktop() {
  const get = () => typeof window !== "undefined" && !!window.matchMedia && window.matchMedia("(min-width: 900px)").matches;
  const [d, setD] = useState(get);
  useEffect(() => {
    if (!window.matchMedia) return;
    const mq = window.matchMedia("(min-width: 900px)"); const h = () => setD(mq.matches);
    if (mq.addEventListener) mq.addEventListener("change", h); else mq.addListener(h);
    return () => { if (mq.removeEventListener) mq.removeEventListener("change", h); else mq.removeListener(h); };
  }, []);
  return d;
}

export default function PortalPage() {
  const isDesktop = useIsDesktop(); // v3.4.232
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);
  const [splash, setSplash] = useState(true); // v3.3.771 — شاشة افتتاحية
  // v3.3.776 — رقم النسخة في الهيدر (من نقطة الحالة العامة)
  const [version, setVersion] = useState("");
  useEffect(() => {
    fetch("/api/health").then(r => r.json()).then(d => setVersion(d.version || "")).catch(() => {});
  }, []);
  const [toast, setToast] = useState(null); // {msg, ok}
  const notify = (msg, ok = true) => { setToast({ msg, ok }); setTimeout(() => setToast(null), 3500); };

  // v3.3.771 — PWA: مانيفست خاص بالبوابة + أيقونة التطبيق + لون الثيم + Service Worker
  useEffect(() => {
    document.title = "المنظم التسويقي"; // v3.3.781 — عنوان التبويب
    const added = [];
    const addTag = (tag, attrs) => {
      const el = document.createElement(tag);
      Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
      document.head.appendChild(el);
      added.push(el);
      return el;
    };
    // استبدال مانيفست النظام بمانيفست البوابة (يُعاد عند الخروج)
    const oldManifest = document.querySelector('link[rel="manifest"]');
    const oldHref = oldManifest?.getAttribute("href");
    if (oldManifest) oldManifest.setAttribute("href", "/portal-manifest.json");
    else addTag("link", { rel: "manifest", href: "/portal-manifest.json" });
    addTag("meta", { name: "theme-color", content: "#0f766e" });
    addTag("link", { rel: "apple-touch-icon", href: "/rael-icon-180.png?v=3" });
    addTag("meta", { name: "apple-mobile-web-app-capable", content: "yes" });
    addTag("meta", { name: "apple-mobile-web-app-status-bar-style", content: "black-translucent" });
    addTag("meta", { name: "apple-mobile-web-app-title", content: "المنظم التسويقي" });
    // Service Worker بنطاق البوابة فقط (لا يمس النظام الرئيسي)
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("/portal-sw.js", { scope: "/portal" }).catch(() => {});
    }
    // v3.3.774 — قفل الانزلاق الأفقي: التطبيق ينسحب عموديًا فقط كسائر التطبيقات
    const de = document.documentElement, bd = document.body;
    const prevStyles = {
      deOx: de.style.overflowX, bdOx: bd.style.overflowX,
      deOb: de.style.overscrollBehaviorX, bdOb: bd.style.overscrollBehaviorX,
      bdTa: bd.style.touchAction, bdMw: bd.style.maxWidth,
      deOy: de.style.overflowY, bdOy: bd.style.overflowY, bdH: bd.style.height, // v3.4.166
    };
    de.style.overflowX = "hidden"; bd.style.overflowX = "hidden";
    // v3.4.166 — body لا يتمرر: المحتوى يتمرر داخل حاوية، فيبقى الهيدر والشريط السفلي ثابتين على iOS
    de.style.overflowY = "hidden"; bd.style.overflowY = "hidden"; bd.style.height = "100%"; window.scrollTo(0, 0);
    de.style.overscrollBehaviorX = "none"; bd.style.overscrollBehaviorX = "none";
    bd.style.touchAction = "pan-y"; bd.style.maxWidth = "100vw";
    // منع التكبير بالقرص (يمنع أيضًا الانجراف الأفقي بعد الزوم)
    const vp = document.querySelector('meta[name="viewport"]');
    const prevVp = vp?.getAttribute("content");
    if (vp) vp.setAttribute("content", "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover");
    const splashTimer = setTimeout(() => setSplash(false), 1200);
    return () => {
      clearTimeout(splashTimer);
      added.forEach(el => el.remove());
      if (oldManifest && oldHref) oldManifest.setAttribute("href", oldHref);
      // v3.3.774 — استرجاع أنماط الصفحة عند الخروج من البوابة
      de.style.overflowX = prevStyles.deOx; bd.style.overflowX = prevStyles.bdOx;
      de.style.overscrollBehaviorX = prevStyles.deOb; bd.style.overscrollBehaviorX = prevStyles.bdOb;
      bd.style.touchAction = prevStyles.bdTa; bd.style.maxWidth = prevStyles.bdMw;
      de.style.overflowY = prevStyles.deOy; bd.style.overflowY = prevStyles.bdOy; bd.style.height = prevStyles.bdH; // v3.4.166
      if (vp && prevVp) vp.setAttribute("content", prevVp);
    };
  }, []);

  // v3.4.160 — وضع المعاينة: /portal?preview_token=… (من إدارة حسابات البوابة) → يُخزَّن الرمز ويُرفع شريط تنبيه، ويُنظَّف الرابط
  const [previewName, setPreviewName] = useState(() => { try { return sessionStorage.getItem("portal_preview_name") || ""; } catch { return ""; } });
  // v3.4.165 — «عرض كـ» للمدير العام: يُحفظ رمزه الأصلي في sessionStorage ليعود إليه بضغطة
  const GM_KEY = "portal_gm_token";
  const [gmToken, setGmToken] = useState(() => { try { return sessionStorage.getItem(GM_KEY) || ""; } catch { return ""; } });
  const [gmUsers, setGmUsers] = useState([]);
  const isGmView = !!gmToken; // نعرض التطبيق حاليًا كمستخدم آخر
  useEffect(() => {
    if ((user?.account_type === "gm" || user?.system_admin || user?.can_view_as || user?.features?.view_as) && !isGmView) api("/gm/users").then(r => setGmUsers(r.users || [])).catch(() => {}); // v3.4.254 — مدير النظام أيضًا
  }, [user, isGmView]);
  // v3.4.254 — شاشة الدخول: إن كانت جلسة النظام الرئيسي لمدير، تظهر قائمة الدخول المباشر بأي حساب
  const [adminUsers, setAdminUsers] = useState([]);
  useEffect(() => { if (!user && !checking) api("/gm/users").then(r => setAdminUsers(r.users || [])).catch(() => setAdminUsers([])); }, [user, checking]);
  const viewAs = async (id) => {
    if (!id) return;
    try {
      const r = await api("/gm/view-as", { method: "POST", body: { portal_user_id: Number(id) } });
      const own = localStorage.getItem(TOKEN_KEY);
      try { sessionStorage.setItem(GM_KEY, own || ""); sessionStorage.setItem("portal_gm_users", JSON.stringify(gmUsers)); } catch {}
      setGmToken(own || "");
      localStorage.setItem(TOKEN_KEY, r.token);
      const me = await api("/me"); setUser(me.user);
      window.scrollTo(0, 0); document.getElementById("portal-scroll")?.scrollTo(0, 0);
    } catch (e) { alert(e.message || "تعذر فتح المعاينة"); }
  };
  const backToMe = async () => {
    try { await api("/logout", { method: "POST" }); } catch {}
    localStorage.setItem(TOKEN_KEY, gmToken);
    try { sessionStorage.removeItem(GM_KEY); } catch {}
    setGmToken("");
    try { const me = await api("/me"); setUser(me.user); } catch { localStorage.removeItem(TOKEN_KEY); setUser(null); }
  };
  useEffect(() => {
    try {
      const sp = new URLSearchParams(window.location.search);
      const pt = sp.get("preview_token");
      if (pt) {
        localStorage.setItem(TOKEN_KEY, pt);
        const nm = sp.get("preview_name") || "";
        sessionStorage.setItem("portal_preview_name", nm || "حساب");
        setPreviewName(nm || "حساب");
        sp.delete("preview_token"); sp.delete("preview_name");
        const qs = sp.toString();
        window.history.replaceState({}, "", window.location.pathname + (qs ? "?" + qs : ""));
      }
    } catch {}
    if (!localStorage.getItem(TOKEN_KEY)) { setChecking(false); return; }
    api("/me").then(r => setUser(r.user)).catch(() => localStorage.removeItem(TOKEN_KEY))
      .finally(() => setChecking(false));
  }, []);

  // v3.3.771 — شاشة افتتاحية (Splash)
  if (splash) {
    return (
      <div dir="rtl" style={{ minHeight: "100vh", background: "linear-gradient(160deg,#134e4a,#0f766e)",
        display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 14,
        fontFamily: "'Segoe UI', Tahoma, sans-serif" }}>
        {/* v3.3.777 — الشعار الرسمي (المنظم التسويقي) في شاشة التحميل */}
        <div style={{ background: "#fff", borderRadius: 28, padding: 18,
          boxShadow: "0 10px 40px rgba(0,0,0,0.35)" }}>
          <img src="/organizer-logo.png" alt="المنظم التسويقي"
            style={{ width: 180, height: 180, display: "block" }} />
        </div>
        <div style={{ color: "rgba(255,255,255,0.85)", fontSize: 14, fontWeight: 700 }}>تسجيل العملاء المهتمين</div>
        <div style={{ width: 34, height: 34, border: "3px solid rgba(255,255,255,0.25)", borderTopColor: "#fff",
          borderRadius: "50%", animation: "raelspin 0.9s linear infinite", marginTop: 8 }} />
        <style>{"@keyframes raelspin{to{transform:rotate(360deg)}}"}</style>
      </div>
    );
  }

  return (
    <div dir="rtl" className={"portal-shell" + (isDesktop ? " portal-desktop" : "")} style={{ background: "#f1f5f9", fontFamily: "'Segoe UI', Tahoma, sans-serif", maxWidth: "100vw" }}>{/* v3.4.232 */}
      {/* v3.4.166 — الهيكل: هيدر ثابت + حاوية تمرير + شريط سفلي ثابت (بدون تمرير body) */}
      <style>{`
        .portal-shell{position:fixed;top:0;left:0;right:0;bottom:0;width:100%;height:100%;display:flex;flex-direction:column;overflow:hidden;background:#134e4a}
        .portal-shell > .portal-scroll{background:#f1f5f9}
        .portal-scroll{flex:1 1 auto;min-height:0;overflow-y:auto;overflow-x:hidden;-webkit-overflow-scrolling:touch;overscroll-behavior:contain}
        /* v3.4.232 — سطح المكتب: حاوية عريضة، بطاقات العملاء في عمودين، ونماذج الإدخال بعرض مريح */
        .portal-desktop .portal-main{max-width:1180px}
        body[data-pview="home"] .portal-desktop .portal-main, body[data-pview="stats"] .portal-desktop .portal-main, body[data-pview="hr"] .portal-desktop .portal-main, body[data-pview="calls"] .portal-desktop .portal-main{max-width:820px!important}
        .portal-desktop .pclients{column-count:2;column-gap:14px}
        .portal-desktop .pclients>*{break-inside:avoid}
        .portal-desktop .pclients>*:not(.pcard){column-span:all}
        .portal-desktop .ptopnav{position:sticky;top:-24px;z-index:50;margin:-24px -28px 18px;padding:0 16px;background:rgba(255,255,255,.96);backdrop-filter:blur(12px);border-bottom:1px solid #e2e8f0;box-shadow:0 6px 18px rgba(15,23,42,.06)}
        .portal-desktop .ptopnav button:hover{background:#f0fdfa!important}
      `}</style>
      {/* v3.4.165 — شريط «تشاهد التطبيق كـ» للمدير العام */}
      {isGmView && user && (
        <div style={{ background: "#fef3c7", borderBottom: "2px solid #f59e0b", color: "#92400e", padding: "7px 14px", fontSize: 12.5, fontWeight: 800, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
          <span>👁 تشاهد التطبيق الآن كـ: {user.display_name || user.phone}</span>
          <button onClick={backToMe} style={{ background: "#fff", border: "1px solid #f59e0b", color: "#92400e", borderRadius: 8, padding: "4px 10px", fontSize: 12, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>↩ العودة إلى حسابي</button>
        </div>
      )}
      {/* v3.4.160 — شريط وضع المعاينة (للإدارة): يشاهد التطبيق كما يراه صاحب الحساب */}
      {previewName && user && (
        <div style={{ background: "#fef3c7", borderBottom: "2px solid #f59e0b", color: "#92400e", padding: "8px 14px", fontSize: 12.5, fontWeight: 800, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
          <span>🔍 وضع المعاينة — تشاهد التطبيق كما يراه: {user.display_name || previewName}</span>
          <button onClick={async () => { try { await api("/logout", { method: "POST" }); } catch {} localStorage.removeItem(TOKEN_KEY); try { sessionStorage.removeItem("portal_preview_name"); } catch {} setPreviewName(""); setUser(null); window.close(); }}
            style={{ background: "#fff", border: "1px solid #f59e0b", color: "#92400e", borderRadius: 8, padding: "5px 12px", fontSize: 12, fontWeight: 800, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>
            إنهاء المعاينة
          </button>
        </div>
      )}
      {/* هيدر */}
      <div style={{ background: "linear-gradient(135deg,#134e4a,#0f766e)", padding: "18px 20px", paddingTop: "calc(18px + env(safe-area-inset-top))", flexShrink: 0, /* v3.4.166 */
        display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        {/* v3.3.771 — العنوان: تسجيل العملاء المهتمين (بدل اسم البوابة) */}
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <img src="/rael-icon-192.png?v=3" alt="" style={{ width: 34, height: 34, borderRadius: 9 }} />
          <div>
            <div style={{ color: "#fff", fontWeight: 800, fontSize: 17 }}>تسجيل العملاء المهتمين</div>
            {/* v3.3.776 — رقم النسخة */}
            {version && <div style={{ color: "rgba(255,255,255,0.65)", fontSize: 10.5, marginTop: 1, direction: "ltr", textAlign: "right" }}>v{version}</div>}
          </div>
        </div>
        {user && (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {/* v3.4.165 — المدير العام: عرض التطبيق كمستخدم آخر */}
            {(user.account_type === "gm" || user.system_admin || user.can_view_as || user.features?.view_as) && !isGmView && gmUsers.length > 0 && ( /* v3.4.270 */ /* v3.4.254 — مدير النظام أيضًا */
              <select value="" onChange={e => viewAs(e.target.value)} onFocus={() => { api("/gm/users").then(r => { if (Array.isArray(r.users)) setGmUsers(r.users); }).catch(() => {}); }} title="معاينة التطبيق كما يراه مستخدم معيّن" /* v3.4.467 — تحديث القائمة عند الفتح */
                style={{ background: "rgba(255,255,255,0.15)", color: "#fff", border: "1px solid rgba(255,255,255,0.3)", borderRadius: 8, padding: "6px 8px", fontSize: 12, fontWeight: 700, fontFamily: "inherit", maxWidth: 170 }}>
                <option value="" style={{ color: "#0f172a" }}>👁 عرض كـ…</option>
                {viewAsOptions(gmUsers)}{/* v3.4.467 */}
              </select>
            )}
            {isGmView ? (
              <button onClick={backToMe}
                style={{ background: "#fbbf24", color: "#78350f", border: "none", borderRadius: 8, padding: "7px 12px", fontSize: 12, fontWeight: 800, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>
                ↩ العودة إلى حسابي
              </button>
            ) : (
              <button onClick={async () => { try { await api("/logout", { method: "POST" }); } catch {} localStorage.removeItem(TOKEN_KEY); setUser(null); }}
                style={{ background: "rgba(255,255,255,0.15)", color: "#fff", border: "1px solid rgba(255,255,255,0.3)",
                  borderRadius: 8, padding: "7px 14px", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
                خروج
              </button>
            )}
          </div>
        )}
      </div>

      {/* v3.3.783 — التنبيهات صارت داخل المحتوى (كانت عائمة أعلى الشاشة فتختفي خلف نتوء الآيفون) */}
      <div className="portal-scroll" id="portal-scroll">
      <div className="portal-main" style={{ maxWidth: isDesktop ? 1180 : 520, margin: "0 auto", padding: isDesktop ? "24px 28px 48px" : "22px 16px calc(96px + env(safe-area-inset-bottom))" }}>{/* v3.4.232 — عرض الحاوية من CSS على سطح المكتب */}
        {checking ? (
          <div style={{ textAlign: "center", padding: 60, color: "#94a3b8" }}>جاري التحقق...</div>
        ) : !user ? (
          <>
            {adminUsers.length > 0 && ( /* v3.4.254 — دخول مباشر لمدير النظام بأي حساب */
              <div style={{ background: "#fff", borderRadius: 14, padding: "14px 16px", boxShadow: "0 4px 20px rgba(0,0,0,0.06)", marginTop: 24, display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                <span style={{ fontSize: 12.5, fontWeight: 800, color: "#0f766e" }}>🔑 أنت مدير النظام — ادخل مباشرة بحساب:</span>
                <select value="" onChange={e => viewAs(e.target.value)}
                  style={{ flex: 1, minWidth: 180, border: "1px solid #99f6e4", borderRadius: 8, padding: "7px 10px", fontSize: 13, fontFamily: "inherit", color: "#0f172a", background: "#f0fdfa" }}>
                  <option value="">اختر حسابًا…</option>
                  {viewAsOptions(adminUsers)}{/* v3.4.467 */}
                </select>
              </div>
            )}
            <PortalLogin onLogin={(u) => setUser(u)} notify={notify} toast={toast} />
          </>
        ) : (
          <PortalHome key={user.id} user={user} notify={notify} toast={toast} />
        )}
      </div>
      </div>
    </div>
  );
}

// v3.3.783 — تنبيه مدمج داخل المحتوى (مرئي دائمًا على كل الأجهزة)
function InlineToast({ toast }) {
  if (!toast) return null;
  return (
    <div style={{ background: toast.ok ? "#dcfce7" : "#fee2e2", color: toast.ok ? "#166534" : "#991b1b",
      border: `1.5px solid ${toast.ok ? "#86efac" : "#fca5a5"}`, borderRadius: 10, padding: "11px 14px",
      fontSize: 13.5, fontWeight: 700, marginBottom: 14, textAlign: "center" }}>
      {toast.msg}
    </div>
  );
}

// ─── شاشة الدخول + إنشاء حساب جديد (v3.3.788) ───
function PortalLogin({ onLogin, notify, toast }) {
  const [mode, setMode] = useState("login"); // login | register | forgot (v3.4.491)
  const [fgStep, setFgStep] = useState(1); /* v3.4.491 — 1: طلب الرمز، 2: إدخال الرمز + كلمة السر الجديدة */
  const [code, setCode] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [password2, setPassword2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (mode === "forgot") { /* v3.4.491 — استعادة كلمة السر برمز واتساب */
      if (!phone.trim()) return notify("أدخل رقم الجوال", false);
      setBusy(true);
      try {
        if (fgStep === 1) {
          const r = await api("/forgot/request", { method: "POST", body: { phone } });
          notify(r.message || "أُرسل رمز التحقق على واتساب"); setFgStep(2);
        } else {
          if (!code.trim()) { setBusy(false); return notify("أدخل رمز التحقق", false); }
          if (password.length < 6) { setBusy(false); return notify("كلمة السر 6 أحرف على الأقل", false); }
          if (password !== password2) { setBusy(false); return notify("كلمتا السر غير متطابقتين", false); }
          const r = await api("/forgot/reset", { method: "POST", body: { phone, code, password } });
          notify(r.message || "تم تغيير كلمة السر");
          setMode("login"); setFgStep(1); setCode(""); setPassword(""); setPassword2("");
        }
      } catch (err) { notify(err.message, false); }
      setBusy(false);
      return;
    }
    if (mode === "register") {
      if (!name.trim()) return notify("أدخل اسم المستخدم", false);
      if (!phone.trim() || !password) return notify("أدخل الجوال وكلمة السر", false);
      if (password.length < 6) return notify("كلمة السر 6 أحرف على الأقل", false);
      if (password !== password2) return notify("كلمتا السر غير متطابقتين", false);
      setBusy(true);
      try {
        const r = await api("/register", { method: "POST", body: { name, phone, password } });
        notify(r.message || "تم إنشاء الحساب — بانتظار التفعيل");
        setMode("login"); setPassword(""); setPassword2("");
      } catch (err) { notify(err.message, false); }
      setBusy(false);
      return;
    }
    if (!phone.trim() || !password) return notify("أدخل الجوال وكلمة السر", false);
    setBusy(true);
    try {
      const r = await api("/login", { method: "POST", body: { phone, password } });
      localStorage.setItem(TOKEN_KEY, r.token);
      onLogin(r.user);
    } catch (err) { notify(err.message, false); }
    setBusy(false);
  };

  const isReg = mode === "register";
  if (mode === "forgot") return ( /* v3.4.491 */
    <form onSubmit={submit} style={{ background: "#fff", borderRadius: 16, padding: "26px 22px", boxShadow: "0 4px 20px rgba(0,0,0,0.06)", marginTop: 30 }}>
      <div style={{ textAlign: "center", marginBottom: 22 }}>
        <div style={{ fontSize: 40 }}>🔑</div>
        <div style={{ fontSize: 18, fontWeight: 800, color: "#1e293b", marginTop: 6 }}>استعادة كلمة السر</div>
        <div style={{ fontSize: 12.5, color: "#94a3b8", marginTop: 4 }}>
          {fgStep === 1 ? "أدخل رقم جوالك المسجّل وسيصلك رمز تحقق على واتساب" : "أدخل الرمز الذي وصلك على واتساب ثم كلمة السر الجديدة"}
        </div>
      </div>
      <InlineToast toast={toast} />
      <div style={{ marginBottom: 14 }}>
        <label style={labelS}>رقم الجوال</label>
        <input value={phone} onChange={e => setPhone(e.target.value)} placeholder="05XXXXXXXX" type="tel" inputMode="tel" autoComplete="tel"
          disabled={fgStep === 2} style={{ ...inputS, direction: "ltr", textAlign: "right", opacity: fgStep === 2 ? 0.7 : 1 }} />
      </div>
      {fgStep === 2 && (<>
        <div style={{ marginBottom: 14 }}>
          <label style={labelS}>رمز التحقق (6 أرقام)</label>
          <input value={code} onChange={e => setCode(e.target.value)} inputMode="numeric" autoComplete="one-time-code" maxLength={6} placeholder="••••••"
            style={{ ...inputS, direction: "ltr", textAlign: "center", letterSpacing: 6, fontSize: 18, fontWeight: 800 }} />
        </div>
        <div style={{ marginBottom: 14 }}>
          <label style={labelS}>كلمة السر الجديدة (6 أحرف على الأقل)</label>
          <input value={password} onChange={e => setPassword(e.target.value)} type="password" autoComplete="new-password" style={{ ...inputS, direction: "ltr", textAlign: "right" }} />
        </div>
        <div style={{ marginBottom: 20 }}>
          <label style={labelS}>تأكيد كلمة السر</label>
          <input value={password2} onChange={e => setPassword2(e.target.value)} type="password" autoComplete="new-password" style={{ ...inputS, direction: "ltr", textAlign: "right" }} />
        </div>
      </>)}
      <button type="submit" disabled={busy} style={{ ...btnPrimary, opacity: busy ? 0.7 : 1 }}>
        {busy ? "لحظات..." : fgStep === 1 ? "📲 إرسال الرمز على واتساب" : "حفظ كلمة السر الجديدة"}
      </button>
      {fgStep === 2 && (
        <button type="button" disabled={busy} onClick={() => { setFgStep(1); setCode(""); }}
          style={{ width: "100%", marginTop: 10, padding: "8px", background: "none", color: "#64748b", border: "none", fontSize: 12.5, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
          لم يصلك الرمز؟ إعادة الإرسال
        </button>
      )}
      <button type="button" onClick={() => { setMode("login"); setFgStep(1); setCode(""); setPassword(""); setPassword2(""); }}
        style={{ width: "100%", marginTop: 10, padding: "10px", background: "none", color: "#0f766e", border: "1.5px dashed #99f6e4", borderRadius: 10, fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
        رجوع لتسجيل الدخول
      </button>
      <div style={{ marginTop: 12, fontSize: 11.5, color: "#94a3b8", textAlign: "center" }}>إن لم يصلك الرمز تواصل مع الإدارة لإعادة تعيين كلمة السر</div>
    </form>
  );
  return (
    <form onSubmit={submit} style={{ background: "#fff", borderRadius: 16, padding: "26px 22px",
      boxShadow: "0 4px 20px rgba(0,0,0,0.06)", marginTop: 30 }}>
      <div style={{ textAlign: "center", marginBottom: 22 }}>
        <div style={{ fontSize: 40 }}>{isReg ? "📝" : "🔐"}</div>
        <div style={{ fontSize: 18, fontWeight: 800, color: "#1e293b", marginTop: 6 }}>{isReg ? "إنشاء حساب جديد" : "تسجيل الدخول"}</div>
        <div style={{ fontSize: 12.5, color: "#94a3b8", marginTop: 4 }}>
          {isReg ? "عبّئ بياناتك وسيُفعّل حسابك من الإدارة" : "أدخل رقم جوالك وكلمة السر المزوّدة لك"}
        </div>
      </div>
      {/* v3.3.783 — التنبيه داخل البطاقة */}
      <InlineToast toast={toast} />
      {isReg && (
        <div style={{ marginBottom: 14 }}>
          <label style={labelS}>اسم المستخدم *</label>
          <input value={name} onChange={e => setName(e.target.value)} placeholder="اسمك الكامل"
            autoComplete="name" style={inputS} />
        </div>
      )}
      <div style={{ marginBottom: 14 }}>
        <label style={labelS}>رقم الجوال</label>
        <input value={phone} onChange={e => setPhone(e.target.value)} placeholder="05XXXXXXXX"
          type="tel" inputMode="tel" autoComplete="tel"
          style={{ ...inputS, direction: "ltr", textAlign: "right" }} />
      </div>
      <div style={{ marginBottom: isReg ? 14 : 20 }}>
        <label style={labelS}>كلمة السر {isReg ? "(6 أحرف على الأقل)" : ""}</label>
        <input value={password} onChange={e => setPassword(e.target.value)} type="password"
          autoComplete={isReg ? "new-password" : "current-password"}
          style={{ ...inputS, direction: "ltr", textAlign: "right" }} />
      </div>
      {isReg && (
        <div style={{ marginBottom: 20 }}>
          <label style={labelS}>تأكيد كلمة السر</label>
          <input value={password2} onChange={e => setPassword2(e.target.value)} type="password"
            autoComplete="new-password" style={{ ...inputS, direction: "ltr", textAlign: "right" }} />
        </div>
      )}
      <button type="submit" disabled={busy} style={{ ...btnPrimary, opacity: busy ? 0.7 : 1 }}>
        {busy ? "لحظات..." : isReg ? "إنشاء الحساب" : "دخول"}
      </button>
      {!isReg && ( /* v3.4.491 */
        <button type="button" onClick={() => { setMode("forgot"); setFgStep(1); setPassword(""); setPassword2(""); }}
          style={{ width: "100%", marginTop: 10, padding: "6px", background: "none", color: "#64748b", border: "none", fontSize: 12.5, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", textDecoration: "underline" }}>
          نسيت كلمة السر؟
        </button>
      )}
      {/* v3.3.788 — التبديل بين الدخول والتسجيل */}
      <button type="button" onClick={() => setMode(isReg ? "login" : "register")}
        style={{ width: "100%", marginTop: 12, padding: "10px", background: "none", color: "#0f766e",
          border: "1.5px dashed #99f6e4", borderRadius: 10, fontSize: 13, fontWeight: 700,
          cursor: "pointer", fontFamily: "inherit" }}>
        {isReg ? "لديك حساب؟ تسجيل الدخول" : "مستخدم جديد؟ إنشاء حساب"}
      </button>
    </form>
  );
}

// ─── v3.3.806 — بار تشارت بسيط (بلا مكتبات) ───
function MiniBars({ points, labelFmt }) {
  const max = Math.max(1, ...points.map(p => p.count));
  return (
    <div style={{ display: "flex", alignItems: "flex-end", gap: points.length > 16 ? 3 : 6, height: 160, padding: "6px 2px 0", overflowX: "auto" }}>
      {points.map((p, i) => (
        <div key={i} title={`${labelFmt ? labelFmt(p.label) : p.label}: ${p.count}`}
          style={{ flex: "1 0 0", minWidth: points.length > 16 ? 12 : 22, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-end", height: "100%" }}>
          <div style={{ fontSize: 9.5, fontWeight: 800, color: p.count ? "#0f766e" : "#cbd5e1", marginBottom: 2 }}>{p.count || ""}</div>
          <div style={{ width: "100%", height: `${Math.max(3, (p.count / max) * 120)}px`,
            background: p.count ? "linear-gradient(180deg,#14b8a6,#0f766e)" : "#e2e8f0", borderRadius: "4px 4px 0 0", transition: "height .3s" }} />
          <div style={{ fontSize: 8.5, color: "#94a3b8", marginTop: 3, whiteSpace: "nowrap" }}>{labelFmt ? labelFmt(p.label) : p.label}</div>
        </div>
      ))}
    </div>
  );
}

// ─── v3.3.806 — صفحة إحصائيات المندوب ───
function PortalStats({ onBack }) { // v3.4.235 — ثلاثة أقسام: الأرقام / العروض / نشاطي
  const PST = ["رقم جديد", "تحت المتابعة", "مهتم", "جاد جدا", "عميل حجز", "اشترى", "اشترى من طرف ثالث", "غير مهتم"];
  const PSC = { "رقم جديد": ["#e0f2fe", "#075985"], "تحت المتابعة": ["#fef9c3", "#854d0e"], "مهتم": ["#dcfce7", "#166534"], "جاد جدا": ["#ffedd5", "#9a3412"], "عميل حجز": ["#ede9fe", "#5b21b6"], "اشترى": ["#dbeafe", "#1e40af"], "اشترى من طرف ثالث": ["#f1f5f9", "#334155"], "غير مهتم": ["#fee2e2", "#991b1b"] };
  const CHL = { marketers: "التطبيق (مسوّقون)", ext_marketers: "مسوّق خارجي", reps: "المناديب", aqar: "منصة عقار", tiktok: "تيك توك", snapchat: "سناب شات", meta: "إنستغرام/فيسبوك", form: "نموذج", qr: "QR", screen: "الشاشة", boards: "لوحات", import: "استيراد", system: "النظام" };
  const [sec, setSec] = useState("numbers"); // numbers | offers | activity
  const [days, setDays] = useState(30);
  const [view, setView] = useState("daily");
  const [month, setMonth] = useState("");
  const [data, setData] = useState(null);
  const [chart, setChart] = useState(null);
  const [err, setErr] = useState("");
  const [showStale, setShowStale] = useState(false);
  const [sales, setSales] = useState(null); // v3.4.236 — مبيعاتي (حجوزات دليلك المرتبطة بي)
  useEffect(() => { setErr(""); api(`/my-stats?days=${days}`).then(setData).catch(e => setErr(e.message)); api(`/my-sales?days=${days}`).then(setSales).catch(() => setSales({ linked: false })); }, [days]);
  useEffect(() => { api(`/stats?view=${view}${month ? `&month=${month}` : ""}`).then(setChart).catch(() => {}); }, [view, month]);
  const shiftMonth = (delta) => {
    const cur = chart?.month || new Date().toISOString().slice(0, 7);
    const [y, m] = cur.split("-").map(Number);
    const d = new Date(y, m - 1 + delta, 1);
    setMonth(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`);
  };
  const labelFmt = view === "weekly" ? (l) => l.slice(5) : view === "monthly" ? (l) => l.slice(2) : (l) => l;
  const fmtD = (x) => (x ? new Date(x).toLocaleDateString("en-GB", { timeZone: "Asia/Riyadh" }) : "—");
  const fmtT = (x) => (x ? new Date(x).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", timeZone: "Asia/Riyadh" }) : "—");
  const card = (label, val, color, sub) => (
    <div style={{ background: "#fff", borderRadius: 12, padding: "10px 8px", textAlign: "center", boxShadow: "0 2px 10px rgba(0,0,0,0.05)" }}>
      <div style={{ fontSize: 22, fontWeight: 900, color }}>{val ?? "—"}</div>
      <div style={{ fontSize: 10.5, color: "#64748b", fontWeight: 700 }}>{label}</div>
      {sub && <div style={{ fontSize: 9.5, color: "#94a3b8" }}>{sub}</div>}
    </div>
  );
  const box = (title, children, extra) => (
    <div style={{ background: "#fff", borderRadius: 16, padding: "12px 12px", boxShadow: "0 4px 20px rgba(0,0,0,0.06)", marginBottom: 12 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}><div style={{ fontSize: 13, fontWeight: 900, color: "#0f172a" }}>{title}</div>{extra}</div>
      {children}
    </div>
  );
  const statusGrid = (counts, total) => (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 6 }}>
      {PST.map(st => { const c = PSC[st]; const n = counts?.[st] || 0; const pct = total ? Math.round(n / total * 100) : 0; return (
        <div key={st} style={{ background: c[0], borderRadius: 10, padding: "7px 4px", textAlign: "center" }}>
          <div style={{ fontSize: 16, fontWeight: 900, color: c[1] }}>{n}</div>
          <div style={{ fontSize: 9.5, fontWeight: 800, color: c[1], whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{st}</div>
          {total > 0 && <div style={{ fontSize: 9, color: c[1], opacity: .8 }}>{pct}%</div>}
        </div>
      ); })}
    </div>
  );
  const hbars = (rows, labelOf) => { const max = Math.max(1, ...rows.map(r => r.n)); return (
    <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
      {rows.length === 0 && <div style={{ fontSize: 11.5, color: "#94a3b8" }}>لا بيانات</div>}
      {rows.map(r => (
        <div key={r.k} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 11.5 }}>
          <span style={{ width: 120, color: "#334155", fontWeight: 700, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }} title={labelOf ? labelOf(r.k) : r.k}>{labelOf ? labelOf(r.k) : r.k}</span>
          <div style={{ flex: 1, background: "#f1f5f9", borderRadius: 6, height: 12, overflow: "hidden" }}><div style={{ width: `${Math.max(3, r.n / max * 100)}%`, height: "100%", background: "linear-gradient(90deg,#0f766e,#14b8a6)" }} /></div>
          <b style={{ width: 34, textAlign: "left", color: "#0f766e" }}>{r.n}</b>
        </div>
      ))}
    </div>
  ); };
  const chips = (obj) => <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>{Object.entries(obj || {}).map(([k, n]) => <span key={k} style={{ background: "#f1f5f9", color: "#334155", borderRadius: 10, padding: "3px 10px", fontSize: 11, fontWeight: 800 }}>{k}: {n}</span>)}{Object.keys(obj || {}).length === 0 && <span style={{ fontSize: 11.5, color: "#94a3b8" }}>—</span>}</div>;
  const editLabel = (e) => e.kind === "note" ? "📝 ملاحظة" : e.kind === "create" ? "➕ إضافة رقم" : e.changes?.status ? `🔁 ${e.changes.status.from || "—"} → ${e.changes.status.to}` : e.changes?.name ? "✏️ تعديل الاسم" : `✏️ ${e.kind}`;
  const seg = (k, l) => (
    <button key={k} type="button" onClick={() => setSec(k)} style={{ flex: 1, padding: "9px 6px", borderRadius: 10, border: "1.5px solid " + (sec === k ? "#0f766e" : "#e2e8f0"), background: sec === k ? "#0f766e" : "#fff", color: sec === k ? "#fff" : "#475569", fontWeight: 800, fontSize: 12.5, cursor: "pointer", fontFamily: "inherit" }}>{l}</button>
  );
  const n = data?.numbers || {}, o = data?.offers || {}, ac = data?.activity || {};
  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, marginBottom: 10, flexWrap: "wrap" }}>
        <div style={{ fontSize: 17, fontWeight: 900, color: "#0f172a" }}>📊 إحصائياتي</div>
        <div style={{ display: "flex", gap: 4 }}>{[7, 30, 90].map(d => <button key={d} type="button" onClick={() => setDays(d)} style={{ padding: "5px 10px", borderRadius: 8, border: "1.5px solid " + (days === d ? "#0f766e" : "#e2e8f0"), background: days === d ? "#f0fdfa" : "#fff", color: days === d ? "#0f766e" : "#64748b", fontWeight: 800, fontSize: 11, cursor: "pointer", fontFamily: "inherit" }}>{d} يوم</button>)}</div>
      </div>
      <div style={{ display: "flex", gap: 6, marginBottom: 12 }}>{seg("numbers", "📱 الأرقام")}{seg("offers", "🏷️ العروض")}{seg("sales", "💰 مبيعاتي")}{seg("activity", "📈 نشاطي")}</div>{/* v3.4.236 */}
      {data && sec === "sales" && (<>
        {!sales ? <div style={{ textAlign: "center", color: "#94a3b8", padding: 20 }}>جارٍ التحميل…</div>
        : !sales.linked ? <div style={{ ...{ background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 12, padding: 14, fontSize: 12.5, color: "#92400e", fontWeight: 700 } }}>⚠️ حسابك غير مربوط باسم مسوّق في قائمة المسوّقين — اطلب من الإدارة ربطه من «إدارة حسابات البوابة» لتظهر مبيعاتك هنا.</div>
        : (<>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8, marginBottom: 12 }}>
            {card("حجوزاتي (الكل)", sales.total, "#0f172a")}{card("تمت (مبيعات)", sales.sold, "#166534")}{card("قيد الإجراء", sales.pending, "#92400e")}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8, marginBottom: 12 }}>
            {card(`آخر ${sales.days} يوم`, sales.recent_count, "#0f766e", `تمت منها: ${sales.sold_recent ?? 0}`)}{card("هذا الشهر", sales.this_month, "#1d4ed8")}{card("لم تتم", sales.lost, "#991b1b")}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 12 }}>
            {card("قيمة مبيعاتي المكتملة", `${Number(sales.sold_value || 0).toLocaleString("en-US", { maximumFractionDigits: 0 })} ر.س`, "#1e40af")}{card("نسبة الإتمام", `${sales.total ? Math.round(sales.sold / sales.total * 100) : 0}%`, "#0f766e", "تمت ÷ كل حجوزاتي")}
          </div>
          {box("🕒 أحدث حجوزاتي", (sales.recent_list || sales.recent || []).length === 0 || !Array.isArray(sales.recent) ? <div style={{ fontSize: 11.5, color: "#94a3b8" }}>لا حجوزات بعد</div> :
            sales.recent.map(r => (
              <div key={r.id} style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 12, padding: "6px 0", borderBottom: "1px dashed #f1f5f9" }}>
                <div style={{ flex: 1, minWidth: 0 }}><b>{r.client_name}</b> <span style={{ color: "#64748b" }}>{r.project_name || ""}{r.selected_unit_code ? " • " + r.selected_unit_code : ""}</span></div>
                <span style={{ background: /لم تتم/.test(r.operation_status || "") ? "#fee2e2" : /تمت/.test(r.operation_status || "") ? "#dcfce7" : "#fef9c3", color: /لم تتم/.test(r.operation_status || "") ? "#991b1b" : /تمت/.test(r.operation_status || "") ? "#166534" : "#854d0e", borderRadius: 10, padding: "2px 8px", fontSize: 10.5, fontWeight: 800, whiteSpace: "nowrap" }}>{r.operation_status}</span>
                <span style={{ color: "#94a3b8", fontSize: 10.5, whiteSpace: "nowrap" }}>{String(r.date || "").slice(0, 10)}</span>
              </div>
            )))}
        </>)}
      </>)}
      {err && <div style={{ color: "#dc2626", fontSize: 12.5, marginBottom: 10 }}>{err}</div>}
      {!data && !err && <div style={{ textAlign: "center", color: "#94a3b8", padding: 30 }}>جارٍ التحميل…</div>}

      {data && sec === "numbers" && (<>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8, marginBottom: 12 }}>
          {card("عندي (مخصص لي)", n.assigned_total, "#1d4ed8")}{card("أضفتها (إجمالي)", n.added_total, "#0f766e")}{card(`مخصصة لي آخر ${data.days} يوم`, n.assigned_recent, "#7c3aed")}
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8, marginBottom: 12 }}>
          {card("أضفت اليوم", n.added_today, "#0f766e")}{card("هذا الأسبوع", n.added_week, "#1d4ed8")}{card("هذا الشهر", n.added_month, "#7c3aed")}
        </div>
        {box("🗂 تصنيف الأرقام المخصصة لي", statusGrid(n.by_status_assigned, n.assigned_total), <span style={{ fontSize: 10.5, color: "#94a3b8" }}>({n.assigned_total})</span>)}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 12 }}>
          {card("نسبة الإغلاق", `${n.conversion_pct ?? 0}%`, "#1e40af", "حجز + اشترى ÷ المخصص لي")}{card("نسبة المهتمين", `${n.interested_pct ?? 0}%`, "#166534", "مهتم + جاد جدا ÷ المخصص لي")}
        </div>
        {box(`⏰ تحتاج انتباهك: ${n.stale_count || 0} رقم بلا متابعة منذ 7 أيام+`, (
          <>
            <div style={{ fontSize: 11.5, color: "#64748b", marginBottom: 6 }}>أرقام في مرحلة عمل (رقم جديد / تحت المتابعة / مهتم / جاد جدا / عميل حجز) لم تُسجَّل عليها ملاحظة منذ أسبوع أو أكثر{n.new_untouched ? ` — ومنها ${n.new_untouched} «رقم جديد» لم يبدأ بعد` : ""}</div>
            {(n.stale || []).length > 0 && <button type="button" onClick={() => setShowStale(v => !v)} style={{ padding: "6px 12px", borderRadius: 8, border: "1px solid #fde68a", background: "#fffbeb", color: "#92400e", fontSize: 11.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>{showStale ? "إخفاء القائمة" : `عرض أقدم ${(n.stale || []).length}`}</button>}
            {showStale && (n.stale || []).map(x => (
              <div key={x.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, fontSize: 12, padding: "6px 0", borderBottom: "1px dashed #f1f5f9" }}>
                <div><b>{x.name || "—"}</b> <span style={{ color: "#64748b", direction: "ltr", display: "inline-block" }}>{x.phone}</span></div>
                <div style={{ display: "flex", gap: 6, alignItems: "center" }}><span style={{ background: (PSC[x.status] || ["#f1f5f9", "#475569"])[0], color: (PSC[x.status] || ["#f1f5f9", "#475569"])[1], borderRadius: 10, padding: "2px 8px", fontSize: 10.5, fontWeight: 800 }}>{x.status}</span><span style={{ color: "#dc2626", fontWeight: 800, fontSize: 11 }}>{x.idle_days} يوم</span></div>
              </div>
            ))}
          </>
        ))}
        {box("📣 من أين تأتي أرقامي (المصدر)", hbars(n.by_source || []))}
        {box("🏗 اهتمام أرقامي بالمشاريع", hbars(n.by_project || []))}
        {box("🔀 القناة", hbars(n.by_channel || [], (k) => CHL[k] || k))}
        {chart && box("📆 الأرقام التي أضفتها عبر الزمن", (
          <>
            <div style={{ display: "flex", gap: 6, marginBottom: 10 }}>
              {[["daily", "يومي"], ["weekly", "أسبوعي"], ["monthly", "شهري"]].map(([k, l]) => (
                <button key={k} type="button" onClick={() => setView(k)} style={{ flex: 1, padding: "8px", borderRadius: 8, border: "1.5px solid " + (view === k ? "#0f766e" : "#e2e8f0"), background: view === k ? "#0f766e" : "#fff", color: view === k ? "#fff" : "#475569", fontWeight: 800, fontSize: 12.5, cursor: "pointer", fontFamily: "inherit" }}>{l}</button>
              ))}
            </div>
            {view === "daily" && (
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
                <button type="button" onClick={() => shiftMonth(1)} style={{ border: "1px solid #e2e8f0", background: "#fff", borderRadius: 8, padding: "4px 10px", cursor: "pointer" }}>‹</button>
                <div style={{ fontSize: 12.5, fontWeight: 800, color: "#0f172a" }}>{chart.month} — {chart.points.reduce((s2, p) => s2 + p.count, 0)} عميل</div>
                <button type="button" onClick={() => shiftMonth(-1)} style={{ border: "1px solid #e2e8f0", background: "#fff", borderRadius: 8, padding: "4px 10px", cursor: "pointer" }}>›</button>
              </div>
            )}
            <MiniBars points={chart.points || []} labelFmt={labelFmt} />
          </>
        ))}
      </>)}

      {data && sec === "offers" && (<>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8, marginBottom: 12 }}>
          {card("عروض المشاريع", o.project_total, "#c2410c")}{card("عروض الأراضي", o.land_total, "#0f766e")}{card(`أُضيفت آخر ${data.days} يوم`, o.recent_count, "#7c3aed", `هذا الشهر: ${o.this_month ?? 0}`)}
        </div>
        {box("🏗 عروض المشاريع حسب الحالة", chips(o.project_by_status))}
        {box("🗺 عروض الأراضي حسب الحالة", chips(o.land_by_status))}
        {box("🕒 أحدث العروض التي أضفتها", (
          (o.recent || []).length === 0 ? <div style={{ fontSize: 11.5, color: "#94a3b8" }}>لم تضف عروضًا بعد — من تبويب «العروض»</div> :
          (o.recent || []).map(x => (
            <div key={x.kind + x.id} style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 12, padding: "6px 0", borderBottom: "1px dashed #f1f5f9" }}>
              <span>{x.kind === "land" ? "🗺" : "🏗"}</span>
              <div style={{ flex: 1, minWidth: 0 }}><b>{x.label || (x.kind === "land" ? "عرض أرض" : "عرض مشروع")}</b>{x.city ? <span style={{ color: "#64748b" }}> — {x.city}{x.district ? " / " + x.district : ""}</span> : null}</div>
              <span style={{ background: "#f1f5f9", color: "#334155", borderRadius: 10, padding: "2px 8px", fontSize: 10.5, fontWeight: 800 }}>{x.status}</span>
              <span style={{ color: "#94a3b8", fontSize: 10.5, whiteSpace: "nowrap" }}>{fmtD(x.created_at)}</span>
            </div>
          ))
        ))}
      </>)}

      {data && sec === "activity" && (<>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8, marginBottom: 12 }}>
          {card("أرقام أضفتها اليوم", n.added_today, "#0f766e")}{card("تعديلاتي اليوم", ac.edits_today_count, "#7c3aed", `منها تغيير حالة: ${ac.status_changes_today ?? 0}`)}{card("ملاحظاتي هذا الشهر", ac.notes_month, "#1d4ed8", `هذا الأسبوع: ${ac.notes_week ?? 0}`)}
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8, marginBottom: 12 }}>
          {card(`أضفت آخر ${data.days} يوم`, n.added_recent, "#0f766e")}{card(`عروض آخر ${data.days} يوم`, o.recent_count, "#c2410c")}{card("إجمالي ملاحظاتي", ac.notes_total, "#334155")}
        </div>
        {box("🗂 حالات أرقامي المخصصة", statusGrid(n.by_status_assigned, n.assigned_total))}
        {box(`📝 تعديلاتي اليوم (${ac.edits_today_count || 0})`, (
          (ac.edits_today || []).length === 0 ? <div style={{ fontSize: 11.5, color: "#94a3b8" }}>لا تعديلات مسجّلة اليوم بعد — الملاحظات وتغيير الحالات وإضافة الأرقام تظهر هنا</div> :
          (ac.edits_today || []).map((e, i) => (
            <div key={i} style={{ fontSize: 11.5, padding: "5px 0", borderBottom: "1px dashed #f1f5f9" }}>
              <div style={{ display: "flex", gap: 6, alignItems: "center" }}><span style={{ color: "#94a3b8" }}>{fmtT(e.at)}</span><span style={{ fontWeight: 800, color: "#4c1d95" }}>{editLabel(e)}</span><span style={{ flex: 1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{e.label}</span></div>
              {e.text && <div style={{ color: "#475569", marginTop: 2, whiteSpace: "pre-wrap" }}>{e.text}</div>}
            </div>
          ))
        ))}
      </>)}
    </div>
  );
}

const WaLogo = ({ size = 18, color = "#fff" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <path fill={color} d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.885-9.885 9.885m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
  </svg>
);

// v3.4.090 — رقم واتساب دولي بصيغة الأرقام فقط (05… → 966…)
const toWaPhone = (raw) => {
  let p = String(raw || "").replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d)).replace(/\D/g, "");
  if (p.startsWith("00")) p = p.slice(2);
  if (p.startsWith("0")) p = "966" + p.slice(1);
  else if (p.length === 9 && p.startsWith("5")) p = "966" + p;
  return p;
};

// v3.4.093 — المكوّن يخدم صندوقين: base="/wa" (رقم المسوّق) أو "/wa/official" (الرقم الرسمي المشترك مع التحويل)
function PortalWhatsApp({ user, onRead, initial, onConsumed, base = "/wa", boxName, boxNumber, official = false, owner = true, onPersonal = null, onAddClient = null }) { // v3.4.178 onPersonal — v3.4.188 onAddClient
  const [convs, setConvs] = useState(null);
  const [assignee, setAssignee] = useState(null);   // v3.4.093 — المحوّل له في المحادثة المفتوحة
  const [mkts, setMkts] = useState(null);           // v3.4.093 — قائمة المسوّقين للتحويل (المالك فقط)
  const [pickMkt, setPickMkt] = useState("");
  // v3.4.094 — مرفقات: صورة/ملف/تسجيل صوتي (OGG/Opus مباشرة من المتصفح كما يشترط واتساب للرسائل الصوتية)
  const imgRef = useRef(null), fileRef = useRef(null);
  const [rec, setRec] = useState("idle"); // idle | recording
  const [recSec, setRecSec] = useState(0);
  const recRef = useRef({});
  const sendFile = async (file, kind, extra = {}) => {
    if (!file || !sel) return;
    setBusy(true); setErr("");
    try {
      const fd = new FormData();
      fd.append("file", file, file.name || (kind === "audio" ? "voice.ogg" : "file"));
      fd.append("kind", kind); fd.append("phone", sel.phone);
      if (extra.caption) fd.append("caption", extra.caption);
      const token = localStorage.getItem(TOKEN_KEY);
      const r = await fetch(`/api/portal${base}/send-media`, { method: "POST", headers: { Authorization: `Bearer ${token}` }, body: fd });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.error || "فشل إرسال المرفق");
      setMsgs(m => [...m, j.message]);
    } catch (e) { setErr(e.message); }
    setBusy(false);
    if (imgRef.current) imgRef.current.value = "";
    if (fileRef.current) fileRef.current.value = "";
  };
  const startVoice = async () => {
    try {
      const { default: Recorder } = await import("opus-recorder");
      const recorder = new Recorder({ encoderPath: "/opus/encoderWorker.min.js", encoderApplication: 2048, encoderSampleRate: 48000, numberOfChannels: 1, encoderBitRate: 32000 });
      recorder.ondataavailable = (arr) => { recRef.current.data = arr; };
      await recorder.start();
      recRef.current = { recorder, sec: 0, data: null, timer: setInterval(() => { recRef.current.sec += 1; setRecSec(recRef.current.sec); }, 1000) };
      setRec("recording"); setRecSec(0); setErr("");
    } catch (e) { setRec("idle"); setErr("تعذر بدء التسجيل — اسمح للمتصفح باستخدام الميكروفون"); }
  };
  const stopVoice = async () => {
    const st = recRef.current; if (!st.recorder) return;
    clearInterval(st.timer);
    try { await st.recorder.stop(); } catch {}
    const data = st.data, dur = st.sec || 0;
    setRec("idle"); setRecSec(0); recRef.current = {};
    if (!data || !data.length || dur < 1) { setErr("التسجيل قصير جدًا"); return; }
    const file = new File([data], "voice.ogg", { type: "audio/ogg" });
    await sendFile(file, "audio", { duration: dur });
  };
  const cancelVoice = () => { const st = recRef.current; clearInterval(st.timer); try { st.recorder?.stop(); } catch {} recRef.current = {}; setRec("idle"); setRecSec(0); };
  const [q, setQ] = useState("");
  const [sel, setSel] = useState(null);      // { phone, contact_name }
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [win, setWin] = useState(null);      // v3.4.092 — نافذة الـ24 ساعة مفتوحة؟ (null = غير معروف)
  const [tpls, setTpls] = useState(null);    // v3.4.092 — القوالب المعتمدة
  const [pick, setPick] = useState(false);   // v3.4.092 — إظهار قائمة القوالب
  const [tplVals, setTplVals] = useState({}); // v3.4.092 — قيم متغيرات القوالب: { [tplId]: [..] }
  const endRef = useRef(null);

  const loadConvs = useCallback(() => {
    api(base + "/conversations" + (q ? "?q=" + encodeURIComponent(q) : ""))
      .then(r => { setConvs(r.conversations || []); setErr(""); })
      .catch(e => { setConvs([]); setErr(e.message); });
  }, [q]);

  useEffect(() => { loadConvs(); }, [loadConvs]);
  useEffect(() => {
    if (sel) return;                    // أثناء فتح محادثة لا نحدّث القائمة
    const t = setInterval(loadConvs, 15000);
    return () => clearInterval(t);
  }, [sel, loadConvs]);

  const openThread = useCallback((c) => {
    setSel(c); setPick(false); setWin(null); setAssignee(null); setPickMkt("");
    api(base + "/thread/" + c.phone)
      .then(r => { setMsgs(r.messages || []); setWin(r.window_open !== false); setAssignee(r.assignee || null); setPickMkt(r.assignee?.id ? String(r.assignee.id) : ""); onRead?.(); })
      .catch(e => setErr(e.message));
  }, [onRead, base]);

  // v3.4.093 — قائمة المسوّقين للتحويل (الرقم الرسمي — المالك فقط)
  useEffect(() => {
    if (!official || !owner || !sel || mkts !== null) return;
    api(base + "/marketers").then(r => setMkts(r.marketers || [])).catch(() => setMkts([]));
  }, [official, owner, sel, mkts, base]);
  const assign = async (toId) => {
    if (!sel) return;
    setBusy(true); setErr("");
    try {
      const r = await api(base + "/assign", { method: "POST", body: { phone: sel.phone, portal_user_id: toId || null } });
      setAssignee(r.assignee || null); setPickMkt(r.assignee?.id ? String(r.assignee.id) : "");
      setMkts(null);
    } catch (e) { setErr(e.message); }
    setBusy(false);
  };

  useEffect(() => {
    if (!sel) return;
    const t = setInterval(() => {
      api(base + "/thread/" + sel.phone).then(r => { setMsgs(r.messages || []); setWin(r.window_open !== false); setAssignee(r.assignee || null); }).catch(() => {});
    }, 12000);
    return () => clearInterval(t);
  }, [sel]);

  // v3.4.092 — القوالب المعتمدة تُحمَّل عند أول فتح لقائمة القوالب
  useEffect(() => {
    if (!pick || tpls !== null) return;
    api(base + "/templates").then(r => setTpls(r.templates || [])).catch(e => { setTpls([]); setErr(e.message); });
  }, [pick, tpls]);

  const tplSlots = (t) => Math.max(0, ...[...String(t.body_text || "").matchAll(/\{\{(\d+)\}\}/g)].map(m => Number(m[1])));
  const tplPreview = (t, vals) => String(t.body_text || "").replace(/\{\{(\d+)\}\}/g, (_, n) => (vals[Number(n) - 1] || `{{${n}}}`));
  const sendTemplate = async (t) => {
    if (!sel) return;
    const n = tplSlots(t);
    const vals = (tplVals[t.id] || t._vals || []).slice(0, n);
    if (n > 0 && vals.some(v => !String(v || "").trim())) { setErr(`أكمل قيم القالب (${n})`); return; }
    setBusy(true); setErr("");
    try {
      const r = await api(base + "/send-template", { method: "POST", body: { phone: sel.phone, template_id: t.id, variables: vals } });
      setMsgs(m => [...m, r.message]);
      setPick(false);
    } catch (e) { setErr(e.message); }
    setBusy(false);
  };
  // حالة الرسالة الصادرة كما أبلغت بها ميتا (تصل عبر الويبهوك خلال ثوانٍ)
  const STATUS_UI = { sent: ["✓", "#94a3b8", "أُرسلت"], delivered: ["✓✓", "#64748b", "وصلت"], read: ["✓✓", "#2563eb", "قُرئت"], failed: ["✗", "#dc2626", "لم تصل"] };
  const failReason = (m) => String(m.error_code) === "131047"
    ? "لم تصل — مضى أكثر من 24 ساعة على آخر رسالة من العميل؛ يجب فتح المحادثة بقالب معتمد"
    : (m.error_message ? `لم تصل — ${m.error_message}` : "لم تصل");

  // v3.4.090 — فتح محادثة عميل مباشرة قادمًا من «عملائي» (زر واتس بجانب رقمه)
  useEffect(() => {
    if (!initial?.phone) return;
    openThread({ phone: initial.phone, contact_name: initial.contact_name || "" });
    onConsumed?.();
  }, [initial, openThread, onConsumed]);

  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs]);

  const send = async () => {
    const body = text.trim();
    if (!body || !sel) return;
    setBusy(true); setErr("");
    try {
      const r = await api(base + "/reply", { method: "POST", body: { phone: sel.phone, body } });
      setMsgs(m => [...m, r.message]);
      setText("");
    } catch (e) { setErr(e.message); }
    setBusy(false);
  };

  const when = (d) => {
    if (!d) return "";
    const dt = new Date(d), now = new Date();
    const sameDay = dt.toDateString() === now.toDateString();
    return sameDay
      ? dt.toLocaleTimeString("ar-SA", { hour: "2-digit", minute: "2-digit" })
      : dt.toLocaleDateString("ar-SA", { month: "short", day: "numeric" });
  };

  const header = (
    <div style={{ background: "linear-gradient(135deg,#047857,#22c55e)", color: "#fff", borderRadius: 14,
      padding: "12px 14px", marginBottom: 12, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10 }}>
      <div>
        <div style={{ fontSize: 14.5, fontWeight: 800 }}>🟢 {official ? (boxName || "الرقم الرسمي") : "واتس الأعمال"}</div>
        <div style={{ fontSize: 11.5, opacity: 0.92, direction: "ltr", textAlign: "right" }}>
          {official
            ? <>{boxNumber}{owner ? " · كل المحادثات" : " · المحادثات المحوّلة لك"}</>
            : (boxNumber ? <>{boxName ? boxName + " · " : ""}{boxNumber}</> : <>{user.wa_number_name ? user.wa_number_name + " · " : ""}{user.wa_display_number}</>)}{/* v3.4.276 — صندوق رقم إضافي */}
        </div>
      </div>
      {sel && (
        <button onClick={() => { setSel(null); setMsgs([]); loadConvs(); }}
          style={{ background: "rgba(255,255,255,.22)", color: "#fff", border: "none", borderRadius: 10,
            padding: "8px 14px", fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>
          ← المحادثات
        </button>
      )}
    </div>
  );

  if (err && convs !== null && convs.length === 0 && !sel) {
    return (
      <>
        {header}
        <div style={{ background: "#fff", borderRadius: 14, padding: 24, textAlign: "center", color: "#b45309", fontSize: 13 }}>{err}</div>
      </>
    );
  }

  // ── خيط محادثة ──
  if (sel) {
    return (
      <>
        {header}
        <div style={{ background: "#fff", borderRadius: 14, overflow: "hidden", boxShadow: "0 4px 20px rgba(0,0,0,.06)" }}>
          <div style={{ padding: "10px 14px", borderBottom: "1px solid #f1f5f9", background: "#f8fafc" }}>
            <div style={{ fontSize: 13.5, fontWeight: 800, color: "#0f172a" }}>{sel.contact_name || sel.phone}</div>
            <div style={{ fontSize: 11, color: "#94a3b8", direction: "ltr", textAlign: "right" }}>{sel.phone}</div>
            {/* v3.4.093 — التحويل: قائمة المسوّقين + زر تحويل (الرقم الرسمي، المالك فقط) — وشارة «محوّلة إلى» للجميع */}
            {official && owner && (
              <div style={{ display: "flex", gap: 6, alignItems: "center", marginTop: 8, flexWrap: "wrap" }}>
                <select value={pickMkt} onChange={e => setPickMkt(e.target.value)}
                  style={{ flex: "1 1 180px", padding: "7px 9px", border: "1.5px solid #e2e8f0", borderRadius: 8, fontSize: 12.5, fontFamily: "inherit", background: "#fff" }}>
                  <option value="">— اختر المسوّق للتحويل —</option>
                  {(mkts || []).map(m => <option key={m.id} value={m.id}>{m.display_name}{m.assigned_count ? ` (${m.assigned_count})` : ""}</option>)}
                </select>
                <button type="button" disabled={busy || !pickMkt || String(assignee?.id || "") === pickMkt} onClick={() => assign(Number(pickMkt))}
                  style={{ background: busy || !pickMkt ? "#94a3b8" : "#b45309", color: "#fff", border: "none", borderRadius: 8, padding: "7px 14px", fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>
                  ↪ تحويل
                </button>
                {assignee?.id && (
                  <button type="button" disabled={busy} onClick={() => assign(null)} title="إلغاء التحويل"
                    style={{ background: "#fff", color: "#b91c1c", border: "1.5px solid #fecaca", borderRadius: 8, padding: "6px 10px", fontSize: 12, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>
                    ✕ إلغاء
                  </button>
                )}
              </div>
            )}
            {official && assignee?.id && (
              <div style={{ marginTop: 6, fontSize: 11.5, color: "#92400e", background: "#fef3c7", borderRadius: 8, padding: "4px 10px", display: "inline-block" }}>
                ↪ محوّلة إلى: <b>{assignee.name || assignee.id}</b>
              </div>
            )}
          </div>
          <div style={{ padding: 12, maxHeight: "52vh", overflowY: "auto", background: "#f6f7f9" }}>
            {msgs.length === 0 && <div style={{ textAlign: "center", color: "#94a3b8", fontSize: 12.5, padding: 20 }}>لا رسائل بعد — اكتب أول رسالة لهذا العميل من رقمك</div>}
            {msgs.map(m => {
              const out = m.direction === "outbound";
              return (
                <div key={m.id} style={{ display: "flex", justifyContent: out ? "flex-start" : "flex-end", marginBottom: 7 }}>
                  <div style={{ maxWidth: "78%", background: out ? "#dcf8c6" : "#fff", borderRadius: 12,
                    padding: "8px 11px", fontSize: 13.5, color: "#0f172a", lineHeight: 1.6,
                    boxShadow: "0 1px 2px rgba(0,0,0,.08)", whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                    <WaMedia m={m} src={`/api/portal${base}/media/${m.id}?t=${encodeURIComponent(localStorage.getItem(TOKEN_KEY) || "")}`} /> {/* v3.4.091 */}
                    {m.message_type === "template" && <div style={{ fontSize: 10, color: "#0f766e", fontWeight: 800, marginBottom: 2 }}>📋 قالب معتمد{m.template_name ? ` · ${m.template_name}` : ""}</div>}
                    {m.media_id && isPlaceholderBody(m.message_body) ? null : (m.message_body || (m.media_id ? "" : "[" + (m.message_type || "مرفق") + "]"))}
                    {/* v3.4.092 — حالة التسليم كما أبلغت ميتا؛ الفاشلة تُعرض بسببها بدل أن تبدو مُرسلة */}
                    <div style={{ fontSize: 9.5, color: "#94a3b8", marginTop: 3, textAlign: "left", display: "flex", gap: 6, justifyContent: "flex-start", alignItems: "center" }}>
                      <span>{when(m.created_at)}</span>
                      {out && STATUS_UI[m.status] && <span style={{ color: STATUS_UI[m.status][1], fontWeight: 800 }} title={STATUS_UI[m.status][2]}>{STATUS_UI[m.status][0]}</span>}
                    </div>
                    {out && m.status === "failed" && (
                      <div style={{ marginTop: 4, fontSize: 10.5, color: "#b91c1c", background: "#fef2f2", borderRadius: 8, padding: "4px 8px" }}>✗ {failReason(m)}</div>
                    )}
                  </div>
                </div>
              );
            })}
            <div ref={endRef} />
          </div>
          {err && <div style={{ padding: "8px 14px", background: "#fef2f2", color: "#b91c1c", fontSize: 11.5 }}>{err}</div>}
          {/* v3.4.092 — خارج نافذة الـ24 ساعة: النص الحر لا يصل (قاعدة ميتا) — يُفتح بقالب معتمد */}
          {win === false && !pick && (
            <div style={{ padding: "10px 12px", background: "#fffbeb", borderTop: "1px solid #fde68a", fontSize: 12, color: "#92400e", display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
              <span style={{ flex: 1 }}>⏳ مضى أكثر من 24 ساعة على آخر رسالة من العميل — واتساب لا يوصل النص الحر الآن؛ افتح المحادثة بقالب معتمد وسيتاح الرد الحر بعد أن يرد العميل.{onPersonal ? " أو تواصل معه مباشرة من واتسابي." : ""}</span>
              <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>{/* v3.4.178 — خياران تحت بعض */}
                <button type="button" onClick={() => setPick(true)}
                  style={{ background: "#0f766e", color: "#fff", border: "none", borderRadius: 10, padding: "8px 14px", fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>
                  📋 إرسال قالب معتمد
                </button>
                {onPersonal && (
                  <button type="button" onClick={() => {
                    // v3.4.181 — نحمل آخر رسالة نصية من العميل (وقبلها واحدة إن وُجدت) كمسودة يكمل عليها المسوّق
                    const ins = msgs.filter(m => m.direction === "inbound" && m.message_body && !isPlaceholderBody(m.message_body)).slice(-2);
                    const draft = ins.length ? `بخصوص رسالتك على رقم ${boxName || "الشركة"} (${boxNumber || ""}):\n${ins.map(m => "«" + String(m.message_body).trim() + "»").join("\n")}\n\n` : "";
                    onPersonal({ phone: sel.phone, name: sel.contact_name || "", draft });
                  }} title="فتح العميل في واتسابك الشخصي داخل التطبيق مع رسالته الأخيرة"
                    style={{ background: "#2563eb", color: "#fff", border: "none", borderRadius: 10, padding: "8px 14px", fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit", display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 6, boxShadow: "0 2px 6px rgba(37,99,235,.35)" }}>
                    <WaLogo size={16} /> التواصل من واتسابي
                  </button>
                )}
              </div>
            </div>
          )}
          {pick && (
            <div style={{ padding: 12, background: "#f8fafc", borderTop: "1px solid #e2e8f0" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                <span style={{ fontSize: 13, fontWeight: 800, color: "#0f172a" }}>📋 القوالب المعتمدة</span>
                <button type="button" onClick={() => setPick(false)} style={{ background: "none", border: "none", color: "#64748b", fontSize: 12, cursor: "pointer", fontFamily: "inherit" }}>إغلاق ✕</button>
              </div>
              {tpls === null && <div style={{ color: "#94a3b8", fontSize: 12 }}>جارٍ التحميل…</div>}
              {tpls !== null && tpls.length === 0 && <div style={{ color: "#b45309", fontSize: 12 }}>لا توجد قوالب معتمدة من ميتا بعد — تُضاف من صفحة التواصل المؤسسي في النظام</div>}
              {(tpls || []).map(t => {
                const n = tplSlots(t);
                const vals = tplVals[t.id] || Array.from({ length: n }, (_, i) => (i === 0 ? (sel.contact_name || "") : ""));
                return (
                  <div key={t.id} style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, padding: 10, marginBottom: 8 }}>
                    <div style={{ fontSize: 12.5, fontWeight: 800, color: "#0f172a", marginBottom: 4 }}>{t.name_ar || t.name}</div>
                    <div style={{ fontSize: 12, color: "#475569", whiteSpace: "pre-wrap", lineHeight: 1.6 }}>{tplPreview(t, vals)}</div>
                    {n > 0 && (
                      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 8 }}>
                        {Array.from({ length: n }, (_, i) => (
                          <input key={i} value={vals[i] || ""} placeholder={`القيمة ${i + 1}`}
                            onChange={e => { const v = [...vals]; v[i] = e.target.value; setTplVals(p => ({ ...p, [t.id]: v })); }}
                            style={{ flex: "1 1 120px", padding: "7px 9px", border: "1.5px solid #e2e8f0", borderRadius: 8, fontSize: 12.5, fontFamily: "inherit" }} />
                        ))}
                      </div>
                    )}
                    <button type="button" disabled={busy} onClick={() => { if (!tplVals[t.id]) setTplVals(p => ({ ...p, [t.id]: vals })); sendTemplate({ ...t, _vals: vals }); }}
                      style={{ marginTop: 8, background: busy ? "#94a3b8" : "#059669", color: "#fff", border: "none", borderRadius: 8, padding: "7px 14px", fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>
                      {busy ? "…" : "إرسال هذا القالب"}
                    </button>
                  </div>
                );
              })}
            </div>
          )}
          <div style={{ padding: 10, borderTop: "1px solid #f1f5f9", background: "#fff" }}>{/* v3.4.188 — النص أعلى، والمرفقات والإرسال أسفله */}
            {/* v3.4.094 — مرفقات: صورة / ملف / تسجيل صوتي */}
            <input ref={imgRef} type="file" accept="image/jpeg,image/png" hidden onChange={e => sendFile(e.target.files?.[0], "image")} />
            <input ref={fileRef} type="file" hidden onChange={e => sendFile(e.target.files?.[0], "document")} />
            <textarea value={text} onChange={e => setText(e.target.value)} disabled={win === false || rec === "recording"} rows={2}
              onKeyDown={e => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); } }}
              placeholder={win === false ? "الرد الحر يتاح بعد أن يرد العميل" : "اكتب ردًا… (Enter للإرسال، Shift+Enter لسطر جديد)"}
              style={{ width: "100%", boxSizing: "border-box", padding: "11px 12px", border: "1.5px solid #e2e8f0", borderRadius: 10, fontSize: 14, fontFamily: "inherit", outline: "none", background: win === false ? "#f8fafc" : "#fff", resize: "vertical", minHeight: 52 }} />
            <div style={{ display: "flex", gap: 6, alignItems: "center", marginTop: 8, flexWrap: "wrap" }}>
            {rec === "recording" ? (
              <>
                <button type="button" onClick={stopVoice} title="إيقاف وإرسال"
                  style={{ background: "#dc2626", color: "#fff", border: "none", borderRadius: 999, height: 42, padding: "0 14px", fontSize: 13, fontWeight: 800, cursor: "pointer", fontFamily: "inherit", animation: "portalPulse 1.2s ease-in-out infinite", direction: "ltr" }}>
                  ⏹ {String(Math.floor(recSec / 60)).padStart(2, "0")}:{String(recSec % 60).padStart(2, "0")}
                </button>
                <button type="button" onClick={cancelVoice} title="إلغاء التسجيل"
                  style={{ background: "#fff", color: "#64748b", border: "1.5px solid #e2e8f0", borderRadius: 999, width: 42, height: 42, fontSize: 16, cursor: "pointer" }}>✕</button>
                <span style={{ flex: 1, fontSize: 12.5, color: "#dc2626", fontWeight: 700 }}>● جارٍ التسجيل… اضغط ⏹ للإرسال</span>
              </>
            ) : (
              <>
                {[["🎙", "تسجيل صوتي", startVoice], ["🖼", "إرسال صورة", () => imgRef.current?.click()], ["📎", "إرسال ملف", () => fileRef.current?.click()]].map(([ic, t, fn]) => (
                  <button key={t} type="button" onClick={fn} title={t} disabled={busy || win === false}
                    style={{ background: busy || win === false ? "#f1f5f9" : "#ecfdf5", color: "#065f46", border: "1.5px solid " + (busy || win === false ? "#e2e8f0" : "#a7f3d0"), borderRadius: 999, width: 42, height: 42, fontSize: 17, cursor: busy || win === false ? "default" : "pointer", flexShrink: 0 }}>
                    {ic}
                  </button>
                ))}
                <span style={{ flex: 1 }} />
              </>
            )}
            {/* v3.4.188 — إضافة جهة الاتصال إلى عملائي (يفتح نموذج التسجيل معبّأً بالرقم والاسم) */}
            {onAddClient && sel && (
              <button type="button" onClick={() => onAddClient({ phone: sel.phone, name: sel.contact_name || "" })} title="إضافة هذا الرقم إلى عملائي"
                style={{ background: "#0f766e", color: "#fff", border: "none", borderRadius: 10, height: 42, padding: "0 12px", fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>
                ➕ إضافة لعملائي
              </button>
            )}
            <button onClick={send} disabled={busy || !text.trim() || win === false}
              style={{ background: busy || !text.trim() || win === false ? "#94a3b8" : "#059669", color: "#fff", border: "none",
                borderRadius: 10, height: 42, padding: "0 18px", fontSize: 14, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>
              {busy ? "…" : "إرسال"}
            </button>
            </div>
          </div>
        </div>
      </>
    );
  }

  // ── قائمة المحادثات ──
  return (
    <>
      {header}
      <input value={q} onChange={e => setQ(e.target.value)} placeholder="🔍 بحث باسم أو رقم…"
        style={{ ...inputS, marginBottom: 10 }} />
      <div style={{ background: "#fff", borderRadius: 14, overflow: "hidden", boxShadow: "0 4px 20px rgba(0,0,0,.06)" }}>
        {convs === null && <div style={{ padding: 24, textAlign: "center", color: "#94a3b8", fontSize: 13 }}>جارٍ التحميل…</div>}
        {convs !== null && convs.length === 0 && (
          <div style={{ padding: 26, textAlign: "center", color: "#94a3b8", fontSize: 13 }}>لا توجد محادثات على رقمك بعد</div>
        )}
        {(convs || []).map(c => (
          <div key={c.phone} onClick={() => openThread(c)}
            style={{ padding: "11px 14px", borderBottom: "1px solid #f1f5f9", cursor: "pointer", display: "flex", gap: 10, alignItems: "center" }}>
            <div style={{ width: 38, height: 38, borderRadius: "50%", background: "#dcfce7", color: "#166534",
              display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: 15, flexShrink: 0 }}>
              {(c.contact_name || c.phone || "?").trim().charAt(0)}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
                <span style={{ fontSize: 13.5, fontWeight: 800, color: "#0f172a", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                  {c.contact_name || c.phone}
                </span>
                <span style={{ fontSize: 10.5, color: "#94a3b8", flexShrink: 0 }}>
                  {official && c.assignee_name && <span style={{ color: "#b45309", fontWeight: 800, marginInlineEnd: 6 }}>↪ {c.assignee_name}</span>}{/* v3.4.093 */}
                  {when(c.last_at)}
                </span>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", gap: 8, marginTop: 2 }}>
                <span style={{ fontSize: 11.5, color: "#64748b", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                  {c.last_dir === "outbound" ? "↩ " : ""}{c.last_body || ""}
                </span>
                {c.unread > 0 && (
                  <span style={{ background: "#22c55e", color: "#fff", borderRadius: 999, minWidth: 19, height: 19,
                    fontSize: 10.5, fontWeight: 800, display: "flex", alignItems: "center", justifyContent: "center", padding: "0 6px", flexShrink: 0 }}>
                    {c.unread}
                  </span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

// v3.4.103 — واتساب المسوّق الشخصي: يُربط بالـ QR من الجوال (كواتساب ويب) ويُحادَث منه العميل داخل التطبيق،
// وكل الرسائل تُحفظ في قاعدة البيانات. الزر الأزرق في «عملائي» يفتح محادثة العميل هنا مباشرة.
function PortalPersonalWa({ user, onRead, initial, onConsumed }) {
  const [st, setSt] = useState(null);        // { status, phone, qr } — none | qr_pending | initializing | restoring | connected | disconnected | error
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [convs, setConvs] = useState(null);
  const [q, setQ] = useState("");
  const [sel, setSel] = useState(null);      // { phone, contact_name }
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");
  const [confirmUnlink, setConfirmUnlink] = useState(false);
  const endRef = useRef(null);
  const connected = st?.status === "connected";

  const refreshStatus = useCallback(() => api("/pwa/status").then(r => { setSt(r); return r; }).catch(e => { setSt({ status: "error", error: e.message }); return null; }), []);
  useEffect(() => { refreshStatus(); }, [refreshStatus]);
  // أثناء الربط: استطلاع سريع (QR يتجدد كل ~20 ثانية) — بعد الاتصال: كل 30 ثانية
  useEffect(() => {
    const ms = connected ? 30000 : (st && ["qr_pending", "initializing", "restoring"].includes(st.status) ? 2500 : 15000);
    const t = setInterval(refreshStatus, ms);
    return () => clearInterval(t);
  }, [st?.status, connected, refreshStatus]);

  // v3.4.106 — طريقتا ربط: رمز اقتران برقم الهاتف (من الجوال نفسه بلا كاميرا) أو QR (يُمسح من جهاز آخر)
  const [mode, setMode] = useState("code"); // code | qr
  const [pairPhone, setPairPhone] = useState(user?.phone || "");
  const link = async (m = mode) => {
    setBusy(true); setErr("");
    try {
      const r = await api("/pwa/link", { method: "POST", body: m === "code" ? { method: "code", phone: pairPhone } : {} });
      setSt(s => ({ ...(s || {}), ...r }));
    } catch (e) { setErr(e.message); }
    setBusy(false);
  };
  const requestCode = async () => {
    setBusy(true); setErr("");
    try { const r = await api("/pwa/pairing-code", { method: "POST", body: { phone: pairPhone } }); setSt(s => ({ ...(s || {}), ...r })); }
    catch (e) { setErr(e.message); }
    setBusy(false);
  };
  const shareQr = async () => {
    if (!st?.qr) return;
    try {
      const blob = await (await fetch(st.qr)).blob();
      const file = new File([blob], "whatsapp-qr.png", { type: "image/png" });
      if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) { await navigator.share({ files: [file], title: "رمز ربط واتساب" }); return; }
      const a = document.createElement("a"); a.href = st.qr; a.download = "whatsapp-qr.png"; a.click();
    } catch { /* ألغى المستخدم */ }
  };
  const fmtCode = (c) => { const x = String(c || "").replace(/-/g, ""); return x.length === 8 ? x.slice(0, 4) + "-" + x.slice(4) : x; };
  const unlink = async () => {
    setBusy(true); setErr(""); setConfirmUnlink(false);
    try { await api("/pwa/unlink", { method: "POST" }); setSt({ status: "none" }); setSel(null); setConvs(null); }
    catch (e) { setErr(e.message); }
    setBusy(false);
  };

  const loadConvs = useCallback(() => {
    if (!connected) return;
    api("/pwa/conversations" + (q ? "?q=" + encodeURIComponent(q) : ""))
      .then(r => { setConvs(r.conversations || []); setErr(""); })
      .catch(e => { setConvs([]); setErr(e.message); });
  }, [q, connected]);
  useEffect(() => { loadConvs(); }, [loadConvs]);
  useEffect(() => {
    if (sel || !connected) return;
    const t = setInterval(loadConvs, 15000);
    return () => clearInterval(t);
  }, [sel, connected, loadConvs]);

  const openThread = useCallback((c) => {
    setSel(c); setErr("");
    api("/pwa/thread/" + c.phone)
      .then(r => { setMsgs(r.messages || []); if (r.contact_name && !c.contact_name) setSel(s => (s && s.phone === c.phone ? { ...s, contact_name: r.contact_name } : s)); onRead?.(); })
      .catch(e => setErr(e.message));
  }, [onRead]);
  useEffect(() => {
    if (!sel || !connected) return;
    // v3.4.109 — كل 6 ثوانٍ، مع الإبقاء على الرسائل المحلية قيد الإرسال/الفاشلة حتى لا تختفي مؤقتًا
    const t = setInterval(() => { api("/pwa/thread/" + sel.phone).then(r => setMsgs(prev => [...(r.messages || []), ...prev.filter(x => x.pending || x.failed)])).catch(() => {}); }, 6000);
    return () => clearInterval(t);
  }, [sel, connected]);

  // قادمًا من الزر الأزرق في «عملائي»: تُفتح المحادثة فور توفر الاتصال (وإلا تبقى شاشة الربط أولًا)
  useEffect(() => {
    if (!initial?.phone || !connected) return;
    openThread({ phone: initial.phone, contact_name: initial.contact_name || "" });
    if (initial.draft) setText(initial.draft); // v3.4.181 — رسالة العميل من رقم الأعمال تُحمل كمسودة
    onConsumed?.();
  }, [initial, connected, openThread, onConsumed]);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs]);

  // v3.4.109 — إرسال متفائل: الفقاعة تظهر فورًا بحالة «جارٍ الإرسال» والحقل يُفرَّغ، ثم تُؤكَّد أو تُعلَّم فاشلة مع إعادة محاولة.
  // إن انقطع الطلب في المتصفح (iOS «Load failed» عند تبديل التطبيقات) نتحقق من الخيط: إن وصلت الرسالة للقاعدة تُعتبر مُرسلة.
  const sendBody = async (body, tmpId) => {
    const id = tmpId || ("tmp_" + Date.now() + "_" + Math.random().toString(36).slice(2, 6));
    const optimistic = { id, direction: "outbound", message_body: body, message_type: "chat", has_media: false, created_at: new Date().toISOString(), pending: true };
    setMsgs(m => tmpId ? m.map(x => x.id === tmpId ? optimistic : x) : [...m, optimistic]);
    setErr("");
    try {
      const r = await api("/pwa/send", { method: "POST", body: { phone: sel.phone, body, contact_name: sel.contact_name || "" } });
      setMsgs(m => m.map(x => x.id === id ? r.message : x));
    } catch (e) {
      let delivered = false;
      if (/load failed|failed to fetch|network/i.test(String(e.message))) {
        try {
          const r = await api("/pwa/thread/" + sel.phone);
          const cut = Date.now() - 3 * 60 * 1000;
          delivered = (r.messages || []).some(x => x.direction === "outbound" && x.message_body === body && new Date(x.created_at).getTime() > cut);
          if (delivered) setMsgs(prev => [...(r.messages || []), ...prev.filter(x => (x.pending || x.failed) && x.id !== id)]);
        } catch { /* تبقى فاشلة */ }
      }
      if (!delivered) {
        setMsgs(m => m.map(x => x.id === id ? { ...x, pending: false, failed: true, error: e.message } : x));
        setErr(e.message);
      }
    }
  };
  const send = async () => {
    const body = text.trim();
    if (!body || !sel) return;
    setText("");
    await sendBody(body);
  };
  const retry = (m) => { if (m.failed) sendBody(m.message_body, m.id); };
  const when = (d) => {
    if (!d) return "";
    const dt = new Date(d), now = new Date();
    return dt.toDateString() === now.toDateString()
      ? dt.toLocaleTimeString("ar-SA", { hour: "2-digit", minute: "2-digit" })
      : dt.toLocaleDateString("ar-SA", { month: "short", day: "numeric" });
  };
  const fmtPhone = (p) => (p ? "+" + String(p).replace(/^\+/, "") : "");

  const header = (
    <div style={{ background: "linear-gradient(135deg,#1d4ed8,#3b82f6)", color: "#fff", borderRadius: 14,
      padding: "12px 14px", marginBottom: 12, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10 }}>
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 14.5, fontWeight: 800, display: "flex", alignItems: "center", gap: 6 }}><WaLogo size={17} /> واتسابي الشخصي</div>
        <div style={{ fontSize: 11.5, opacity: 0.92, direction: "ltr", textAlign: "right" }}>
          {connected ? <>{fmtPhone(st.phone)} · <span style={{ direction: "rtl" }}>متصل ✓</span></> : "غير مربوط"}
        </div>
      </div>
      {sel ? (
        <button onClick={() => { setSel(null); setMsgs([]); loadConvs(); }}
          style={{ background: "rgba(255,255,255,.22)", color: "#fff", border: "none", borderRadius: 10, padding: "8px 14px", fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit", flexShrink: 0 }}>
          ← المحادثات
        </button>
      ) : connected ? (
        <button onClick={() => setConfirmUnlink(true)} title="فصل الرقم عن التطبيق"
          style={{ background: "rgba(255,255,255,.18)", color: "#fff", border: "1px solid rgba(255,255,255,.35)", borderRadius: 10, padding: "7px 12px", fontSize: 12, fontWeight: 800, cursor: "pointer", fontFamily: "inherit", flexShrink: 0 }}>
          فصل
        </button>
      ) : null}
    </div>
  );

  // ── شاشة الربط ──
  if (!connected) {
    const s = st?.status;
    const waiting = s === "initializing" || s === "restoring";
    return (
      <>
        {header}
        <div style={{ background: "#fff", borderRadius: 16, padding: "22px 18px", boxShadow: "0 4px 20px rgba(0,0,0,.06)", textAlign: "center" }}>
          {st === null && <div style={{ color: "#94a3b8", fontSize: 13 }}>جارٍ التحقق من الحالة…</div>}
          {s === "error" && <div style={{ color: "#b45309", fontSize: 13 }}>{st.error || "تعذر الوصول إلى سيرفر واتساب"}</div>}
          {(s === "none" || s === "disconnected") && (
            <>
              <div style={{ width: 64, height: 64, borderRadius: "50%", background: "#2563eb", margin: "0 auto 12px", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 8px 22px rgba(37,99,235,.35)" }}><WaLogo size={34} /></div>
              <div style={{ fontSize: 16, fontWeight: 800, color: "#0f172a", marginBottom: 6 }}>اربط واتسابك الشخصي بالتطبيق</div>
              <div style={{ fontSize: 12.5, color: "#64748b", lineHeight: 1.8, marginBottom: 14 }}>
                تراسل عملاءك من رقمك الشخصي داخل التطبيق، وتُحفظ كل المحادثات في النظام تلقائيًا.
                {s === "disconnected" && <div style={{ color: "#b45309", marginTop: 4 }}>انقطع الاتصال بجوالك — أعد الربط.</div>}
              </div>
              {/* v3.4.106 — اختيار طريقة الربط */}
              <div style={{ display: "flex", gap: 6, background: "#f1f5f9", borderRadius: 12, padding: 4, marginBottom: 12 }}>
                {[["code", "📱 برقم الجوال (من هذا الجوال)"], ["qr", "🔳 بمسح QR (من جهاز آخر)"]].map(([k, l]) => (
                  <button key={k} type="button" onClick={() => setMode(k)}
                    style={{ flex: 1, border: "none", borderRadius: 9, padding: "9px 6px", fontSize: 12, fontWeight: 800, cursor: "pointer", fontFamily: "inherit",
                      background: mode === k ? "#fff" : "transparent", color: mode === k ? "#1d4ed8" : "#64748b", boxShadow: mode === k ? "0 2px 8px rgba(15,23,42,.10)" : "none" }}>{l}</button>
                ))}
              </div>
              {mode === "code" ? (
                <>
                  <div style={{ fontSize: 12, color: "#475569", textAlign: "right", marginBottom: 6 }}>رقم واتساب الذي تريد ربطه</div>
                  <input value={pairPhone} onChange={e => setPairPhone(e.target.value)} placeholder="05xxxxxxxx" inputMode="tel"
                    style={{ ...inputS, direction: "ltr", textAlign: "left", marginBottom: 10, fontSize: 16, letterSpacing: 1 }} />
                  <button type="button" onClick={() => link("code")} disabled={busy || String(pairPhone).replace(/\D/g, "").length < 9}
                    style={{ ...btnPrimary, background: busy ? "#94a3b8" : "linear-gradient(135deg,#1d4ed8,#3b82f6)" }}>
                    {busy ? "…" : "🔗 احصل على رمز الربط"}
                  </button>
                  <div style={{ fontSize: 11.5, color: "#94a3b8", marginTop: 8, lineHeight: 1.7 }}>ستحصل على رمز من 8 خانات تدخله في واتساب: الأجهزة المرتبطة ← ربط جهاز ← <b>الربط برقم الهاتف بدلًا من ذلك</b></div>
                </>
              ) : (
                <>
                  <button type="button" onClick={() => link("qr")} disabled={busy} style={{ ...btnPrimary, background: busy ? "#94a3b8" : "linear-gradient(135deg,#1d4ed8,#3b82f6)" }}>
                    {busy ? "…" : "🔗 ابدأ الربط — إظهار رمز QR"}
                  </button>
                  <div style={{ fontSize: 11.5, color: "#94a3b8", marginTop: 8, lineHeight: 1.7 }}>افتح هذه الصفحة على جهاز آخر (حاسب/جهاز لوحي) أو شارك صورة الرمز، ثم امسحه بكاميرا واتساب جوالك</div>
                </>
              )}
            </>
          )}
          {(s === "qr_pending" || waiting) && (
            <>
              {(st.pairing_code || (st.pairing_phone && s === "qr_pending")) && mode === "code" ? (
                <>
                  <div style={{ fontSize: 15.5, fontWeight: 800, color: "#0f172a", marginBottom: 4 }}>أدخل هذا الرمز في واتساب جوالك</div>
                  <div style={{ fontSize: 12, color: "#64748b", lineHeight: 1.8, marginBottom: 12 }}>
                    واتساب ← <b>⋮</b> أو <b>الإعدادات</b> ← <b>الأجهزة المرتبطة</b> ← <b>ربط جهاز</b> ← <b>الربط برقم الهاتف بدلًا من ذلك</b>
                  </div>
                  <div style={{ margin: "0 auto 10px", borderRadius: 16, border: "2px solid #dbeafe", background: "#eff6ff", padding: "18px 12px", direction: "ltr" }}>
                    {st.pairing_code
                      ? <div style={{ fontSize: 34, fontWeight: 900, letterSpacing: 6, color: "#1d4ed8", fontFamily: "ui-monospace, Menlo, Consolas, monospace" }}>{fmtCode(st.pairing_code)}</div>
                      : <div style={{ color: "#64748b", fontSize: 12.5 }}>
                          <div style={{ width: 30, height: 30, border: "3px solid #bfdbfe", borderTopColor: "#2563eb", borderRadius: "50%", margin: "0 auto 10px", animation: "pwaSpin .9s linear infinite" }} />
                          جارٍ إصدار الرمز لرقم +{st.pairing_phone}…
                        </div>}
                  </div>
                  <div style={{ display: "flex", gap: 8, justifyContent: "center", flexWrap: "wrap" }}>
                    <button type="button" onClick={requestCode} disabled={busy}
                      style={{ background: "#fff", color: "#1d4ed8", border: "1.5px solid #bfdbfe", borderRadius: 10, padding: "8px 14px", fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>
                      🔄 رمز جديد
                    </button>
                    <button type="button" onClick={() => setMode("qr")}
                      style={{ background: "#fff", color: "#64748b", border: "1.5px solid #e2e8f0", borderRadius: 10, padding: "8px 14px", fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>
                      🔳 أو بمسح QR
                    </button>
                  </div>
                  <div style={{ fontSize: 11.5, color: "#94a3b8", marginTop: 10 }}>بعد إدخال الرمز انتظر ثوانٍ حتى يظهر «متصل»</div>
                </>
              ) : (
                <>
                  <div style={{ fontSize: 15.5, fontWeight: 800, color: "#0f172a", marginBottom: 4 }}>امسح الرمز من واتساب جوالك</div>
                  <div style={{ fontSize: 12, color: "#64748b", lineHeight: 1.8, marginBottom: 12 }}>
                    واتساب ← <b>⋮</b> أو <b>الإعدادات</b> ← <b>الأجهزة المرتبطة</b> ← <b>ربط جهاز</b> ← وجّه الكاميرا للرمز
                  </div>
                  <div style={{ width: 260, height: 260, margin: "0 auto 12px", borderRadius: 16, border: "2px solid #dbeafe", background: "#f8fafc", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
                    {s === "qr_pending" && st.qr
                      ? <img src={st.qr} alt="QR" style={{ width: 250, height: 250, display: "block" }} />
                      : <div style={{ color: "#64748b", fontSize: 12.5, padding: 20 }}>
                          <div style={{ width: 30, height: 30, border: "3px solid #bfdbfe", borderTopColor: "#2563eb", borderRadius: "50%", margin: "0 auto 10px", animation: "pwaSpin .9s linear infinite" }} />
                          {s === "restoring" ? "جارٍ إعادة تشغيل جلستك…" : "جارٍ تجهيز الرمز… (قد يستغرق حتى دقيقة)"}
                        </div>}
                  </div>
                  <div style={{ display: "flex", gap: 8, justifyContent: "center", flexWrap: "wrap" }}>
                    {st.qr && (
                      <button type="button" onClick={shareQr}
                        style={{ background: "#fff", color: "#1d4ed8", border: "1.5px solid #bfdbfe", borderRadius: 10, padding: "8px 14px", fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>
                        📤 مشاركة / حفظ صورة الرمز
                      </button>
                    )}
                    <button type="button" onClick={() => { setMode("code"); if (!st.pairing_code) requestCode(); }} disabled={busy}
                      style={{ background: "#fff", color: "#64748b", border: "1.5px solid #e2e8f0", borderRadius: 10, padding: "8px 14px", fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>
                      📱 أو برقم الجوال بدل المسح
                    </button>
                  </div>
                  <div style={{ fontSize: 11.5, color: "#94a3b8", marginTop: 10 }}>يتجدّد الرمز تلقائيًا · بعد المسح انتظر ثوانٍ حتى يظهر «متصل»</div>
                </>
              )}
              <style>{`@keyframes pwaSpin{to{transform:rotate(360deg)}}`}</style>
            </>
          )}
          {err && <div style={{ marginTop: 12, background: "#fef2f2", color: "#b91c1c", fontSize: 12, borderRadius: 10, padding: "8px 12px" }}>{err}</div>}
          <div style={{ marginTop: 16, fontSize: 11, color: "#94a3b8", lineHeight: 1.7, textAlign: "right", background: "#f8fafc", borderRadius: 10, padding: "8px 12px" }}>
            ℹ️ الربط يعمل كواتساب ويب: يبقى جوالك متصلًا بالإنترنت. الرسائل النصية تُرسل وتُستقبل من هنا، أما الصور والملفات فتظهر على الجوال فقط حاليًا.
          </div>
        </div>
      </>
    );
  }

  const unlinkDlg = confirmUnlink && createPortal( /* v3.4.168 */
    <div style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,.45)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={() => setConfirmUnlink(false)}>
      <div onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 16, padding: 20, maxWidth: 340, width: "100%", boxShadow: "0 20px 50px rgba(0,0,0,.25)" }}>
        <div style={{ fontSize: 15, fontWeight: 800, color: "#0f172a", marginBottom: 6 }}>فصل واتسابك الشخصي؟</div>
        <div style={{ fontSize: 12.5, color: "#64748b", lineHeight: 1.7, marginBottom: 14 }}>سيُفصل الجهاز المرتبط من واتساب جوالك ويتوقف الإرسال من التطبيق. المحادثات المحفوظة تبقى في النظام.</div>
        <div style={{ display: "flex", gap: 8 }}>
          <button type="button" onClick={unlink} style={{ flex: 1, background: "#dc2626", color: "#fff", border: "none", borderRadius: 10, padding: "10px", fontSize: 13, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>فصل</button>
          <button type="button" onClick={() => setConfirmUnlink(false)} style={{ flex: 1, background: "#f1f5f9", color: "#0f172a", border: "none", borderRadius: 10, padding: "10px", fontSize: 13, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>إلغاء</button>
        </div>
      </div>
    </div>
  , document.body);

  // ── خيط محادثة ──
  if (sel) {
    return (
      <>
        {header}{unlinkDlg}
        <div style={{ background: "#fff", borderRadius: 14, overflow: "hidden", boxShadow: "0 4px 20px rgba(0,0,0,.06)" }}>
          <div style={{ padding: "10px 14px", borderBottom: "1px solid #f1f5f9", background: "#f8fafc" }}>
            <div style={{ fontSize: 13.5, fontWeight: 800, color: "#0f172a" }}>{sel.contact_name || sel.phone}</div>
            <div style={{ fontSize: 11, color: "#94a3b8", direction: "ltr", textAlign: "right" }}>{fmtPhone(sel.phone)}</div>
          </div>
          <div style={{ padding: 12, maxHeight: "52vh", overflowY: "auto", background: "#eef2ff" }}>
            {msgs.length === 0 && <div style={{ textAlign: "center", color: "#94a3b8", fontSize: 12.5, padding: 20 }}>لا رسائل محفوظة بعد — اكتب أول رسالة لهذا العميل من رقمك الشخصي</div>}
            {msgs.map(m => {
              const out = m.direction === "outbound";
              return (
                <div key={m.id} style={{ display: "flex", justifyContent: out ? "flex-start" : "flex-end", marginBottom: 7 }}>
                  <div onClick={() => retry(m)} style={{ maxWidth: "78%", background: m.failed ? "#fee2e2" : out ? "#dbeafe" : "#fff", borderRadius: 12, padding: "8px 11px", fontSize: 13.5, color: "#0f172a", lineHeight: 1.6,
                    boxShadow: "0 1px 2px rgba(0,0,0,.08)", whiteSpace: "pre-wrap", wordBreak: "break-word", opacity: m.pending ? .7 : 1, cursor: m.failed ? "pointer" : "default" }}>
                    {m.has_media && <div style={{ fontSize: 11, color: "#1d4ed8", fontWeight: 800, marginBottom: 2 }}>📎 {m.message_type === "image" ? "صورة" : m.message_type === "video" ? "فيديو" : m.message_type === "ptt" || m.message_type === "audio" ? "رسالة صوتية" : "مرفق"} — يظهر على الجوال</div>}
                    {m.message_body}
                    {/* v3.4.109 — حالة الإرسال: 🕓 جارٍ · ✓ أُرسلت · ✗ فشلت (اضغط لإعادة المحاولة) */}
                    <div style={{ fontSize: 9.5, color: m.failed ? "#b91c1c" : "#94a3b8", marginTop: 3, textAlign: "left", display: "flex", gap: 6, alignItems: "center" }}>
                      <span>{when(m.created_at)}</span>
                      {out && (m.pending ? <span title="جارٍ الإرسال">🕓</span> : m.failed ? <span style={{ fontWeight: 800 }}>✗ لم تُرسل — اضغط لإعادة المحاولة</span> : <span style={{ color: "#64748b", fontWeight: 800 }}>✓</span>)}
                    </div>
                  </div>
                </div>
              );
            })}
            <div ref={endRef} />
          </div>
          {err && <div style={{ padding: "8px 14px", background: "#fef2f2", color: "#b91c1c", fontSize: 11.5 }}>{err}</div>}
          <div style={{ display: "flex", gap: 6, padding: 10, borderTop: "1px solid #f1f5f9", background: "#fff", alignItems: "center" }}>
            <input value={text} onChange={e => setText(e.target.value)}
              onKeyDown={e => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); } }}
              placeholder="اكتب رسالة من رقمك الشخصي…"
              style={{ flex: 1, padding: "11px 12px", border: "1.5px solid #e2e8f0", borderRadius: 10, fontSize: 14, fontFamily: "inherit", outline: "none", background: "#fff" }} />
            <button onClick={send} disabled={busy || !text.trim()}
              style={{ background: busy || !text.trim() ? "#94a3b8" : "#2563eb", color: "#fff", border: "none", borderRadius: 10, padding: "0 18px", height: 42, fontSize: 14, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>
              {busy ? "…" : "إرسال"}
            </button>
          </div>
        </div>
      </>
    );
  }

  // ── قائمة المحادثات ──
  return (
    <>
      {header}{unlinkDlg}
      <input value={q} onChange={e => setQ(e.target.value)} placeholder="🔍 بحث باسم أو رقم…" style={{ ...inputS, marginBottom: 10 }} />
      {err && <div style={{ marginBottom: 10, background: "#fef2f2", color: "#b91c1c", fontSize: 12, borderRadius: 10, padding: "8px 12px" }}>{err}</div>}
      <div style={{ background: "#fff", borderRadius: 14, overflow: "hidden", boxShadow: "0 4px 20px rgba(0,0,0,.06)" }}>
        {convs === null && <div style={{ padding: 24, textAlign: "center", color: "#94a3b8", fontSize: 13 }}>جارٍ التحميل…</div>}
        {convs !== null && convs.length === 0 && (
          <div style={{ padding: 26, textAlign: "center", color: "#94a3b8", fontSize: 13, lineHeight: 1.8 }}>
            لا توجد محادثات محفوظة بعد<br />
            <span style={{ fontSize: 12 }}>تُحفظ الرسائل الجديدة (الواردة والصادرة) تلقائيًا من لحظة الربط · افتح عميلًا من «عملائي» بالزر الأزرق لبدء محادثة</span>
          </div>
        )}
        {(convs || []).map(c => (
          <div key={c.phone} onClick={() => openThread(c)}
            style={{ padding: "11px 14px", borderBottom: "1px solid #f1f5f9", cursor: "pointer", display: "flex", gap: 10, alignItems: "center" }}>
            <div style={{ width: 38, height: 38, borderRadius: "50%", background: "#dbeafe", color: "#1e40af", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: 15, flexShrink: 0 }}>
              {(c.contact_name || c.phone || "?").trim().charAt(0)}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
                <span style={{ fontSize: 13.5, fontWeight: 800, color: "#0f172a", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{c.contact_name || fmtPhone(c.phone)}</span>
                <span style={{ fontSize: 10.5, color: "#94a3b8", flexShrink: 0 }}>{when(c.last_at)}</span>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", gap: 8, marginTop: 2 }}>
                <span style={{ fontSize: 11.5, color: "#64748b", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{c.last_dir === "outbound" ? "↩ " : ""}{c.last_body || ""}</span>
                {c.unread > 0 && (
                  <span style={{ background: "#2563eb", color: "#fff", borderRadius: 999, minWidth: 19, height: 19, fontSize: 10.5, fontWeight: 800, display: "flex", alignItems: "center", justifyContent: "center", padding: "0 6px", flexShrink: 0 }}>{c.unread}</span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

function PortalChat({ user, onBack, onRead }) {
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const boxRef = React.useRef(null);
  const lastId = msgs.length ? msgs[msgs.length - 1].id : 0;
  const load = useCallback(async (since) => {
    try {
      const r = await api(`/chat?since=${since || 0}`);
      if (r.messages?.length) setMsgs(m => since ? [...m, ...r.messages] : r.messages);
      onRead && onRead();
    } catch {}
  }, [onRead]);
  useEffect(() => { load(0); }, [load]);
  useEffect(() => {
    const t = setInterval(() => load(lastId), 5000);
    return () => clearInterval(t);
  }, [lastId, load]);
  useEffect(() => { if (boxRef.current) boxRef.current.scrollTop = boxRef.current.scrollHeight; }, [msgs.length]);
  const send = async () => {
    const b = text.trim();
    if (!b || busy) return;
    setBusy(true);
    try {
      const r = await api("/chat", { method: "POST", body: { body: b } });
      setMsgs(m => [...m, r.message]);
      setText("");
    } catch {}
    setBusy(false);
  };
  // v3.3.808 — رسالة صوتية: ضغطة تبدأ التسجيل، ضغطة أخرى توقفه وترسله
  const [rec, setRec] = useState("idle"); // idle | recording | sending
  const [recSec, setRecSec] = useState(0);
  const recRef = React.useRef({});
  const startVoice = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mime = ["audio/webm;codecs=opus", "audio/webm", "audio/mp4", ""].find(t => !t || (window.MediaRecorder && MediaRecorder.isTypeSupported(t)));
      const recorder = new MediaRecorder(stream, mime ? { mimeType: mime } : undefined);
      const chunks = [];
      recorder.ondataavailable = e => { if (e.data && e.data.size) chunks.push(e.data); };
      recorder.onstop = async () => {
        stream.getTracks().forEach(t => t.stop());
        clearInterval(recRef.current.timer);
        const blob = new Blob(chunks, { type: recorder.mimeType || "audio/webm" });
        const dur = recRef.current.sec || 0;
        setRec("sending");
        try {
          const b64 = await new Promise((ok, bad) => { const fr = new FileReader(); fr.onload = () => ok(String(fr.result).split(",")[1] || ""); fr.onerror = bad; fr.readAsDataURL(blob); });
          const r = await api("/chat/voice", { method: "POST", body: { audio_base64: b64, mime: blob.type, duration: dur } });
          setMsgs(m => [...m, r.message]);
        } catch {}
        setRec("idle"); setRecSec(0);
      };
      recRef.current = { recorder, sec: 0, timer: setInterval(() => { recRef.current.sec += 1; setRecSec(recRef.current.sec); }, 1000) };
      recorder.start(1000);
      setRec("recording"); setRecSec(0);
    } catch { setRec("idle"); }
  };
  const stopVoice = () => { try { recRef.current.recorder?.state !== "inactive" && recRef.current.recorder?.stop(); } catch {} };
  const [playing, setPlaying] = useState(null); // {id,url}
  const playVoice = async (m) => {
    if (playing?.id === m.id) { setPlaying(null); return; }
    try {
      const token = localStorage.getItem(TOKEN_KEY);
      const res = await fetch(`/api/portal/chat/${m.id}/audio`, { headers: { Authorization: `Bearer ${token}` } });
      const blob = await res.blob();
      setPlaying({ id: m.id, url: URL.createObjectURL(blob) });
    } catch {}
  };
  const fmtT = (d) => { try { return new Date(d).toLocaleTimeString("ar-SA", { hour: "2-digit", minute: "2-digit" }); } catch { return ""; } };
  const fmtD = (d) => String(d || "").slice(0, 10);
  const fmtDur = (s) => s ? `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}` : "";
  let lastDay = "";
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "calc(100vh - 230px)", minHeight: 400 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, background: "#075e54", color: "#fff", borderRadius: "14px 14px 0 0", padding: "12px 14px" }}>
        <button type="button" onClick={onBack} title="رجوع للتسجيل" style={{ background: "none", border: "none", color: "#fff", fontSize: 18, cursor: "pointer", fontFamily: "inherit", padding: 0 }}>→</button>
        <div style={{ width: 36, height: 36, borderRadius: "50%", background: "#128c7e", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>🎧</div>
        <div><div style={{ fontWeight: 800, fontSize: 14 }}>خدمة العملاء — رئال</div><div style={{ fontSize: 10.5, opacity: 0.85 }}>نرد عليك في أقرب وقت</div></div>
      </div>
      <div ref={boxRef} style={{ flex: 1, overflowY: "auto", background: "#ece5dd", padding: "10px 10px" }}>
        {msgs.length === 0 && <div style={{ textAlign: "center", color: "#64748b", fontSize: 12, padding: 30 }}>ابدأ المحادثة — اكتب سؤالك أو طلبك وسيرد عليك فريق الشركة</div>}
        {msgs.map(m => {
          const day = fmtD(m.created_at);
          const showDay = day !== lastDay; lastDay = day;
          const mine = m.sender === "portal";
          return (
            <React.Fragment key={m.id}>
              {showDay && <div style={{ textAlign: "center", margin: "8px 0" }}><span style={{ background: "#dbe7ef", color: "#475569", fontSize: 10.5, padding: "3px 10px", borderRadius: 8 }}>{day}</span></div>}
              <div style={{ display: "flex", justifyContent: mine ? "flex-start" : "flex-end", marginBottom: 6 }}>
                <div style={{ maxWidth: "80%", background: mine ? "#dcf8c6" : "#fff", borderRadius: 10, padding: "7px 10px", boxShadow: "0 1px 1px rgba(0,0,0,0.08)", fontSize: 13.5, lineHeight: 1.5, whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                  {!mine && m.staff_name && <div style={{ fontSize: 10, color: "#128c7e", fontWeight: 800, marginBottom: 2 }}>{m.staff_name}</div>}
                  {m.kind === "voice" ? (
                    <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 170 }}>
                      <button type="button" onClick={() => playVoice(m)}
                        style={{ width: 34, height: 34, borderRadius: "50%", border: "none", background: "#128c7e", color: "#fff", fontSize: 14, cursor: "pointer", flexShrink: 0 }}>
                        {playing?.id === m.id ? "■" : "▶"}
                      </button>
                      {playing?.id === m.id
                        ? <audio src={playing.url} autoPlay controls onEnded={() => setPlaying(null)} style={{ height: 30, width: 170 }} />
                        : <span style={{ fontSize: 12.5, color: "#475569" }}>🎙 رسالة صوتية {fmtDur(m.duration_seconds) && `• ${fmtDur(m.duration_seconds)}`}</span>}
                    </div>
                  ) : m.body}
                  <div style={{ fontSize: 9.5, color: "#94a3b8", textAlign: "left", marginTop: 2 }}>{fmtT(m.created_at)}</div>
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </div>
      <div style={{ display: "flex", gap: 6, padding: 8, background: "#f0f0f0", borderRadius: "0 0 14px 14px", alignItems: "center" }}>
        {rec === "recording" ? (
          <div style={{ flex: 1, display: "flex", alignItems: "center", gap: 8, padding: "0 12px", height: 44, background: "#fee2e2", borderRadius: 20, color: "#b91c1c", fontWeight: 800, fontSize: 13.5 }}>
            <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#ef4444", animation: "pulse 1s infinite" }} />
            جارٍ التسجيل… {fmtDur(recSec) || "0:00"} — اضغط ■ للإرسال
          </div>
        ) : (
          <input value={text} onChange={e => setText(e.target.value)} onKeyDown={e => { if (e.key === "Enter") send(); }}
            placeholder={rec === "sending" ? "جارٍ إرسال التسجيل…" : "اكتب رسالة…"} disabled={rec === "sending"}
            style={{ ...inputS, padding: "10px 12px", borderRadius: 20, fontSize: 14 }} />
        )}
        {text.trim() && rec === "idle" ? (
          <button type="button" onClick={send} disabled={busy}
            style={{ width: 44, height: 44, borderRadius: "50%", border: "none", background: "#128c7e", color: "#fff", fontSize: 18, cursor: "pointer", flexShrink: 0 }}>➤</button>
        ) : (
          <button type="button" onClick={rec === "recording" ? stopVoice : startVoice} disabled={rec === "sending"}
            title={rec === "recording" ? "إيقاف وإرسال" : "تسجيل رسالة صوتية"}
            style={{ width: 44, height: 44, borderRadius: "50%", border: "none", background: rec === "recording" ? "#dc2626" : rec === "sending" ? "#cbd5e1" : "#128c7e", color: "#fff", fontSize: 18, cursor: "pointer", flexShrink: 0 }}>
            {rec === "recording" ? "■" : rec === "sending" ? "…" : "🎙"}
          </button>
        )}
      </div>
    </div>
  );
}

// ─── v3.3.812 — "عملائي" للمسوّق: المخصص له من الشركة + ما أضافه بنفسه، بحالة وملاحظات تراكمية ───
function PortalMyClients({ onWhatsApp, onAdd, onPersonal, scope, title, subtitle }) { /* v3.4.464 — scope="ext": عملاء المسوّقين الخارجيين (مديرة المبيعات) */ // v3.4.090 — onWhatsApp(client) — v3.4.096: onAdd يفتح تسجيل عميل جديد — v3.4.103: onPersonal(client) الزر الأزرق (واتسابي الشخصي)
  const [list, setList] = useState(null);
  const [q, setQ] = useState("");
  // v3.4.096 — فلاتر: نوع الاحتياج (وسوم الاهتمام) / نوع العميل / المصدر / الحالة — بدل «الكل/مخصصة لي/أضفتها»
  const [flt, setFlt] = useState({ need: [], cat: [], src: [], status: [] });
  const [fltOpen, setFltOpen] = useState(false);
  const tagsOf = (c) => String(c.portal_interests || "").split(/[،,]/).map(s => s.trim()).filter(Boolean);
  const toggleF = (k, v) => setFlt(p => ({ ...p, [k]: p[k].includes(v) ? p[k].filter(x => x !== v) : [...p[k], v] }));
  const nFlt = flt.need.length + flt.cat.length + flt.src.length + flt.status.length;
  const [open, setOpen] = useState(null); // prospect id
  const [noteText, setNoteText] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);
  const isExt = scope === "ext" || scope === "wa"; // v3.4.758 — «wa»: الواردون عبر واتساب يُعاملون كعملاء مسوّقين خارجيين
  const isWa = isExt; // v3.4.762 — التجميع حسب المسوّق + الطيّ/الفتح صارا لتبويب المسوّقين الخارجيين المدمج
  const [limit, setLimit] = useState(120); // v3.4.464 — عرض تدريجي للقوائم الكبيرة
  const [collapsedGrp, setCollapsedGrp] = useState({}); // v3.4.761 — مجموعات المسوّقين المطوية في تبويب «إضافة واتساب»
  const load = useCallback(() => api(isExt ? "/my-clients?scope=ext" : "/my-clients").then(r => setList(r.clients || [])).catch(() => setList([])), [isExt]);
  useEffect(() => { load(); }, [load]);
  const flash = (t, ok = true) => { setMsg({ t, ok }); setTimeout(() => setMsg(null), 2500); };
  const addNote = async (id) => {
    const t = noteText.trim();
    if (!t) return;
    setBusy(true);
    try { await api(`/my-clients/${id}/notes`, { method: "POST", body: { note_text: t } }); setNoteText(""); await load(); flash("✅ أُضيفت الملاحظة"); }
    catch (e) { flash(e.message, false); }
    setBusy(false);
  };
  const setStatus = async (id, status) => {
    try { await api(`/my-clients/${id}/status`, { method: "PATCH", body: { status } }); await load(); flash("✅ حُدّثت الحالة"); }
    catch (e) { flash(e.message, false); }
  };
  // v3.4.201 — تعديل اسم العميل فقط (الرقم لا يُعدَّل من التطبيق) — متاح لكل مستخدمي التطبيق على عملائهم
  const [editName, setEditName] = useState(null); // { id, value }
  const saveName = async () => {
    const v = (editName?.value || "").trim();
    if (!editName || !v) return;
    setBusy(true);
    try { await api(`/my-clients/${editName.id}/name`, { method: "PATCH", body: { name: v } }); setEditName(null); await load(); flash("✅ حُدّث الاسم"); }
    catch (e) { flash(e.message, false); }
    setBusy(false);
  };
  // v3.4.229 — تصنيفات العميل بترتيب منطقي (من الأبرد إلى الإغلاق)
  const STATUS = { "رقم جديد": ["#e0f2fe", "#075985"], "تحت المتابعة": ["#fef9c3", "#854d0e"], "مهتم": ["#dcfce7", "#166534"], "جاد جدا": ["#ffedd5", "#9a3412"], "عميل حجز": ["#ede9fe", "#5b21b6"], "اشترى": ["#dbeafe", "#1e40af"], "اشترى من طرف ثالث": ["#f1f5f9", "#334155"], "غير مهتم": ["#fee2e2", "#991b1b"] }; // v3.4.231
  const nq = q.trim().toLowerCase();
  const rows = (list || []).filter(c => {
    if (nq && !((c.name || "").toLowerCase().includes(nq) || (c.phone || "").includes(nq))) return false;
    if (flt.cat.length && !flt.cat.includes(c.client_category || "")) return false;
    if (flt.src.length && !flt.src.includes(c.source || "")) return false;
    if (flt.status.length && !flt.status.includes(c.status || "")) return false;
    if (flt.need.length) { const t = tagsOf(c); if (!flt.need.some(n => t.includes(n))) return false; }
    return true;
  });
  // v3.4.760 — تبويب «إضافة واتساب»: ترتيب حسب المسوّق الذي شارك الرقم (مجموعات)، «بدون مسوق» آخرًا، وداخل المجموعة الأحدث أولًا
  const mkKey = (c) => (c.marketer_name || "").trim();
  if (isWa) rows.sort((a, b) => { const ka = mkKey(a), kb = mkKey(b); if (!ka !== !kb) return ka ? -1 : 1; return ka.localeCompare(kb, "ar") || String(b.assigned_at || b.created_at || "").localeCompare(String(a.assigned_at || a.created_at || "")); });
  const mkCount = isWa ? rows.reduce((m, c) => { const k = mkKey(c); m[k] = (m[k] || 0) + 1; return m; }, {}) : {};
  const grpKeys = Object.keys(mkCount);
  const allCollapsed = isWa && grpKeys.length > 0 && grpKeys.every(k => collapsedGrp[k]);
  const toggleGrp = (k) => setCollapsedGrp(p => ({ ...p, [k]: !p[k] }));
  const setAllGrp = (v) => setCollapsedGrp(v ? Object.fromEntries(grpKeys.map(k => [k, true])) : {});
  const fmtD = (d) => String(d || "").slice(0, 10);
  const fmtT = (d) => { try { return new Date(d).toLocaleString("ar-SA", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }); } catch { return ""; } };
  // قيم الفلاتر المتاحة من البيانات نفسها (لا تظهر خيارات فارغة)
  const uniq = (arr) => [...new Set(arr.filter(Boolean))];
  const needOpts = uniq((list || []).flatMap(tagsOf));
  const catOpts = uniq((list || []).map(c => c.client_category));
  const srcOpts = uniq((list || []).map(c => c.source));
  const statusOpts = Object.keys(STATUS).filter(s => (list || []).some(c => c.status === s)); // v3.4.229
  const chipF = (on) => ({ padding: "7px 12px", borderRadius: 999, border: "1.5px solid " + (on ? "#0f766e" : "#e2e8f0"), background: on ? "#0f766e" : "#fff",
    color: on ? "#fff" : "#475569", fontSize: 12, fontWeight: 800, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" });
  const group = (title, key, opts) => opts.length ? (
    <div style={{ marginBottom: 10 }}>
      <div style={{ fontSize: 11, fontWeight: 800, color: "#0f766e", marginBottom: 6 }}>{title}</div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
        {opts.map(v => <button key={v} type="button" onClick={() => toggleF(key, v)} style={chipF(flt[key].includes(v))}>{flt[key].includes(v) ? "✓ " : ""}{v}</button>)}
      </div>
    </div>
  ) : null;
  return (
    <div className="pclients">{/* v3.4.232 — عمودان على سطح المكتب */}
      {/* v3.4.096 — العنوان + زر واضح لإضافة عميل جديد (بدل الزر العائم) */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, marginBottom: 4 }}>
        <div style={{ fontSize: 17, fontWeight: 900, color: "#0f172a" }}>{title || "👥 عملائي"} <span style={{ fontSize: 12, color: "#94a3b8", fontWeight: 700 }}>({rows.length}{nFlt || nq ? ` من ${(list || []).length}` : ""})</span></div>
        {onAdd && (
          <button type="button" onClick={onAdd}
            style={{ background: "linear-gradient(135deg,#0f766e,#14b8a6)", color: "#fff", border: "none", borderRadius: 12, padding: "9px 14px", fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit", boxShadow: "0 6px 16px rgba(15,118,110,.3)", whiteSpace: "nowrap" }}>
            ＋ إضافة عميل جديد
          </button>
        )}
      </div>
      <div style={{ fontSize: 12, color: "#64748b", marginBottom: 10 }}>{subtitle || "الأرقام المخصصة لك من الشركة + ما أضفته بنفسك — عالج كل رقم وأضف ملاحظاتك"}</div>
      {msg && <div style={{ background: msg.ok ? "#dcfce7" : "#fee2e2", color: msg.ok ? "#166534" : "#991b1b", borderRadius: 10, padding: "8px 12px", fontSize: 12.5, fontWeight: 700, marginBottom: 10 }}>{msg.t}</div>}
      {/* بحث + زر الفلاتر */}
      <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
        <input value={q} onChange={e => setQ(e.target.value)} placeholder="🔍 بحث بالاسم أو الجوال…" style={{ ...inputS, flex: 1, padding: "10px 12px", fontSize: 14 }} />
        <button type="button" onClick={() => setFltOpen(v => !v)}
          style={{ padding: "0 14px", borderRadius: 12, border: "1.5px solid " + (nFlt ? "#0f766e" : "#e2e8f0"), background: nFlt ? "#ccfbf1" : "#fff", color: "#0f766e", fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>
          ⚙ تصفية{nFlt ? ` (${nFlt})` : ""}
        </button>
      </div>
      {/* الفلاتر النشطة كشرائح قابلة للإزالة */}
      {nFlt > 0 && !fltOpen && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 8 }}>
          {[["need", flt.need], ["cat", flt.cat], ["src", flt.src], ["status", flt.status]].flatMap(([k, arr]) => arr.map(v => (
            <button key={k + v} type="button" onClick={() => toggleF(k, v)} style={{ ...chipF(true), padding: "5px 10px", fontSize: 11 }}>{v} ✕</button>
          )))}
          <button type="button" onClick={() => setFlt({ need: [], cat: [], src: [], status: [] })} style={{ ...chipF(false), padding: "5px 10px", fontSize: 11, color: "#dc2626", borderColor: "#fecaca" }}>مسح الكل</button>
        </div>
      )}
      {fltOpen && (
        <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 14, padding: 12, marginBottom: 10, boxShadow: "0 6px 20px rgba(15,23,42,.06)" }}>
          {group("نوع الاحتياج", "need", needOpts)}
          {group("نوع العميل", "cat", catOpts)}
          {group("مصدر العميل", "src", srcOpts)}
          {group("الحالة", "status", statusOpts)}
          {!needOpts.length && !catOpts.length && !srcOpts.length && <div style={{ fontSize: 12, color: "#94a3b8" }}>لا توجد بيانات كافية للتصفية بعد</div>}
          <div style={{ display: "flex", gap: 8, marginTop: 4 }}>
            <button type="button" onClick={() => setFltOpen(false)} style={{ flex: 1, padding: "10px", background: "linear-gradient(135deg,#0f766e,#14b8a6)", color: "#fff", border: "none", borderRadius: 10, fontSize: 13, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>✓ عرض النتائج ({rows.length})</button>
            {nFlt > 0 && <button type="button" onClick={() => setFlt({ need: [], cat: [], src: [], status: [] })} style={{ padding: "10px 14px", background: "#fff1f2", color: "#dc2626", border: "1px solid #fecaca", borderRadius: 10, fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>مسح</button>}
          </div>
        </div>
      )}
      {isWa && list !== null && grpKeys.length > 1 && ( /* v3.4.761 — طيّ/فتح كل مجموعات المسوّقين */
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 6, marginBottom: 2 }}>
          <button type="button" onClick={() => setAllGrp(!allCollapsed)} style={{ padding: "5px 12px", borderRadius: 999, border: "1px solid #ddd6fe", background: "#f5f3ff", color: "#5b21b6", fontSize: 11.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>
            {allCollapsed ? "▾ فتح الكل" : "◂ طيّ الكل"} ({grpKeys.length} مسوّق)
          </button>
        </div>
      )}
      {list === null ? <div style={{ textAlign: "center", color: "#94a3b8", padding: 30 }}>جارٍ التحميل…</div>
        : rows.length === 0 ? <div style={{ textAlign: "center", color: "#94a3b8", padding: 30, fontSize: 13 }}>{nFlt || nq ? "لا يوجد عملاء مطابقون للتصفية" : "لا يوجد عملاء بعد"}</div>
        : rows.slice(0, limit).map((c, ci, arr) => {
          const st = STATUS[c.status] || ["#f1f5f9", "#475569"];
          const isOpen = open === c.id;
          const notes = Array.isArray(c.notes_log) ? c.notes_log : [];
          const grpHead = isWa && (ci === 0 || mkKey(arr[ci - 1]) !== mkKey(c)); // v3.4.760 — رأس مجموعة المسوّق
          const grpClosed = isWa && !!collapsedGrp[mkKey(c)]; // v3.4.761 — المجموعة مطوية: يظهر رأسها فقط
          return (
            <React.Fragment key={c.id}>
            {grpHead && (
              <div role="button" onClick={() => toggleGrp(mkKey(c))} title={grpClosed ? "فتح المجموعة" : "طيّ المجموعة"}
                style={{ display: "flex", alignItems: "center", gap: 8, margin: "14px 0 8px", padding: "8px 12px", background: "linear-gradient(135deg,#f5f3ff,#ede9fe)", border: "1px solid #ddd6fe", borderRadius: 12, cursor: "pointer", userSelect: "none" }}>
                <span style={{ fontSize: 13, color: "#7c3aed", width: 16, textAlign: "center" }}>{grpClosed ? "◂" : "▾"}</span>
                <span style={{ fontSize: 14, fontWeight: 900, color: "#5b21b6" }}>🧑‍💼 {mkKey(c) || "بدون مسوق"}</span>
                <span style={{ background: "#7c3aed", color: "#fff", borderRadius: 999, padding: "1px 9px", fontSize: 11.5, fontWeight: 800 }}>{mkCount[mkKey(c)] || 0}</span>
                <span style={{ fontSize: 11, color: "#6d28d9", marginInlineStart: "auto" }}>{grpClosed ? "اضغط للفتح" : "المسوّق الذي شارك الأرقام"}</span>
              </div>
            )}
            {!grpClosed && <div className="pcard" style={{ background: "#fff", borderRadius: 14, boxShadow: "0 2px 10px rgba(0,0,0,0.05)", marginBottom: 10, overflow: "hidden", border: isOpen ? "1.5px solid #f59e0b" : "1.5px solid transparent" }}>
              <div onClick={() => { setOpen(isOpen ? null : c.id); setNoteText(""); }} style={{ padding: "12px 14px", cursor: "pointer" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                  <div style={{ minWidth: 0 }}>
                    <div style={{ fontWeight: 800, fontSize: 14.5, color: "#0f172a", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{c.name || "—"}</div>
                    <div style={{ fontSize: 12, color: "#475569", direction: "ltr", textAlign: "right", marginTop: 2, display: "flex", gap: 8, alignItems: "center", justifyContent: "flex-end", flexWrap: "wrap" }}>
                      {c.phone ? <a href={`tel:${c.phone}`} onClick={e => e.stopPropagation()} style={{ color: "#1d4ed8", textDecoration: "none", fontWeight: 700 }}>📞 {c.phone}</a> : "—"}
                      {c.phone && onWhatsApp && ( // v3.4.090 — زر واتس يفتح محادثة العميل داخل التطبيق — v3.4.092: شعار واتساب المعروف بدل النص
                        <button type="button" onClick={e => { e.stopPropagation(); onWhatsApp(c); }} title="أرسل على الواتس" aria-label="أرسل على الواتس"
                          style={{ width: 30, height: 30, borderRadius: "50%", background: "#25D366", border: "none", padding: 0, cursor: "pointer",
                            display: "inline-flex", alignItems: "center", justifyContent: "center", boxShadow: "0 2px 6px rgba(37,211,102,.45)" }}>
                          <WaLogo size={18} />
                        </button>
                      )}
                      {c.phone && onPersonal && ( // v3.4.103 — زر أزرق: محادثة العميل من واتساب المسوّق الشخصي المربوط بالـ QR داخل التطبيق (كان v3.4.102 رابط wa.me)
                        <button type="button" onClick={e => { e.stopPropagation(); onPersonal(c); }} title="راسله من واتسابي الشخصي" aria-label="راسله من واتسابي الشخصي"
                          style={{ width: 30, height: 30, borderRadius: "50%", background: "#2563eb", border: "none", padding: 0, cursor: "pointer",
                            display: "inline-flex", alignItems: "center", justifyContent: "center", boxShadow: "0 2px 6px rgba(37,99,235,.45)" }}>
                          <WaLogo size={18} />
                        </button>
                      )}
                    </div>
                  </div>
                  <div style={{ textAlign: "left", flexShrink: 1, minWidth: 0, maxWidth: "52%" }}>{/* v3.4.763 — كان flexShrink: 0 فيضغط الاسم والجوال عندما يطول سطر المعلومات */}
                    <span style={{ background: st[0], color: st[1], borderRadius: 12, padding: "3px 10px", fontSize: 11, fontWeight: 800, whiteSpace: "nowrap" }}>{c.status || "—"}</span>
                    {/* v3.4.759 — خانة «مخصص لـ» باسم الحساب المخصص له + من أضافه — v3.4.761: على كل البطاقات في كل التبويبات، وقبلها معلومة المسوّق في تبويبي الخارجيين/واتساب */}
                    {isExt && ( /* v3.4.762 · v3.4.763: سطر المسوّق/التحويل مستقل */
                      <div style={{ fontSize: 9.5, color: "#7c3aed", marginTop: 4, lineHeight: 1.5 }}>🧑‍💼 المسوق: {c.marketer_name || c.owner_name || "—"}{String(c.source || "").startsWith("واتساب — تحويل") && c.created_by ? <> • 📱 حوّله: {c.created_by}</> : null}</div>
                    )}
                    <div style={{ fontSize: 9.5, color: "#94a3b8", marginTop: isExt ? 1 : 4, lineHeight: 1.5 }}>{[
                      c.assigned_portal_user_id || c.assigned_name ? (c.is_assigned ? "📌 مخصص لك" : "📌 مخصص لـ: " + (c.assigned_name || "حساب غير معروف")) : "📌 غير مخصص",
                      c.is_mine ? "✍️ أضفته" : c.adder_name ? "✍️ أضافه: " + c.adder_name : c.created_by ? "✍️ أضافه: " + c.created_by : "",
                      fmtD(c.assigned_at || c.created_at)].filter(Boolean).join(" • ")}</div>
                  </div>
                </div>
                {(c.portal_interests || c.interest_project_name || c.notes) && (
                  <div style={{ fontSize: 11.5, color: "#64748b", marginTop: 6, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: isOpen ? "normal" : "nowrap" }}>
                    {[c.portal_interests, c.interest_project_name, c.notes].filter(Boolean).join(" • ")}
                  </div>
                )}
                {notes.length > 0 && !isOpen && <div style={{ fontSize: 10.5, color: "#b45309", marginTop: 4, fontWeight: 700 }}>💬 {notes.length} ملاحظة — آخرها: {notes[0].text.slice(0, 40)}{notes[0].text.length > 40 ? "…" : ""}</div>}
              </div>
              {isOpen && (
                <div style={{ borderTop: "1px solid #f1f5f9", padding: "10px 14px", background: "#fffbeb" }}>
                  {/* v3.4.233 — بيانات طلب العميل كما أُدخلت عند التسجيل */}
                  {(() => {
                    const rows = [
                      ["نوع العميل", c.client_category], ["مصدر العميل", c.source], ["الاهتمام", tagsOf(c).join("، ")],
                      ["نوع الطلب", c.interest_type], ["المشروع", c.interest_project_name], ["النطاق", c.interest_scope], ["النموذج", c.interest_model],
                      ["عدد الوحدات", c.interest_units_count], ["الغرف", c.interest_rooms], ["طريقة الدفع", c.interest_payment], ["الهدف من الشراء", c.interest_goal],
                    ].filter(([, v]) => v !== null && v !== undefined && String(v).trim() !== "");
                    return (
                      <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: "10px 12px", marginBottom: 12 }}>
                        <div style={{ fontSize: 11.5, fontWeight: 900, color: "#0f766e", marginBottom: 6 }}>📋 بيانات طلب العميل</div>
                        {rows.length === 0 && !c.notes ? <div style={{ fontSize: 11.5, color: "#94a3b8" }}>لم تُسجَّل تفاصيل للطلب</div> : (
                          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: "6px 10px" }}>
                            {rows.map(([l, v]) => (
                              <div key={l} style={{ fontSize: 12 }}>
                                <div style={{ fontSize: 10, color: "#94a3b8", fontWeight: 700 }}>{l}</div>
                                <div style={{ fontWeight: 800, color: "#0f172a" }}>{String(v)}</div>
                              </div>
                            ))}
                          </div>
                        )}
                        {c.notes && <div style={{ marginTop: 8, fontSize: 12, color: "#475569", whiteSpace: "pre-wrap", borderTop: "1px dashed #e2e8f0", paddingTop: 6 }}><span style={{ fontSize: 10, color: "#94a3b8", fontWeight: 700 }}>ملاحظة التسجيل: </span>{c.notes}</div>}
                      </div>
                    );
                  })()}
                  {/* v3.4.201 — تعديل الاسم فقط (بدون الرقم) */}
                  <div style={{ fontSize: 11, fontWeight: 800, color: "#92400e", marginBottom: 6 }}>✏️ اسم العميل</div>
                  {editName?.id === c.id ? (
                    <div style={{ display: "flex", gap: 6, marginBottom: 12 }}>
                      <input autoFocus value={editName.value} onChange={e => setEditName({ id: c.id, value: e.target.value })} maxLength={200} placeholder="اسم العميل"
                        onKeyDown={e => { if (e.key === "Enter") saveName(); if (e.key === "Escape") setEditName(null); }}
                        style={{ ...inputS, flex: 1, padding: "9px 12px", fontSize: 14 }} />
                      <button type="button" onClick={saveName} disabled={busy || !editName.value.trim()}
                        style={{ padding: "0 14px", borderRadius: 10, border: "none", background: editName.value.trim() ? "#0f766e" : "#cbd5e1", color: "#fff", fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>حفظ</button>
                      <button type="button" onClick={() => setEditName(null)}
                        style={{ padding: "0 12px", borderRadius: 10, border: "1px solid #e2e8f0", background: "#fff", color: "#475569", fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>إلغاء</button>
                    </div>
                  ) : (
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, marginBottom: 12 }}>
                      <div style={{ fontSize: 13.5, fontWeight: 800, color: "#0f172a", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{c.name || "—"}</div>
                      <button type="button" onClick={() => setEditName({ id: c.id, value: c.name || "" })}
                        style={{ padding: "6px 12px", borderRadius: 10, border: "1.5px solid #fed7aa", background: "#fff7ed", color: "#c2410c", fontSize: 11.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>✏️ تعديل الاسم</button>
                    </div>
                  )}
                  <div style={{ fontSize: 11, fontWeight: 800, color: "#92400e", marginBottom: 6 }}>الحالة</div>
                  <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 12 }}>
                    {Object.keys(STATUS).map(s => (
                      <button key={s} type="button" onClick={() => setStatus(c.id, s)}
                        style={{ padding: "6px 12px", borderRadius: 10, border: "1.5px solid " + (c.status === s ? STATUS[s][1] : "#e2e8f0"),
                          background: c.status === s ? STATUS[s][0] : "#fff", color: c.status === s ? STATUS[s][1] : "#475569", fontWeight: 800, fontSize: 11.5, cursor: "pointer", fontFamily: "inherit" }}>{s}</button>
                    ))}
                  </div>
                  <div style={{ fontSize: 11, fontWeight: 800, color: "#92400e", marginBottom: 6 }}>💬 الملاحظات ({notes.length}) — الملاحظات تراكمية لمتابعة تاريخ العلاقة مع العميل</div>
                  <div style={{ maxHeight: 220, overflowY: "auto", marginBottom: 8 }}>
                    {notes.length === 0 && <div style={{ fontSize: 11.5, color: "#94a3b8", padding: 6 }}>لا ملاحظات بعد</div>}
                    {notes.map(n => (
                      <div key={n.id} style={{ background: n.mine ? "#fef3c7" : "#fff", border: "1px solid #fde68a", borderRadius: 8, padding: "6px 10px", marginBottom: 6 }}>
                        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 10, color: "#64748b", marginBottom: 2 }}>
                          <span style={{ fontWeight: 700, color: n.mine ? "#b45309" : "#0f766e" }}>{n.mine ? "أنا" : n.user || "الشركة"}</span><span>{fmtT(n.date)}</span>
                        </div>
                        <div style={{ fontSize: 12.5, color: "#1e293b", whiteSpace: "pre-wrap" }}>{n.text}</div>
                      </div>
                    ))}
                  </div>
                  <textarea value={noteText} onChange={e => setNoteText(e.target.value)} rows={2} placeholder="اكتب ملاحظة عن هذا العميل…"
                    style={{ ...inputS, padding: "9px 12px", fontSize: 13.5, resize: "vertical", marginBottom: 6 }} />
                  <button type="button" onClick={() => addNote(c.id)} disabled={busy || !noteText.trim()}
                    style={{ ...btnPrimary, padding: "10px", fontSize: 13.5, background: noteText.trim() ? "linear-gradient(135deg,#b45309,#f59e0b)" : "#cbd5e1" }}>
                    {busy ? "جارٍ الحفظ…" : "💾 حفظ الملاحظة"}
                  </button>
                </div>
              )}
            </div>}
            </React.Fragment>
          );
        })}
      {list !== null && rows.length > limit && ( /* v3.4.464 */
        <button type="button" onClick={() => setLimit(l => l + 200)}
          style={{ gridColumn: "1 / -1", width: "100%", padding: "11px", borderRadius: 12, border: "1.5px dashed #0f766e", background: "#f0fdfa", color: "#0f766e", fontSize: 13, fontWeight: 800, cursor: "pointer", fontFamily: "inherit", marginBottom: 10 }}>
          عرض المزيد ({Math.min(limit, rows.length)} من {rows.length})
        </button>
      )}
    </div>
  );
}

// ─── الشاشة الرئيسية: إدخال عميل + إدخالاتي ───
// ═══════ v3.3.846 — العروض العقارية (المسوّقون): خريطة كاملة + فلتر سفلي منسدل ═══════
const OFFER_TYPES = ["استديو", "غرفة", "غرفتين", "ثلاث غرف", "أربع غرف", "خمس غرف", "ست غرف", "ملاحق", "دبلوكسات"];
const nfmt = (n) => (n == null || n === "" || isNaN(Number(n))) ? "—" : Number(n).toLocaleString("en-US", { maximumFractionDigits: 0 });
// v3.3.955 — خريطة عروض الأراضي (للمدير العام): استعراض فقط ببطاقة تفاصيل
function PortalLands() {
  const [data, setData] = useState(null);
  const [sel, setSel] = useState(null);
  const [mapReady, setMapReady] = useState(0);
  const mapRef = useRef(null); const mapEl = useRef(null); const markersRef = useRef([]); const wrapRef = useRef(null);
  useEffect(() => { api("/land-offers").then(setData).catch(() => setData({ lands: [] })); }, []);
  useEffect(() => {
    if (!mapEl.current || mapRef.current || !data) return;
    const map = new maplibregl.Map({ container: mapEl.current, style: buildStyle(data.mapbox_token), center: DEFAULT_CENTER, zoom: 10, attributionControl: false });
    map.addControl(new maplibregl.NavigationControl({ visualizePitch: false, showCompass: false }), "top-left");
    map.addControl(new maplibregl.FullscreenControl(wrapRef.current ? { container: wrapRef.current } : {}), "top-left");
    map.addControl(new maplibregl.GeolocateControl({ positionOptions: { enableHighAccuracy: true } }), "top-left");
    map.on("load", () => { mapRef.current = map; setTimeout(() => map.resize(), 50); setMapReady(x => x + 1); });
    return () => { map.remove(); mapRef.current = null; };
  }, [data]);
  const lands = (data?.lands || []).filter(l => l.lat != null && l.lng != null);
  useEffect(() => {
    const map = mapRef.current; if (!map) return;
    markersRef.current.forEach(m => m.remove()); markersRef.current = [];
    lands.forEach(l => {
      const bg = l.status === "مباعة" ? "#64748b" : l.status === "محجوزة" ? "#b45309" : "#15803d";
      const el = document.createElement("div");
      el.style.cssText = `padding:4px 9px;border-radius:9px;background:${bg};color:#fff;font-size:11px;font-weight:800;white-space:nowrap;box-shadow:0 2px 8px rgba(0,0,0,.4);border:2px solid #fff;cursor:pointer;font-family:inherit;`;
      el.textContent = `📍 ${l.title}`;
      el.addEventListener("click", (e) => { e.stopPropagation(); setSel(l); });
      markersRef.current.push(new maplibregl.Marker({ element: el, anchor: "bottom" }).setLngLat([l.lng, l.lat]).addTo(map));
    });
  }, [mapReady, data]); // lands مشتق من data
  const nf = (v) => (v == null || v === "" ? "—" : Number(v).toLocaleString());
  // v3.3.956 — إضافة ذكية ويدوية من البوابة
  const [smartOpen, setSmartOpen] = useState(false);
  const [formData, setFormData] = useState(null); // null | كائن النموذج
  const reload = () => api("/land-offers").then(setData).catch(() => {});
  return (
    <div ref={wrapRef} style={{ position: "relative" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8, flexWrap: "wrap" }}>
        <div style={{ fontSize: 13, fontWeight: 800, color: "#334155" }}>🗺️ عروض الأراضي ({lands.length})</div>
        <span style={{ marginInlineStart: "auto", display: "inline-flex", gap: 6 }}>
          <button onClick={() => setSmartOpen(true)} style={{ padding: "8px 14px", background: "linear-gradient(135deg,#6d28d9,#8b5cf6)", color: "#fff", border: "none", borderRadius: 10, fontSize: 12, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>✨ إضافة بذكاء</button>
          <button onClick={() => setFormData({})} style={{ padding: "8px 14px", background: "#15803d", color: "#fff", border: "none", borderRadius: 10, fontSize: 12, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>➕ إضافة يدوية</button>
        </span>
      </div>
      {smartOpen && <PortalLandSmart onClose={() => setSmartOpen(false)} onParsed={(p) => { setSmartOpen(false); setFormData(p); if (p.lat && p.lng && mapRef.current) mapRef.current.flyTo({ center: [p.lng, p.lat], zoom: 15 }); }} />}
      {formData && <PortalLandForm init={formData} mapRef={mapRef} onClose={() => setFormData(null)} onSaved={() => { setFormData(null); reload(); }} />}
      <div ref={mapEl} style={{ height: "60vh", borderRadius: 14, overflow: "hidden", border: "1px solid #e2e8f0" }} />
      {sel && (
        <div style={{ position: "absolute", insetInline: 8, bottom: 8, background: "#fff", borderRadius: 14, boxShadow: "0 -6px 30px rgba(0,0,0,0.25)", padding: 14, zIndex: 20, maxHeight: "55%", overflowY: "auto" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
            <div style={{ fontWeight: 800, fontSize: 14.5 }}>📍 {sel.title}</div>
            <span style={{ display: "inline-flex", gap: 6, alignItems: "center" }}>
              <span style={{ background: sel.status === "مباعة" ? "#f1f5f9" : sel.status === "محجوزة" ? "#fef3c7" : "#dcfce7", color: sel.status === "مباعة" ? "#64748b" : sel.status === "محجوزة" ? "#b45309" : "#166534", borderRadius: 10, padding: "2px 10px", fontSize: 10.5, fontWeight: 800 }}>{sel.status || "معروضة"}</span>
              <button onClick={() => setSel(null)} style={{ border: "none", background: "#f1f5f9", borderRadius: 8, width: 26, height: 26, cursor: "pointer", fontWeight: 800 }}>✕</button>
            </span>
          </div>
          <div style={{ fontSize: 11.5, color: "#64748b", marginTop: 2 }}>{[sel.city, sel.district, sel.land_type].filter(Boolean).join(" • ") || "—"}</div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6, marginTop: 10, fontSize: 12 }}>
            <div style={{ background: "#f8fafc", borderRadius: 8, padding: "6px 10px" }}>المساحة: <b>{nf(sel.area_sqm)} م²</b></div>
            <div style={{ background: "#f8fafc", borderRadius: 8, padding: "6px 10px" }}>الشوارع: <b>{sel.streets_count || "—"}{sel.street_widths ? ` (${sel.street_widths})` : ""}</b></div>
            <div style={{ background: "#f0fdf4", borderRadius: 8, padding: "6px 10px" }}>سعر المتر: <b>{nf(sel.price_per_sqm)} ر.س</b></div>
            <div style={{ background: "#f0fdf4", borderRadius: 8, padding: "6px 10px" }}>الإجمالي: <b style={{ color: "#15803d" }}>{nf(sel.total_price)} ر.س</b></div>
          </div>
          <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
            <a href={`https://www.google.com/maps?q=${sel.lat},${sel.lng}`} target="_blank" rel="noreferrer"
              style={{ padding: "8px 14px", background: "#eff6ff", color: "#1d4ed8", border: "1px solid #bfdbfe", borderRadius: 9, fontSize: 12, fontWeight: 800, textDecoration: "none" }}>📍 Google Maps</a>
          </div>
        </div>
      )}
    </div>
  );
}

// v3.3.960 — إضافة عرض عقاري بذكاء: نص و/أو ملف PDF (بروشور) → Claude يستخرج المشروع والنماذج كاملة
function PortalOfferSmart({ onClose, onParsed }) {
  const [text, setText] = useState("");
  const [pdf, setPdf] = useState(null);
  const [busy, setBusy] = useState(false);
  const go = async () => {
    if (!text.trim() && !pdf) return alert("الصق نص العرض أو ارفع ملف PDF");
    setBusy(true);
    try {
      const token = localStorage.getItem(TOKEN_KEY);
      const fd = new FormData();
      if (text.trim()) fd.append("text", text.trim());
      if (pdf) fd.append("pdf", pdf);
      const r = await fetch("/api/portal/property-offers/parse", { method: "POST", headers: { Authorization: `Bearer ${token}` }, body: fd });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.error || "فشل التحليل");
      onParsed(d);
    } catch (e) { alert(e.message || "فشل التحليل"); }
    setBusy(false);
  };
  return createPortal( /* v3.4.168 */
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", padding: 14 }} onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: "#fff", borderRadius: 16, padding: 18, width: 540, maxWidth: "96vw" }}>
        <div style={{ fontWeight: 800, fontSize: 14.5, marginBottom: 6 }}>✨ إضافة عرض بذكاء</div>
        <div style={{ fontSize: 11.5, color: "#64748b", marginBottom: 10 }}>ارفع بروشور المشروع (PDF) و/أو الصق نص العرض — يستخرج الذكاء الاصطناعي اسم المشروع والمطور والنماذج بمساحاتها وأسعارها والوصف، ويفتح النموذج معبأً للمراجعة.</div>
        <label style={{ display: "block", padding: "13px 14px", border: "1.5px dashed " + (pdf ? "#0f766e" : "#cbd5e1"), borderRadius: 10, cursor: "pointer", textAlign: "center", color: pdf ? "#0f766e" : "#94a3b8", fontWeight: pdf ? 700 : 500, fontSize: 12.5, marginBottom: 8 }}>
          📄 {pdf ? `${pdf.name} (${(pdf.size / 1048576).toFixed(1)}MB)` : "اختر ملف بروشور PDF… (حتى 100MB)"}
          <input type="file" accept=".pdf,application/pdf" style={{ display: "none" }} onChange={(e) => setPdf(e.target.files?.[0] || null)} />
        </label>
        <textarea value={text} onChange={(e) => setText(e.target.value)} rows={5}
          placeholder={"و/أو الصق نص العرض هنا (مع رابط الموقع إن وجد)…"}
          style={{ width: "100%", boxSizing: "border-box", padding: 10, border: "1.5px solid #e2e8f0", borderRadius: 10, fontSize: 12.5, fontFamily: "inherit", resize: "vertical" }} />
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 10 }}>
          <button onClick={onClose} style={{ padding: "9px 16px", background: "#fff", border: "1.5px solid #e2e8f0", color: "#64748b", borderRadius: 10, fontSize: 12.5, cursor: "pointer", fontFamily: "inherit" }}>إلغاء</button>
          <button onClick={go} disabled={busy} style={{ padding: "9px 20px", background: "linear-gradient(135deg,#6d28d9,#8b5cf6)", color: "#fff", border: "none", borderRadius: 10, fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>{busy ? "جارٍ التحليل… (قد يستغرق دقيقة للـPDF)" : "🔎 تحليل وفتح النموذج"}</button>
        </div>
      </div>
    </div>
  , document.body);
}

// v3.3.956 — إضافة أرض بذكاء من البوابة: لصق رسالة → تحليل → نموذج معبأ
function PortalLandSmart({ onClose, onParsed }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async () => {
    if (!text.trim()) return alert("الصق نص العرض أولًا");
    setBusy(true);
    try { onParsed(await api("/land-offers/parse", { method: "POST", body: { text } })); }
    catch (e) { alert(e.message || "فشل التحليل"); }
    setBusy(false);
  };
  return createPortal( /* v3.4.168 */
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", padding: 14 }} onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: "#fff", borderRadius: 16, padding: 18, width: 520, maxWidth: "96vw" }}>
        <div style={{ fontWeight: 800, fontSize: 14.5, marginBottom: 6 }}>✨ إضافة أرض بذكاء</div>
        <div style={{ fontSize: 11.5, color: "#64748b", marginBottom: 10 }}>الصق رسالة العرض كما وصلتك (برابط خرائط جوجل والسعر والمساحة) — يُحلل تلقائيًا ويفتح النموذج معبأً.</div>
        <textarea value={text} onChange={(e) => setText(e.target.value)} rows={7} autoFocus
          style={{ width: "100%", boxSizing: "border-box", padding: 10, border: "1.5px solid #e2e8f0", borderRadius: 10, fontSize: 12.5, fontFamily: "inherit", resize: "vertical" }} />
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 10 }}>
          <button onClick={onClose} style={{ padding: "9px 16px", background: "#fff", border: "1.5px solid #e2e8f0", color: "#64748b", borderRadius: 10, fontSize: 12.5, cursor: "pointer", fontFamily: "inherit" }}>إلغاء</button>
          <button onClick={go} disabled={busy} style={{ padding: "9px 20px", background: "linear-gradient(135deg,#6d28d9,#8b5cf6)", color: "#fff", border: "none", borderRadius: 10, fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>{busy ? "جارٍ التحليل…" : "🔎 تحليل"}</button>
        </div>
      </div>
    </div>
  , document.body);
}

// v3.3.956 — نموذج إضافة/مراجعة أرض من البوابة (للمدير العام)
function PortalLandForm({ init, mapRef, onClose, onSaved }) {
  const [f, setF] = useState({
    title: init.title || "", city: init.city || "", district: init.district || "",
    lat: init.lat ?? "", lng: init.lng ?? "", maps_link: init.maps_url || "",
    area_sqm: init.area_sqm ?? "", streets_count: init.streets_count ?? "", street_widths: init.street_widths || "",
    price_per_sqm: init.price_per_sqm ?? "", total_price: init.total_price ?? "", land_type: init.land_type || "",
    owner_name: init.owner_name || "", owner_phone: init.owner_phone || "",
    broker_name: init.broker_name || "", broker_phone: init.broker_phone || "", notes: init.notes || "",
  });
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));
  useEffect(() => {
    const a = Number(f.area_sqm), p = Number(f.price_per_sqm);
    if (f.area_sqm !== "" && f.price_per_sqm !== "" && !isNaN(a) && !isNaN(p)) set("total_price", String(Math.round(a * p)));
  }, [f.area_sqm, f.price_per_sqm]); // حساب الإجمالي تلقائيًا
  // v3.3.959 — زر تحقق صريح بمؤشر حالة (✓/✗) بجانب التلقائي عند مغادرة الحقل
  const [locState, setLocState] = useState(init.lat != null && init.lat !== "" ? "ok" : null); // null | checking | ok | fail
  const resolveLink = async () => {
    if (!f.maps_link.trim()) return;
    setLocState("checking");
    try {
      const p = await api("/land-offers/parse", { method: "POST", body: { text: f.maps_link.trim() } });
      if (p.lat && p.lng) { set("lat", p.lat); set("lng", p.lng); setLocState("ok"); if (mapRef.current) mapRef.current.flyTo({ center: [p.lng, p.lat], zoom: 15 }); }
      else setLocState("fail");
    } catch { setLocState("fail"); }
  };
  const useCenter = () => { const c = mapRef.current?.getCenter(); if (c) { set("lat", c.lat.toFixed(7)); set("lng", c.lng.toFixed(7)); } }; // v3.3.957 — دقة 7 خانات
  const save = async () => {
    if (!f.title.trim()) return alert("اسم الأرض مطلوب");
    if (f.lat === "" || f.lng === "") return alert("حدد الموقع: الصق رابط خرائط أو استخدم مركز الخريطة");
    setBusy(true);
    try { await api("/land-offers", { method: "POST", body: f }); onSaved(); }
    catch (e) { alert(e.message || "فشل الحفظ"); }
    setBusy(false);
  };
  const L = ({ t }) => <div style={{ fontSize: 11, fontWeight: 800, color: "#475569", margin: "8px 0 3px" }}>{t}</div>;
  const inp = { width: "100%", boxSizing: "border-box", padding: "10px 12px", border: "1.5px solid #e2e8f0", borderRadius: 10, fontSize: 13, fontFamily: "inherit" };
  return createPortal( /* v3.4.168 */
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", padding: 14 }} onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: "#fff", borderRadius: 16, padding: 18, width: 540, maxWidth: "96vw", maxHeight: "92vh", overflowY: "auto" }}>
        <div style={{ fontWeight: 800, fontSize: 14.5 }}>➕ إضافة أرض معروضة</div>
        <L t="اسم/عنوان الأرض *" /><input value={f.title} onChange={(e) => set("title", e.target.value)} style={{ ...inp, fontWeight: 700 }} placeholder="مثال: أرض سكنية — أبحر الجنوبي" />
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
          <div><L t="المدينة" /><input value={f.city} onChange={(e) => set("city", e.target.value)} style={inp} /></div>
          <div><L t="الحي" /><input value={f.district} onChange={(e) => set("district", e.target.value)} style={inp} /></div>
        </div>
        <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 10, padding: 10, marginTop: 8 }}>
          <L t="📍 الموقع *" />
          <div style={{ display: "flex", gap: 6 }}>
            <input value={f.maps_link} onChange={(e) => { set("maps_link", e.target.value); setLocState(null); }} onBlur={resolveLink} dir="ltr" placeholder="الصق رابط خرائط جوجل" style={{ ...inp, flex: 1 }} />
            <button type="button" onClick={resolveLink} disabled={locState === "checking"}
              style={{ padding: "8px 12px", background: locState === "ok" ? "#15803d" : "#0f766e", color: "#fff", border: "none", borderRadius: 10, fontSize: 11, fontWeight: 800, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>
              {locState === "checking" ? "…" : locState === "ok" ? "✓ تم" : "✅ تحقق"}
            </button>{/* v3.3.959 */}
            <button type="button" onClick={() => { useCenter(); setLocState("ok"); }} style={{ padding: "8px 10px", background: "#fff", border: "1.5px solid #bbf7d0", color: "#15803d", borderRadius: 10, fontSize: 11, fontWeight: 800, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>مركز الخريطة</button>
          </div>
          <div style={{ fontSize: 11, fontWeight: 700, marginTop: 4, color: locState === "fail" ? "#dc2626" : locState === "checking" ? "#b45309" : f.lat !== "" ? "#15803d" : "#94a3b8" }} dir={locState === "fail" || locState === "checking" ? "rtl" : "ltr"}>
            {locState === "checking" ? "⏳ جارٍ التحقق من الرابط…"
              : locState === "fail" ? "✗ لم يُستخرج موقع من الرابط — تأكد أنه رابط خرائط جوجل صحيح"
              : f.lat !== "" ? `✓ الموقع صحيح — ${Number(f.lat).toFixed(7)}, ${Number(f.lng).toFixed(7)}` : "لم يُحدد الموقع بعد"}
          </div>{/* v3.3.959 */}
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
          <div><L t="المساحة (م²)" /><input value={f.area_sqm} onChange={(e) => set("area_sqm", e.target.value)} inputMode="numeric" style={inp} /></div>
          <div><L t="نوع الأرض" />
            <select value={f.land_type} onChange={(e) => set("land_type", e.target.value)} style={inp}>
              <option value="">— اختر —</option><option>سكني</option><option>تجاري</option><option>سكني تجاري</option><option>زراعي</option>
            </select></div>
          <div><L t="عدد الشوارع" /><input value={f.streets_count} onChange={(e) => set("streets_count", e.target.value)} inputMode="numeric" style={inp} /></div>
          <div><L t="عرض الشوارع (م)" /><input value={f.street_widths} onChange={(e) => set("street_widths", e.target.value)} placeholder="مثال: 20، 15" style={inp} /></div>
          <div><L t="سعر المتر (ر.س)" /><input value={f.price_per_sqm} onChange={(e) => set("price_per_sqm", e.target.value)} inputMode="numeric" style={inp} /></div>
          <div><L t="السعر الإجمالي (ر.س)" /><input value={f.total_price} onChange={(e) => set("total_price", e.target.value)} inputMode="numeric" style={inp} /></div>
          <div><L t="المالك" /><input value={f.owner_name} onChange={(e) => set("owner_name", e.target.value)} style={inp} /></div>
          <div><L t="جوال المالك" /><input value={f.owner_phone} onChange={(e) => set("owner_phone", e.target.value)} inputMode="tel" dir="ltr" style={inp} /></div>
          <div><L t="الوسيط" /><input value={f.broker_name} onChange={(e) => set("broker_name", e.target.value)} style={inp} /></div>
          <div><L t="جوال الوسيط" /><input value={f.broker_phone} onChange={(e) => set("broker_phone", e.target.value)} inputMode="tel" dir="ltr" style={inp} /></div>
        </div>
        <L t="ملاحظات" /><textarea value={f.notes} onChange={(e) => set("notes", e.target.value)} rows={3} style={{ ...inp, resize: "vertical" }} />
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 12 }}>
          <button onClick={onClose} style={{ padding: "10px 16px", background: "#fff", border: "1.5px solid #e2e8f0", color: "#64748b", borderRadius: 10, fontSize: 12.5, cursor: "pointer", fontFamily: "inherit" }}>إلغاء</button>
          <button onClick={save} disabled={busy} style={{ padding: "10px 22px", background: "#15803d", color: "#fff", border: "none", borderRadius: 10, fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>{busy ? "جارٍ الحفظ…" : "💾 حفظ الأرض"}</button>
        </div>
      </div>
    </div>
  , document.body);
}

// ═══════ v3.4.236 — كشف حجوزات دليلك في التطبيق (كل المسوّقين — بلا تفاصيل الدلالة) ═══════
function PortalDalilakReservations({ user }) { // v3.4.244 — تابان: قائمة حجوزاتي / إحصائياتي (+ الكشف الكامل لمن يملكه)
  const seeAll = !!user.can_view_reservations, seeOwn = !!user.can_view_own_reservations;
  const [tab, setTab] = useState(seeOwn ? "mine" : "all"); // mine | stats | all
  const [list, setList] = useState(null);
  const [q, setQ] = useState("");
  const [linked, setLinked] = useState(true);
  const [sales, setSales] = useState(null);
  const [days, setDays] = useState(30);
  const [months, setMonths] = useState(12); // v3.4.246
  const scope = tab === "all" ? "all" : "mine";
  useEffect(() => { if (tab === "stats") return; setList(null); const t = setTimeout(() => api(`/dalilak-reservations?${scope === "mine" ? "mine=1&" : ""}${q.trim() ? "search=" + encodeURIComponent(q.trim()) : ""}`).then(d => { setList(d.reservations || []); setLinked(d.linked !== false); }).catch(() => setList([])), 250); return () => clearTimeout(t); }, [q, scope, tab]);
  useEffect(() => { if (tab !== "stats") return; setSales(null); api(`/my-sales?days=${days}&months=${months}`).then(setSales).catch(() => setSales({ linked: false })); }, [tab, days, months]); // v3.4.246
  const col = (st) => /لم تتم|ملغي/.test(st || "") ? ["#fee2e2", "#991b1b"] : /تمت/.test(st || "") ? ["#dcfce7", "#166534"] : ["#fef9c3", "#854d0e"];
  const fmtN = (n) => Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 0 });
  const seg = (k, l) => (
    <button key={k} type="button" onClick={() => setTab(k)} style={{ flex: 1, padding: "9px 6px", borderRadius: 10, border: "1.5px solid " + (tab === k ? "#0f766e" : "#e2e8f0"), background: tab === k ? "#0f766e" : "#fff", color: tab === k ? "#fff" : "#475569", fontWeight: 800, fontSize: 12.5, cursor: "pointer", fontFamily: "inherit" }}>{l}</button>
  );
  const card = (label, val, color, sub) => (
    <div style={{ background: "#fff", borderRadius: 12, padding: "10px 8px", textAlign: "center", boxShadow: "0 2px 10px rgba(0,0,0,0.05)" }}>
      <div style={{ fontSize: 20, fontWeight: 900, color }}>{val ?? "—"}</div>
      <div style={{ fontSize: 10.5, color: "#64748b", fontWeight: 700 }}>{label}</div>
      {sub && <div style={{ fontSize: 9.5, color: "#94a3b8" }}>{sub}</div>}
    </div>
  );
  const box = (title, children) => (
    <div style={{ background: "#fff", borderRadius: 16, padding: "12px 12px", boxShadow: "0 4px 20px rgba(0,0,0,0.06)", marginBottom: 12 }}>
      <div style={{ fontSize: 13, fontWeight: 900, color: "#0f172a", marginBottom: 8 }}>{title}</div>{children}
    </div>
  );
  const rowsList = (list || []);
  return (
    <div>
      <div style={{ fontSize: 17, fontWeight: 900, color: "#0f172a", marginBottom: 8 }}>🏠 الحجوزات</div>
      <div style={{ display: "flex", gap: 6, marginBottom: 12 }}>
        {seeOwn && seg("mine", "📋 قائمة حجوزاتي")}
        {seeOwn && seg("stats", "📊 إحصائياتي")}
        {seeAll && seg("all", "🏢 الكشف الكامل")}
      </div>
      {tab !== "stats" && (<>
        <div style={{ fontSize: 11.5, color: "#64748b", marginBottom: 10 }}>{tab === "all" ? "كشف مشترك: كل حجز فيه مسوّق داخلي (داخلي أو داخلي/خارجي)" : "الحجوزات المربوطة باسمك في قائمة المسوّقين"}{!linked && tab === "mine" ? " — حسابك غير مربوط باسم مسوّق بعد (يُربط من الإدارة)" : ""}</div>
        <input value={q} onChange={e => setQ(e.target.value)} placeholder="🔍 بحث: عميل / رقم / مسوّق / وحدة…" style={{ ...inputS, marginBottom: 10 }} />
        {list === null ? <div style={{ textAlign: "center", color: "#94a3b8", padding: 30 }}>جارٍ التحميل…</div>
          : rowsList.length === 0 ? <div style={{ textAlign: "center", color: "#94a3b8", padding: 30, fontSize: 13 }}>لا توجد حجوزات</div>
          : rowsList.map(r => { const c = col(r.operation_status); return (
            <div key={r.id} style={{ background: "#fff", borderRadius: 14, boxShadow: "0 2px 10px rgba(0,0,0,0.05)", marginBottom: 10, padding: "12px 14px", border: r.mine ? "1.5px solid #99f6e4" : "1.5px solid transparent" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontWeight: 800, fontSize: 14, color: "#0f172a", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{r.client_name || "—"} <span style={{ fontSize: 10.5, color: "#94a3b8", fontFamily: "monospace" }}>#{r.serial_number || r.id}</span></div>
                  <div style={{ fontSize: 11.5, color: "#475569", marginTop: 2 }}>{r.project_name || "—"}{r.selected_unit_code ? ` • ${r.selected_unit_code}` : ""} • {String(r.operation_type || "").replace("حجز ", "")}</div>
                  <div style={{ fontSize: 11, color: "#64748b", marginTop: 2 }}>👤 {r.marketers || "—"}</div>
                </div>
                <div style={{ textAlign: "left", flexShrink: 0 }}>
                  <span style={{ background: c[0], color: c[1], borderRadius: 12, padding: "3px 10px", fontSize: 11, fontWeight: 800, whiteSpace: "nowrap" }}>{r.operation_status || "—"}</span>
                  <div style={{ fontSize: 12, fontWeight: 900, color: "#1e40af", marginTop: 4, direction: "ltr" }}>{r.value ? fmtN(r.value) + " ر.س" : ""}</div>
                  <div style={{ fontSize: 9.5, color: "#94a3b8", marginTop: 2 }}>{String(r.date || "").slice(0, 10)}</div>
                </div>
              </div>
            </div>
          ); })}
      </>)}
      {tab === "stats" && (<>
        <div style={{ display: "flex", gap: 4, marginBottom: 10 }}>{[7, 30, 90, 365].map(d => <button key={d} type="button" onClick={() => setDays(d)} style={{ flex: 1, padding: "6px", borderRadius: 8, border: "1.5px solid " + (days === d ? "#0f766e" : "#e2e8f0"), background: days === d ? "#f0fdfa" : "#fff", color: days === d ? "#0f766e" : "#64748b", fontWeight: 800, fontSize: 11, cursor: "pointer", fontFamily: "inherit" }}>{d} يوم</button>)}</div>
        {!sales ? <div style={{ textAlign: "center", color: "#94a3b8", padding: 20 }}>جارٍ التحميل…</div>
        : !sales.linked ? <div style={{ background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 12, padding: 14, fontSize: 12.5, color: "#92400e", fontWeight: 700 }}>⚠️ حسابك غير مربوط باسم مسوّق في قائمة المسوّقين — اطلب من الإدارة ربطه لتظهر إحصائياتك.</div>
        : (<>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8, marginBottom: 10 }}>
            {card("حجوزاتي (الكل)", sales.total, "#0f172a")}{card("تمت", sales.sold, "#166534")}{card("قيد الإجراء", sales.pending, "#92400e")}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8, marginBottom: 10 }}>
            {card("لم تتم", sales.lost, "#991b1b")}{card(`آخر ${sales.days} يوم`, sales.recent_count, "#0f766e", `تمت منها ${sales.sold_recent ?? 0}`)}{card("هذا الشهر", sales.this_month, "#1d4ed8")}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 12 }}>
            {card("قيمة مبيعاتي المكتملة", `${fmtN(sales.sold_value)} ر.س`, "#1e40af")}{card("نسبة الإتمام", `${sales.total ? Math.round(sales.sold / sales.total * 100) : 0}%`, "#0f766e", "تمت ÷ الكل")}
          </div>
          {box("🗂 حسب الحالة", (sales.by_status || []).length === 0 ? <div style={{ fontSize: 11.5, color: "#94a3b8" }}>—</div> : (sales.by_status || []).map(x => { const c = col(x.s); return (
            <div key={x.s} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 12, padding: "5px 0", borderBottom: "1px dashed #f1f5f9" }}>
              <span style={{ background: c[0], color: c[1], borderRadius: 10, padding: "2px 9px", fontSize: 11, fontWeight: 800 }}>{x.s}</span><b style={{ marginInlineStart: "auto" }}>{x.n}</b><span style={{ color: "#64748b", direction: "ltr" }}>{fmtN(x.v)} ر.س</span>
            </div>); }))}
          {box("🏗 حسب المشروع", (sales.by_project || []).length === 0 ? <div style={{ fontSize: 11.5, color: "#94a3b8" }}>—</div> : (sales.by_project || []).map(x => (
            <div key={x.k} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 12, padding: "5px 0", borderBottom: "1px dashed #f1f5f9" }}>
              <span style={{ flex: 1, fontWeight: 700 }}>{x.k}</span><span style={{ color: "#64748b" }}>{x.n} حجز</span><span style={{ color: "#166534", fontWeight: 800 }}>{x.sold} تمت</span><span style={{ color: "#1e40af", direction: "ltr" }}>{fmtN(x.sold_value)}</span>
            </div>)))}
          {box(<span style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}><span>📆 {months ? `آخر ${months} شهرًا` : "منذ البداية"}</span>{[[12, "12 شهرًا"], [18, "18 شهرًا"], [24, "24 شهرًا"], [0, "منذ البداية"]].map(([m, l]) => <button key={m} type="button" onClick={() => setMonths(m)} style={{ padding: "3px 9px", borderRadius: 8, border: "1.5px solid " + (months === m ? "#0f766e" : "#e2e8f0"), background: months === m ? "#f0fdfa" : "#fff", color: months === m ? "#0f766e" : "#64748b", fontWeight: 800, fontSize: 10.5, cursor: "pointer", fontFamily: "inherit" }}>{l}</button>)}</span>, (sales.monthly || []).length === 0 ? <div style={{ fontSize: 11.5, color: "#94a3b8" }}>—</div> : (
            <div style={{ display: "flex", alignItems: "flex-end", gap: 5, height: 110 }}>
              {(() => { const max = Math.max(1, ...sales.monthly.map(m => m.n)); return sales.monthly.map(m => (
                <div key={m.ym} title={`${m.ym}: ${m.n} حجز — ${m.sold} تمت`} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-end", height: "100%" }}>
                  <div style={{ fontSize: 9, fontWeight: 800, color: "#0f766e" }}>{m.n}</div>
                  <div style={{ width: "100%", height: `${Math.max(3, m.n / max * 80)}px`, background: "#e2e8f0", borderRadius: "4px 4px 0 0", position: "relative" }}><div style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: `${m.n ? m.sold / m.n * 100 : 0}%`, background: "linear-gradient(180deg,#14b8a6,#0f766e)", borderRadius: "4px 4px 0 0" }} /></div>
                  <div style={{ fontSize: 8.5, color: "#94a3b8", marginTop: 3 }}>{m.ym.slice(2)}</div>
                </div>)); })()}
            </div>))}
          {box("🕒 أحدث حجوزاتي", (sales.recent || []).length === 0 ? <div style={{ fontSize: 11.5, color: "#94a3b8" }}>لا حجوزات بعد</div> : sales.recent.map(r => { const c = col(r.operation_status); return (
            <div key={r.id} style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 12, padding: "6px 0", borderBottom: "1px dashed #f1f5f9" }}>
              <div style={{ flex: 1, minWidth: 0 }}><b>{r.client_name}</b> <span style={{ color: "#64748b" }}>{r.project_name || ""}{r.selected_unit_code ? " • " + r.selected_unit_code : ""}</span></div>
              <span style={{ background: c[0], color: c[1], borderRadius: 10, padding: "2px 8px", fontSize: 10.5, fontWeight: 800, whiteSpace: "nowrap" }}>{r.operation_status}</span>
              <span style={{ color: "#94a3b8", fontSize: 10.5, whiteSpace: "nowrap" }}>{String(r.date || "").slice(0, 10)}</span>
            </div>); }))}
        </>)}
      </>)}
    </div>
  );
}

function PortalOffers() {
  const [data, setData] = useState(null); // {projects, mapbox_token}
  const [sel, setSel] = useState(null);
  const [sheet, setSheet] = useState(false);
  const [q, setQ] = useState(""); // v3.4.101 — بحث باسم المشروع/المطوّر/الحي
  const [mapReady, setMapReady] = useState(0);
  const [distFilter, setDistFilter] = useState([]);
  const [typeFilter, setTypeFilter] = useState([]);
  const [priceMin, setPriceMin] = useState(""); const [priceMax, setPriceMax] = useState("");
  const [areaMin, setAreaMin] = useState(""); const [areaMax, setAreaMax] = useState("");
  const [imgUrls, setImgUrls] = useState({}); // fid → blobUrl
  const mapRef = useRef(null); const mapEl = useRef(null); const markersRef = useRef([]);
  const wrapRef = useRef(null); // v3.3.848 — حاوية ملء الشاشة
  // v3.4.294 — ارتفاع الخريطة يُقاس فعليًا: من أعلى الحاوية حتى بداية شريط التابات السفلي
  const [mapH, setMapH] = useState(0);
  useEffect(() => {
    const measure = () => {
      const el = wrapRef.current; if (!el) return;
      if (document.fullscreenElement || document.webkitFullscreenElement || el.classList.contains("maplibregl-pseudo-fullscreen")) return;
      const nav = document.querySelector(".pnav-bar");
      const navH = nav ? nav.getBoundingClientRect().height : 0;
      const top = el.getBoundingClientRect().top;
      const base = Math.max(240, Math.round(window.innerHeight - top - navH - 10));
      setMapH(base);
      // v3.4.329 — تصحيح ثانٍ بعد الرسم: إن بقي تمرير رأسي في حاوية التطبيق (padding/هوامش أسفل الخريطة) تُصغَّر الخريطة بمقداره
      requestAnimationFrame(() => setTimeout(() => {
        const sc = document.getElementById("portal-scroll") || document.scrollingElement;
        const over = sc ? sc.scrollHeight - sc.clientHeight : 0;
        if (over > 0) setMapH(Math.max(240, base - over - 2));
      }, 30));
    };
    const raf = requestAnimationFrame(measure);
    const t = setTimeout(measure, 350);
    const t2 = setTimeout(measure, 1200); // v3.4.329 — بعد اكتمال الخطوط/الفلاتر
    window.addEventListener("resize", measure);
    window.visualViewport?.addEventListener("resize", measure);
    return () => { cancelAnimationFrame(raf); clearTimeout(t); clearTimeout(t2); window.removeEventListener("resize", measure); window.visualViewport?.removeEventListener("resize", measure); };
  }, []);
  useEffect(() => { if (mapRef.current) setTimeout(() => mapRef.current && mapRef.current.resize(), 60); }, [mapH]);
  // v3.4.294 — ملء الشاشة (حقيقي أو pseudo): يُخفى شريط التابات عبر صنف على body
  useEffect(() => {
    const el = wrapRef.current; if (!el) return;
    const sync = () => {
      const full = !!(document.fullscreenElement === el || document.webkitFullscreenElement === el || el.classList.contains("maplibregl-pseudo-fullscreen"));
      document.body.classList.toggle("portal-map-full", full);
      setTimeout(() => mapRef.current && mapRef.current.resize(), 80);
    };
    document.addEventListener("fullscreenchange", sync); document.addEventListener("webkitfullscreenchange", sync);
    const mo = new MutationObserver(sync); mo.observe(el, { attributes: true, attributeFilter: ["class"] });
    return () => { document.removeEventListener("fullscreenchange", sync); document.removeEventListener("webkitfullscreenchange", sync); mo.disconnect(); document.body.classList.remove("portal-map-full"); };
  }, []);
  // v3.3.880 — ثلاثة أزرار: خريطة | قائمة العروض | إضافة عرض
  const [viewMode, setViewMode] = useState("map"); // map | list
  const [addOpen, setAddOpen] = useState(false);
  const [smartOfferOpen, setSmartOfferOpen] = useState(false); // v3.3.960
  const [addInit, setAddInit] = useState(null); // تعبئة مسبقة من التحليل الذكي
  const [editOffer, setEditOffer] = useState(null); // v3.4.095 — عرض قيد التعديل (المضيف أو المدير العام)
  const reload = () => api("/property-offers").then(setData).catch(() => {});
  const token = localStorage.getItem(TOKEN_KEY);
  // v3.4.095 — حذف عرض (حذف ناعم في النظام)
  const deleteOffer = async (p) => {
    if (!window.confirm(`حذف العرض «${p.name}»؟ سيختفي من الخريطة والقائمة.`)) return;
    try { await api(`/property-offers/${p.id}`, { method: "DELETE" }); setSel(null); reload(); }
    catch (e) { alert(e.message || "فشل الحذف"); }
  };
  const editBtn = (p, small) => p.can_edit ? (
    <>
      <button onClick={(e) => { e.stopPropagation(); setEditOffer(p); }} title="تعديل العرض"
        style={{ padding: small ? "5px 10px" : "8px 14px", background: "#fff7ed", color: "#c2410c", border: "1px solid #fed7aa", borderRadius: 9, fontSize: small ? 11 : 12, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>✏️ تعديل</button>
      <button onClick={(e) => { e.stopPropagation(); deleteOffer(p); }} title="حذف العرض"
        style={{ padding: small ? "5px 10px" : "8px 14px", background: "#fff1f2", color: "#dc2626", border: "1px solid #fecaca", borderRadius: 9, fontSize: small ? 11 : 12, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>🗑 حذف</button>
    </>
  ) : null;

  useEffect(() => { api("/property-offers").then(setData).catch(() => setData({ projects: [] })); }, []);

  useEffect(() => {
    if (!mapEl.current || mapRef.current || !data) return;
    const map = new maplibregl.Map({ container: mapEl.current, style: buildStyle(data.mapbox_token), center: DEFAULT_CENTER, zoom: 10, attributionControl: false });
    map.addControl(new maplibregl.NavigationControl({ visualizePitch: false, showCompass: false }), "top-left");
    map.addControl(new maplibregl.FullscreenControl(wrapRef.current ? { container: wrapRef.current } : {}), "top-left"); // v3.3.848 — ملء الشاشة (للحاوية كلها حتى تبقى الفلاتر والبطاقة)
    map.addControl(new maplibregl.GeolocateControl({ positionOptions: { enableHighAccuracy: true } }), "top-left");
    map.on("load", () => { mapRef.current = map; setTimeout(() => map.resize(), 50); setMapReady(x => x + 1); });
    return () => { map.remove(); mapRef.current = null; };
  }, [data]);

  const projects = data?.projects || [];
  const projAvailTypes = (p) => {
    const s = new Set((p.unit_types_available || "").split("،").map(x => x.trim()).filter(Boolean));
    (p.units || []).forEach(u => { if (u.unit_type && u.availability !== "مباع") s.add(String(u.unit_type).trim()); });
    return s;
  };
  const availTypeSet = new Set();
  projects.forEach(p => projAvailTypes(p).forEach(t => availTypeSet.add(t)));
  const distOptions = [...new Set(projects.map(p => (p.district || "").trim()).filter(Boolean))].sort((a, b) => a.localeCompare(b, "ar"));
  const nv = (x) => (x === "" || isNaN(Number(x)) ? null : Number(x));
  const activeFilters = distFilter.length + typeFilter.length + (priceMin !== "" || priceMax !== "" ? 1 : 0) + (areaMin !== "" || areaMax !== "" ? 1 : 0);

  const nq = q.trim().toLowerCase();
  const filtered = projects.filter(p => {
    if (nq && ![p.name, p.developer_name, p.district, p.city].some(v => String(v || "").toLowerCase().includes(nq))) return false; // v3.4.101
    if (distFilter.length && !distFilter.includes((p.district || "").trim())) return false;
    if (typeFilter.length) { const ts = projAvailTypes(p); if (!typeFilter.some(t => ts.has(t))) return false; }
    const lo = nv(priceMin), hi = nv(priceMax);
    if (lo != null || hi != null) {
      const prices = [p.price_from, p.price_to, ...(p.units || []).flatMap(u => [u.price_from, u.price_to])].map(Number).filter(v => !isNaN(v) && v > 0);
      if (!prices.length) return false;
      if (lo != null && Math.max(...prices) < lo) return false;
      if (hi != null && Math.min(...prices) > hi) return false;
    }
    const aLo = nv(areaMin), aHi = nv(areaMax);
    if (aLo != null || aHi != null) {
      const areas = (p.units || []).flatMap(u => [u.area_from, u.area_to]).map(Number).filter(v => !isNaN(v) && v > 0);
      if (!areas.length) return false;
      if (aLo != null && Math.max(...areas) < aLo) return false;
      if (aHi != null && Math.min(...areas) > aHi) return false;
    }
    return true;
  });

  // الدبابيس — v3.4.101: دبوس زجاجي داكن بنقطة، يتقلّص إلى نقطة عند التصغير (أقل تزاحمًا)، ويُضاء المختار
  useEffect(() => {
    const map = mapRef.current; if (!map) return;
    markersRef.current.forEach(m => m.remove()); markersRef.current = [];
    const mini = () => map.getZoom() < 11.2;
    filtered.forEach(p => {
      if (p.lat == null || p.lng == null) return;
      const el = document.createElement("div");
      el.className = "pm" + (mini() ? " mini" : "") + (sel && sel.id === p.id ? " on" : "");
      el.innerHTML = `<i></i><span>${String(p.name || "").replace(/[<>&]/g, "")}</span>`;
      el.title = p.name || "";
      el.addEventListener("click", (e) => { e.stopPropagation(); setSel(p); setSheet(false); });
      markersRef.current.push(new maplibregl.Marker({ element: el, anchor: "bottom" }).setLngLat([p.lng, p.lat]).addTo(map));
    });
    const onZoom = () => { const m = mini(); markersRef.current.forEach(mk => mk.getElement().classList.toggle("mini", m)); };
    map.on("zoom", onZoom);
    return () => { map.off("zoom", onZoom); };
  }, [mapReady, data, distFilter, typeFilter, priceMin, priceMax, areaMin, areaMax, q, sel]); // deps مقصودة (filtered مشتق منها)

  // صور البطاقة (بالتوكن → blob)
  useEffect(() => {
    if (!sel) return;
    const imgs = (sel.files || []).filter(f => f.kind === "image").slice(0, 6);
    imgs.forEach(f => {
      if (imgUrls[f.id]) return;
      if (f.url) { setImgUrls(v => ({ ...v, [f.id]: f.url })); return; }
      fetch(`/api/portal/property-offers/${sel.id}/files/${f.id}`, { headers: { Authorization: `Bearer ${token}` } })
        .then(r => r.ok ? r.blob() : null).then(b => { if (b) setImgUrls(v => ({ ...v, [f.id]: URL.createObjectURL(b) })); }).catch(() => {});
    });
  }, [sel]); // imgUrls/token مقصود عدم إدراجهما

  const openFile = async (f) => {
    try {
      if (f.url) { window.open(f.url, "_blank", "noopener"); return; }
      const r = await fetch(`/api/portal/property-offers/${sel.id}/files/${f.id}`, { headers: { Authorization: `Bearer ${token}` } });
      if (!r.ok) throw new Error();
      const b = await r.blob();
      window.open(URL.createObjectURL(b), "_blank", "noopener");
    } catch { /* تجاهل */ }
  };

  const chipBtn = (on, disabled) => ({ // v3.4.101 — شرائح بلون التطبيق (تركوازي) بدل البنفسجي
    padding: "8px 13px", borderRadius: 999, fontSize: 12.5, fontWeight: on ? 800 : 600, fontFamily: "inherit",
    cursor: disabled ? "not-allowed" : "pointer", transition: "all .15s",
    border: on ? "1.5px solid #0f766e" : "1px solid #e2e8f0",
    background: disabled ? "#f1f5f9" : on ? "#0f766e" : "#fff",
    color: disabled ? "#cbd5e1" : on ? "#fff" : "#334155",
  });
  const activeChips = [
    ...distFilter.map(d => ({ k: "d", v: d, l: `📍 ${d}`, off: () => setDistFilter(p => p.filter(x => x !== d)) })),
    ...typeFilter.map(t => ({ k: "t", v: t, l: `🛏 ${t}`, off: () => setTypeFilter(p => p.filter(x => x !== t)) })),
    ...(priceMin !== "" || priceMax !== "" ? [{ k: "p", v: "p", l: `💵 ${priceMin || "0"} – ${priceMax || "∞"}`, off: () => { setPriceMin(""); setPriceMax(""); } }] : []),
    ...(areaMin !== "" || areaMax !== "" ? [{ k: "a", v: "a", l: `📐 ${areaMin || "0"} – ${areaMax || "∞"} م²`, off: () => { setAreaMin(""); setAreaMax(""); } }] : []),
  ];
  const clearAll = () => { setDistFilter([]); setTypeFilter([]); setPriceMin(""); setPriceMax(""); setAreaMin(""); setAreaMax(""); };
  const inpS = { width: "100%", padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 13, fontFamily: "inherit", boxSizing: "border-box", direction: "ltr", textAlign: "right" };
  const brochure = sel && (sel.files || []).find(f => f.kind === "brochure");
  const video = sel && ((sel.files || []).find(f => f.kind === "video") || (sel.video_url ? { url: sel.video_url } : null));
  const selImgs = sel ? (sel.files || []).filter(f => f.kind === "image").slice(0, 6) : [];

  return (
    <>
    {/* v3.4.101 — شريط أدوات هادئ: مبدّل خريطة/قائمة + بحث + تصفية + إجراءات الإضافة */}
    <style>{`
      .pm{display:flex;align-items:center;gap:6px;padding:5px 10px 5px 8px;border-radius:999px;background:rgba(15,23,42,.86);color:#fff;font-size:11px;font-weight:800;white-space:nowrap;border:1px solid rgba(255,255,255,.35);box-shadow:0 6px 16px rgba(0,0,0,.35);cursor:pointer;font-family:inherit;backdrop-filter:blur(6px);transition:transform .15s}
      .pm i{width:9px;height:9px;border-radius:50%;background:#2dd4bf;box-shadow:0 0 0 3px rgba(45,212,191,.25);flex:none}
      .pm:hover{transform:translateY(-2px)}
      .pm.mini{padding:4px}.pm.mini span{display:none}
      .pm.on{background:#0f766e;border-color:#99f6e4}.pm.on i{background:#fff}
      body.portal-map-full .pnav-bar{display:none!important}
      .portal-map-wrap.maplibregl-pseudo-fullscreen{border-radius:0!important;z-index:2147483000!important}
      .portal-map-wrap:fullscreen{border-radius:0!important}
      .seg{display:inline-flex;background:#f1f5f9;border-radius:12px;padding:3px;border:1px solid #e2e8f0}
      .seg button{border:none;background:transparent;padding:8px 14px;border-radius:10px;font:inherit;font-size:12.5px;font-weight:800;color:#64748b;cursor:pointer;transition:all .15s;white-space:nowrap}
      .seg button.on{background:#fff;color:#0f766e;box-shadow:0 2px 8px rgba(15,23,42,.10)}
    `}</style>
    <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 8, flexWrap: "wrap" }}>
      <div className="seg">
        <button className={viewMode === "map" ? "on" : ""} onClick={() => setViewMode("map")}>🗺 خريطة</button>
        <button className={viewMode === "list" ? "on" : ""} onClick={() => setViewMode("list")}>📋 قائمة</button>
      </div>
      <input value={q} onChange={e => setQ(e.target.value)} placeholder="🔍 ابحث باسم المشروع أو المطوّر أو الحي…"
        style={{ flex: "1 1 200px", padding: "10px 12px", border: "1px solid #e2e8f0", borderRadius: 12, fontSize: 13.5, fontFamily: "inherit", outline: "none", background: "#fff", minWidth: 160 }} />
      <button onClick={() => { setSheet(v => !v); setSel(null); }} title="التصفية"
        style={{ padding: "10px 14px", borderRadius: 12, border: "1.5px solid " + (activeFilters ? "#0f766e" : "#e2e8f0"), background: activeFilters ? "#ccfbf1" : "#fff", color: "#0f766e", fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>
        ⚙ تصفية{activeFilters ? ` (${activeFilters})` : ""}
      </button>
      <button onClick={() => setSmartOfferOpen(true)} title="إضافة عرض بذكاء من نص أو PDF"
        style={{ padding: "10px 12px", borderRadius: 12, border: "1.5px solid #ddd6fe", background: "#f5f3ff", color: "#6d28d9", fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>✨ بذكاء</button>
      <button onClick={() => setAddOpen(true)}
        style={{ padding: "10px 14px", borderRadius: 12, border: "none", background: "linear-gradient(135deg,#0f766e,#14b8a6)", color: "#fff", fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit", boxShadow: "0 6px 16px rgba(15,118,110,.28)", whiteSpace: "nowrap" }}>＋ إضافة عرض</button>
    </div>
    {activeChips.length > 0 && (
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 8, alignItems: "center" }}>
        {activeChips.map(c => (
          <button key={c.k + c.v} onClick={c.off} style={{ ...chipBtn(true, false), padding: "5px 10px", fontSize: 11.5 }}>{c.l} ✕</button>
        ))}
        <button onClick={clearAll} style={{ ...chipBtn(false, false), padding: "5px 10px", fontSize: 11.5, color: "#dc2626", borderColor: "#fecaca" }}>مسح الكل</button>
        <span style={{ fontSize: 11.5, color: "#64748b", marginInlineStart: "auto" }}>{filtered.length} من {projects.length}</span>
      </div>
    )}
    <div ref={wrapRef} className="portal-map-wrap" style={{ position: "relative", height: mapH ? mapH : "calc(100vh - 290px)", minHeight: 240, /* v3.4.329 */ borderRadius: 18, overflow: "hidden", border: "1px solid #e2e8f0", background: "#0f172a", boxShadow: "0 10px 30px rgba(15,23,42,.08)" }}>{/* v3.4.294 — الارتفاع مقاس حتى بداية التابات */}
      {!data ? (
        <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", color: "#94a3b8", fontSize: 13 }}>جاري تحميل العروض…</div>
      ) : (
        <div ref={mapEl} style={{ position: "absolute", inset: 0 }} />
      )}

      {/* عدّاد النتائج — v3.3.848: يمين الخريطة (كان يختفي خلف أزرار الزوم يسارًا) */}
      <div style={{ position: "absolute", top: 10, right: 10, background: "rgba(15,23,42,.78)", backdropFilter: "blur(8px)", borderRadius: 999, padding: "6px 12px", fontSize: 12, fontWeight: 800, color: "#fff", border: "1px solid rgba(255,255,255,.25)", boxShadow: "0 6px 18px rgba(0,0,0,.3)", zIndex: 4 }}>
        🏠 {filtered.length} عرض{activeFilters || nq ? ` · من ${projects.length}` : ""}
      </div>

      {/* بطاقة العرض المختار */}
      {sel && (
        <div dir="rtl" style={{ position: "absolute", bottom: 12, insetInlineStart: 10, insetInlineEnd: 10, background: "#fff", borderRadius: 16, boxShadow: "0 10px 40px rgba(0,0,0,0.35)", maxHeight: "66%", overflowY: "auto", zIndex: 5 }}>
          <div style={{ padding: "12px 14px", background: "linear-gradient(135deg,#134e4a,#0f766e)", color: "#fff", display: "flex", justifyContent: "space-between", alignItems: "center", position: "sticky", top: 0 }}>
            <div>
              <div style={{ fontWeight: 900, fontSize: 15 }}>🏢 {sel.name}</div>
              <div style={{ fontSize: 11.5, opacity: 0.9, marginTop: 2 }}>{[sel.developer_name && `🏗 ${sel.developer_name}`, sel.city, sel.district].filter(Boolean).join(" • ")}</div>
              {sel.created_by && <div style={{ fontSize: 11, opacity: 0.85, marginTop: 2 }}>👤 أضافه: {sel.created_by}</div>}{/* v3.3.942 */}
            </div>
            <button onClick={() => setSel(null)} style={{ background: "rgba(255,255,255,0.2)", border: "none", color: "#fff", borderRadius: 8, width: 28, height: 28, cursor: "pointer", fontSize: 14 }}>✕</button>
          </div>
          <div style={{ padding: 12 }}>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 5, marginBottom: 8 }}>
              {sel.readiness && <span style={{ background: sel.readiness === "جاهز" ? "#dcfce7" : "#fef3c7", color: sel.readiness === "جاهز" ? "#166534" : "#92400e", borderRadius: 10, padding: "3px 10px", fontSize: 11, fontWeight: 800 }}>🏗 {sel.readiness}</span>}
              {(sel.price_from != null || sel.price_to != null) && <span style={{ background: "#f0fdfa", color: "#0f766e", border: "1px solid #99f6e4", borderRadius: 10, padding: "3px 10px", fontSize: 11, fontWeight: 800 }}>💵 {nfmt(sel.price_from)}{sel.price_to != null && Number(sel.price_to) !== Number(sel.price_from) ? ` – ${nfmt(sel.price_to)}` : ""} ر.س</span>}
              {sel.developer_phone && <a href={`tel:${sel.developer_phone}`} style={{ background: "#eff6ff", color: "#1d4ed8", border: "1px solid #bfdbfe", borderRadius: 10, padding: "3px 10px", fontSize: 11, fontWeight: 800, textDecoration: "none" }}>📞 {sel.developer_phone}</a>}
            </div>
            {selImgs.length > 0 && (
              <div style={{ display: "flex", gap: 6, overflowX: "auto", marginBottom: 10, paddingBottom: 4 }}>
                {selImgs.map(f => imgUrls[f.id]
                  ? <img key={f.id} src={imgUrls[f.id]} alt="" onClick={() => openFile(f)} style={{ height: 84, borderRadius: 10, cursor: "pointer", flexShrink: 0 }} />
                  : <div key={f.id} style={{ width: 110, height: 84, borderRadius: 10, background: "#f1f5f9", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", color: "#94a3b8", fontSize: 11 }}>⏳</div>)}
              </div>
            )}
            {(sel.units || []).length > 0 && (
              <div style={{ border: "1px solid #e2e8f0", borderRadius: 10, overflow: "hidden", marginBottom: 10 }}>
                {(sel.units || []).map((u, i) => {
                  const sold = u.availability === "مباع";
                  return (
                    <div key={u.id || i} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, padding: "7px 10px", borderBottom: i < sel.units.length - 1 ? "1px solid #f1f5f9" : "none", opacity: sold ? 0.6 : 1 }}>
                      <div style={{ fontSize: 12.5 }}>
                        <b>{u.model_name || `نموذج ${i + 1}`}</b> — {[u.unit_type, u.area_from && `${nfmt(u.area_from)} م²`, u.facade].filter(Boolean).join(" • ")}
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: 6, flexShrink: 0 }}>
                        {(u.price_from ?? u.price_to) != null && <span style={{ fontSize: 12.5, fontWeight: 800, color: "#0f766e" }}>{nfmt(u.price_from ?? u.price_to)}</span>}
                        <span style={{ background: sold ? "#fee2e2" : "#dcfce7", color: sold ? "#991b1b" : "#166534", borderRadius: 8, padding: "1px 7px", fontSize: 10, fontWeight: 800 }}>{sold ? "مباع" : "متوفر"}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            {/* v3.3.921 — بطاقة الخريطة مختصرة: النماذج + البروشور/الفيديو + Google Maps فقط (بلا الوصف الطويل) */}
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
              {brochure && <button onClick={() => openFile(brochure)} style={{ padding: "8px 14px", background: "#0f766e", color: "#fff", border: "none", borderRadius: 9, fontSize: 12, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>📄 البروشور</button>}
              {video && <button onClick={() => openFile(video)} style={{ padding: "8px 14px", background: "#7c3aed", color: "#fff", border: "none", borderRadius: 9, fontSize: 12, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>🎬 الفيديو</button>}
              <a href={`https://www.google.com/maps?q=${sel.lat},${sel.lng}`} target="_blank" rel="noopener noreferrer"
                style={{ padding: "8px 14px", background: "#eff6ff", color: "#1d4ed8", border: "1px solid #bfdbfe", borderRadius: 9, fontSize: 12, fontWeight: 800, textDecoration: "none" }}>📍 Google Maps</a>
              {editBtn(sel, false)}{/* v3.4.095 */}
            </div>
          </div>
        </div>
      )}

      {/* v3.3.880 — قائمة العروض (فوق الخريطة عند اختيار وضع القائمة، تحترم الفلاتر) */}
      {viewMode === "list" && (
        <div dir="rtl" style={{ position: "absolute", inset: 0, background: "#f8fafc", zIndex: 4, overflowY: "auto", padding: 10 }}>
          {filtered.length === 0 && <div style={{ textAlign: "center", color: "#94a3b8", fontSize: 13, padding: 30 }}>لا توجد عروض مطابقة</div>}
          {filtered.map(p => (
            <div key={p.id} onClick={() => setSel(p)}
              style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 12, padding: "10px 12px", marginBottom: 8, cursor: "pointer" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ fontWeight: 800, fontSize: 14 }}>🏢 {p.name}</div>
                <span style={{ background: "#dcfce7", color: "#166534", borderRadius: 10, padding: "1px 8px", fontSize: 10, fontWeight: 800 }}>{p.status}</span>
              </div>
              <div style={{ fontSize: 11.5, color: "#64748b", marginTop: 2 }}>{[p.developer_name && `🏗 ${p.developer_name}`, p.city, p.district].filter(Boolean).join(" • ") || "—"}</div>
              <div style={{ fontSize: 11.5, color: "#0f766e", fontWeight: 700, marginTop: 4 }}>
                {(p.units || []).length
                  ? p.units.slice(0, 3).map(u => `${u.unit_type || "نموذج"}${(u.price_from ?? u.price_to) != null ? ` (${nfmt(u.price_from ?? u.price_to)})` : ""}`).join(" • ")
                  : (p.price_from != null || p.price_to != null ? `💵 ${nfmt(p.price_from)}${p.price_to != null ? ` – ${nfmt(p.price_to)}` : ""} ر.س` : "—")}
              </div>
              {p.created_by && <div style={{ fontSize: 10.5, color: "#94a3b8", marginTop: 3 }}>👤 أضافه: {p.created_by}</div>}{/* v3.3.942 */}
              {p.can_edit && <div style={{ display: "flex", gap: 6, marginTop: 6 }}>{editBtn(p, true)}</div>}{/* v3.4.095 */}
            </div>
          ))}
        </div>
      )}

      {/* v3.4.101 — شيت التصفية: خلفية معتمة + لوحة سفلية بمقبض وأقسام واضحة (بدل الشريط البنفسجي الدائم) */}
      {sheet && (
        <div onClick={() => setSheet(false)} style={{ position: "absolute", inset: 0, background: "rgba(15,23,42,.45)", zIndex: 7, backdropFilter: "blur(2px)" }} />
      )}
      <div dir="rtl" onClick={e => e.stopPropagation()} style={{ position: "absolute", bottom: 0, insetInlineStart: 0, insetInlineEnd: 0, zIndex: 8,
        transform: sheet ? "translateY(0)" : "translateY(110%)", transition: "transform .3s cubic-bezier(.2,.8,.2,1)",
        background: "#fff", borderRadius: "22px 22px 0 0", boxShadow: "0 -12px 40px rgba(15,23,42,.28)", maxHeight: "78%", display: "flex", flexDirection: "column" }}>
        <div style={{ padding: "10px 16px 6px", textAlign: "center" }}>
          <div style={{ width: 44, height: 5, borderRadius: 3, background: "#e2e8f0", margin: "0 auto 8px" }} />
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div style={{ fontSize: 15, fontWeight: 900, color: "#0f172a" }}>⚙ تصفية العروض</div>
            <button onClick={() => setSheet(false)} style={{ background: "#f1f5f9", border: "none", borderRadius: 8, width: 30, height: 30, cursor: "pointer", fontSize: 14, color: "#475569" }}>✕</button>
          </div>
        </div>
        <div style={{ padding: "4px 16px 12px", overflowY: "auto" }}>
          <div style={{ fontSize: 12, fontWeight: 800, color: "#0f766e", margin: "8px 0 8px" }}>📍 الأحياء</div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 8 }}>
            {distOptions.length === 0 && <span style={{ fontSize: 11.5, color: "#94a3b8" }}>لا توجد أحياء بعد</span>}
            {distOptions.map(d => { const on = distFilter.includes(d); return (
              <button key={d} onClick={() => setDistFilter(prev => on ? prev.filter(x => x !== d) : [...prev, d])} style={chipBtn(on, false)}>
                {on ? "✓ " : ""}{d}
              </button>
            ); })}
          </div>
          <div style={{ fontSize: 12, fontWeight: 800, color: "#0f766e", margin: "12px 0 8px" }}>🛏 نوع النماذج</div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 8 }}>
            {[...new Set([...OFFER_TYPES, ...availTypeSet])].map(t => {
              const on = typeFilter.includes(t);
              const disabled = !availTypeSet.has(t) && !on;
              return (
                <button key={t} disabled={disabled} onClick={() => !disabled && setTypeFilter(prev => on ? prev.filter(x => x !== t) : [...prev, t])}
                  style={chipBtn(on, disabled)} title={disabled ? "غير متوفر حاليًا" : undefined}>
                  {on ? "✓ " : ""}{t}
                </button>
              );
            })}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginTop: 12 }}>
            <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 12, padding: 10 }}>
              <div style={{ fontSize: 12, fontWeight: 800, color: "#0f766e", marginBottom: 6 }}>💵 السعر (ر.س)</div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6 }}>
                <input type="number" min="0" value={priceMin} onChange={e => setPriceMin(e.target.value)} placeholder="من" style={inpS} />
                <input type="number" min="0" value={priceMax} onChange={e => setPriceMax(e.target.value)} placeholder="إلى" style={inpS} />
              </div>
            </div>
            <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 12, padding: 10 }}>
              <div style={{ fontSize: 12, fontWeight: 800, color: "#0f766e", marginBottom: 6 }}>📐 المساحة (م²)</div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6 }}>
                <input type="number" min="0" value={areaMin} onChange={e => setAreaMin(e.target.value)} placeholder="من" style={inpS} />
                <input type="number" min="0" value={areaMax} onChange={e => setAreaMax(e.target.value)} placeholder="إلى" style={inpS} />
              </div>
            </div>
          </div>
        </div>
        <div style={{ display: "flex", gap: 8, padding: "10px 16px calc(14px + env(safe-area-inset-bottom))", borderTop: "1px solid #f1f5f9", background: "#fff" }}>
          <button onClick={() => setSheet(false)}
            style={{ flex: 1, padding: "12px", background: "linear-gradient(135deg,#0f766e,#14b8a6)", color: "#fff", border: "none", borderRadius: 12, fontSize: 13.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit", boxShadow: "0 6px 16px rgba(15,118,110,.28)" }}>
            عرض {filtered.length} {filtered.length === 1 ? "عرض" : "عروض"}
          </button>
          {activeFilters > 0 && (
            <button onClick={clearAll}
              style={{ padding: "12px 16px", background: "#fff", color: "#dc2626", border: "1px solid #fecaca", borderRadius: 12, fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>مسح الكل</button>
          )}
        </div>
      </div>
    </div>
    {/* v3.3.880 — نافذة إضافة عرض من التطبيق */}
    {smartOfferOpen && <PortalOfferSmart onClose={() => setSmartOfferOpen(false)} onParsed={(p) => {
      setSmartOfferOpen(false); setAddInit(p); setAddOpen(true);
      if (p.lat && p.lng && mapRef.current) mapRef.current.flyTo({ center: [p.lng, p.lat], zoom: 14 });
    }} />}{/* v3.3.960 */}
    {addOpen && <PortalAddOffer mapRef={mapRef} init={addInit || {}} onClose={() => { setAddOpen(false); setAddInit(null); }} onSaved={() => { setAddOpen(false); setAddInit(null); reload(); }} />}
    {editOffer && <PortalAddOffer mapRef={mapRef} init={editOffer} editId={editOffer.id} onClose={() => setEditOffer(null)} onSaved={() => { setEditOffer(null); setSel(null); reload(); }} />}{/* v3.4.095 */}
    </>
  );
}

// v3.3.880 — إضافة عرض مشروع من تطبيق المسوّقين (الموقع من مركز الخريطة الحالي)
// v3.3.919 — إضافة عرض عقاري من البوابة بكامل بيانات النظام الأساسي (مطوّر من القائمة، حي ببحث، وحدات، جاهزية، حالة، نماذج، فيديو/بروشور)
function PortalAddOffer({ mapRef, onClose, onSaved, init = {}, editId = null }) { // v3.3.960 — init من التحليل الذكي — v3.4.095: editId = تعديل عرض قائم
  const [f, setF] = useState({ name: init.name || "", developer_name: init.developer_name || "", developer_phone: init.developer_phone || "", city: init.city || "جدة", district: init.district || "", lat: init.lat ?? "", lng: init.lng ?? "", maps_link: init.maps_url || init.maps_link || "",
    total_units: init.total_units ?? "", available_units: init.available_units ?? "", unit_types: init.unit_types_available ? String(init.unit_types_available).split("،").map((s) => s.trim()).filter(Boolean) : [], readiness: init.readiness || "", status: init.status || "متاح", price_from: init.price_from ?? "", price_to: init.price_to ?? "", delivery_date: init.delivery_date || "", description: init.description || "",
    units: Array.isArray(init.units) ? init.units.map(u => ({ ...u, area_from: u.area_from ?? "", price_from: u.price_from ?? "", facade: u.facade || "", model_name: u.model_name || "", unit_type: u.unit_type || "", availability: u.availability || "متوفر" })) : [], video_url: editId ? "" : (init.video_url || ""), brochure_url: "" });
  // v3.4.095 — ملفات العرض القائمة (صور/بروشور/فيديو) مع إمكانية حذفها أثناء التعديل
  const [existingFiles, setExistingFiles] = useState(editId && Array.isArray(init.files) ? init.files : []);
  const removeExisting = async (fid) => {
    if (!window.confirm("حذف هذا الملف من العرض؟")) return;
    try { await api(`/property-offers/${editId}/files/${fid}`, { method: "DELETE" }); setExistingFiles(p => p.filter(x => x.id !== fid)); }
    catch (e) { alert(e.message || "فشل حذف الملف"); }
  };
  const [opts, setOpts] = useState({ developers: [], districts: {}, unit_types: [], facades: [], readiness: [], statuses: [] });
  const [videoFile, setVideoFile] = useState(null);
  const [imageFiles, setImageFiles] = useState([]); // v3.3.958 — صور متعددة
  const [brochureFile, setBrochureFile] = useState(null);
  const [saving, setSaving] = useState(false);
  const [progress, setProgress] = useState("");
  const [newDev, setNewDev] = useState(false);
  useEffect(() => { api("/offer-options").then(setOpts).catch(() => {}); }, []);
  const set = (k, v) => setF(p => ({ ...p, [k]: v }));
  const useCenter = () => {
    const c = mapRef.current?.getCenter();
    if (c) setF(p => ({ ...p, lat: c.lat.toFixed(6), lng: c.lng.toFixed(6) }));
    else alert("افتح الخريطة أولًا وحرّكها لموقع المشروع");
  };
  // v3.4.053 — تحديد الموقع بعدة طرق: رابط خرائط / مستنتج من الملف / إدخال يدوي / اختيار على الخريطة
  const [locState, setLocState] = useState(init.lat != null && init.lat !== "" ? "ok" : null); // null | checking | ok | fail
  const [locFromFile] = useState(init.lat != null && init.lat !== ""); // جاء من تحليل الـ PDF/النص
  const [picking, setPicking] = useState(false);
  const resolveLink = async () => {
    const link = (f.maps_link || "").trim();
    if (!link) return;
    setLocState("checking");
    try {
      const r = await api("/land-offers/parse", { method: "POST", body: { text: link } });
      if (r.lat && r.lng) {
        setF(p => ({ ...p, lat: String(r.lat), lng: String(r.lng) }));
        setLocState("ok");
        if (mapRef.current) mapRef.current.flyTo({ center: [r.lng, r.lat], zoom: 15 });
      } else setLocState("fail");
    } catch { setLocState("fail"); }
  };
  const startPick = () => {
    if (!mapRef.current) return alert("الخريطة غير جاهزة — أغلق النموذج وانتظر تحميل الخريطة ثم أعد المحاولة");
    if (f.lat && f.lng) { try { mapRef.current.flyTo({ center: [Number(f.lng), Number(f.lat)], zoom: 15 }); } catch {} }
    setPicking(true);
  };
  const confirmPick = () => {
    const c = mapRef.current?.getCenter();
    if (c) { setF(p => ({ ...p, lat: c.lat.toFixed(6), lng: c.lng.toFixed(6) })); setLocState("ok"); }
    setPicking(false);
  };
  const toggleType = (t) => setF(p => ({ ...p, unit_types: p.unit_types.includes(t) ? p.unit_types.filter(x => x !== t) : [...p.unit_types, t] }));
  const addUnit = () => setF(p => ({ ...p, units: [...p.units, { model_name: `نموذج ${p.units.length + 1}`, unit_type: p.unit_types[0] || "", area_from: "", facade: "", price_from: "", availability: "متوفر" }] }));
  const setUnit = (i, k, v) => setF(p => ({ ...p, units: p.units.map((u, j) => j === i ? { ...u, [k]: v } : u) }));
  const delUnit = (i) => setF(p => ({ ...p, units: p.units.filter((_, j) => j !== i) }));
  const pickDev = (name) => {
    const d = (opts.developers || []).find(x => x.name === name);
    setF(p => ({ ...p, developer_name: name, developer_phone: d?.phone || p.developer_phone }));
  };
  // v3.4.044 — رفع مع إعادة محاولة: «Failed to fetch» يعني انقطاع الطلب (شبكة جوال/حجم كبير) —
  // نعيد المحاولة مرتين تلقائيًا قبل إظهار رسالة مفهومة بدل نص المتصفح الخام
  const postFdRetry = async (url, fd, stepLabel) => {
    const token = localStorage.getItem(TOKEN_KEY);
    for (let attempt = 1; attempt <= 3; attempt++) {
      try {
        const r = await fetch(url, { method: "POST", headers: { Authorization: `Bearer ${token}` }, body: fd });
        if (!r.ok) { const d = await r.json().catch(() => ({})); throw new Error(d.error || `فشل ${stepLabel}`); }
        return;
      } catch (e) {
        const netFail = e instanceof TypeError || /failed to fetch|network/i.test(e.message);
        if (netFail && attempt < 3) { setProgress(`${stepLabel} — انقطع الاتصال، إعادة المحاولة ${attempt}/2…`); await new Promise(r => setTimeout(r, 2000 * attempt)); continue; }
        throw new Error(netFail ? `انقطع الاتصال أثناء ${stepLabel} — تحقق من الشبكة وأن حجم كل ملف ≤ 95MB ثم أعد المحاولة` : e.message);
      }
    }
  };
  const uploadFile = async (offerId, kind, file, url, stepLabel) => {
    const fd = new FormData(); fd.append("kind", kind); if (file) fd.append("files", file); if (url) fd.append("url", url);
    await postFdRetry(`/api/portal/property-offers/${offerId}/files`, fd, stepLabel || "رفع الملف");
  };
  const save = async () => {
    if (!f.name.trim()) return alert("اسم المشروع مطلوب");
    if (!f.lat || !f.lng) return alert("حدد موقع المشروع: الصق رابط خرائط، أو اكتب الإحداثيات، أو اختر من الخريطة");
    setSaving(true);
    try {
      setProgress("حفظ بيانات العرض…");
      const r = editId
        ? await api(`/property-offers/${editId}`, { method: "PUT", body: f }) // v3.4.095 — تعديل
        : await api("/property-offers", { method: "POST", body: f });
      const id = r.offer?.id;
      // v3.4.045 — تجميع الصور حسب الحجم: ≤45MB لكل طلب (الحد 95MB للملف والمدخل ~100MB للطلب) —
      // الدفعات الثابتة كانت تتجاوز حد المدخل فينقطع الطلب («Failed to fetch»)
      if (id && imageFiles.length) {
        let batch = [], size = 0, done = 0;
        const flush = async () => {
          if (!batch.length) return;
          const fd = new FormData(); fd.append("kind", "image");
          batch.forEach(im => fd.append("files", im));
          done += batch.length;
          setProgress(`رفع الصور… (${done}/${imageFiles.length})`);
          await postFdRetry(`/api/portal/property-offers/${id}/files`, fd, `رفع الصور (${done}/${imageFiles.length})`);
          batch = []; size = 0;
        };
        for (const im of imageFiles) {
          if (batch.length && (size + im.size > 45 * 1024 * 1024 || batch.length >= 5)) await flush();
          batch.push(im); size += im.size;
        }
        await flush();
      }
      if (id && (videoFile || f.video_url)) { setProgress("رفع الفيديو…"); await uploadFile(id, "video", videoFile, videoFile ? null : f.video_url, "رفع الفيديو"); }
      if (id && (brochureFile || f.brochure_url)) { setProgress("رفع البروشور…"); await uploadFile(id, "brochure", brochureFile, brochureFile ? null : f.brochure_url, "رفع البروشور"); }
      onSaved();
    } catch (e) { alert(e.message); }
    setSaving(false); setProgress("");
  };
  const inpP = { width: "100%", padding: "10px 12px", border: "1.5px solid #e2e8f0", borderRadius: 10, fontFamily: "inherit", fontSize: 14, boxSizing: "border-box", outline: "none", background: "#fff" };
  const lblP = { display: "block", fontSize: 12, fontWeight: 700, color: "#475569", marginBottom: 4 };
  const chip = (on, label, onClick, color = "#0f766e") => (
    <button key={label} type="button" onClick={onClick}
      style={{ padding: "8px 12px", borderRadius: 10, fontSize: 12.5, cursor: "pointer", fontFamily: "inherit", fontWeight: on ? 800 : 600,
        border: on ? `2px solid ${color}` : "1px solid #e2e8f0", background: on ? "#f0fdfa" : "#fff", color: on ? color : "#64748b" }}>{on ? "✓ " : "+ "}{label}</button>
  );
  const districts = (opts.districts || {})[f.city] || [];
  const modelTypes = f.unit_types.length ? f.unit_types : (opts.unit_types || []);
  // v3.4.053 — وضع الاختيار من الخريطة: يُخفى النموذج (بياناته محفوظة) ويظهر دبوس ثابت بمنتصف الخريطة الحيّة
  if (picking) return createPortal( /* v3.4.168 */
    <>
      <div style={{ position: "fixed", inset: 0, zIndex: 1000, pointerEvents: "none", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ fontSize: 40, transform: "translateY(-18px)", filter: "drop-shadow(0 3px 5px rgba(0,0,0,0.45))" }}>📍</div>
      </div>
      <div dir="rtl" style={{ position: "fixed", top: 12, left: 12, right: 12, zIndex: 1001, textAlign: "center", pointerEvents: "none" }}>
        <span style={{ background: "rgba(15,23,42,0.85)", color: "#fff", padding: "8px 16px", borderRadius: 20, fontSize: 12.5, fontWeight: 700, fontFamily: "inherit" }}>
          حرّك الخريطة حتى يصبح الدبوس على موقع المشروع
        </span>
      </div>
      <div dir="rtl" style={{ position: "fixed", left: 0, right: 0, bottom: 0, zIndex: 1001, background: "#fff", padding: 14, borderRadius: "18px 18px 0 0", boxShadow: "0 -8px 30px rgba(0,0,0,0.25)", display: "flex", gap: 10, fontFamily: "inherit" }}>
        <button type="button" onClick={confirmPick} style={{ flex: 1, padding: "12px", background: "#0f766e", color: "#fff", border: "none", borderRadius: 12, fontSize: 14, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>✓ تأكيد هذا الموقع</button>
        <button type="button" onClick={() => setPicking(false)} style={{ padding: "12px 18px", background: "#f1f5f9", color: "#475569", border: "none", borderRadius: 12, fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>إلغاء</button>
      </div>
    </>
  , document.body);
  return createPortal( /* v3.4.168 */
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.55)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 10 }}>
      <div dir="rtl" onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 18, width: "100%", maxWidth: 560, maxHeight: "94vh", overflowY: "auto", padding: 18, boxShadow: "0 20px 60px rgba(0,0,0,0.3)", fontFamily: "inherit" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
          <div style={{ fontSize: 16, fontWeight: 900, color: "#0f766e" }}>{editId ? "✏️ تعديل العرض العقاري" : "➕ إضافة عرض عقاري"}</div>{/* v3.4.095 */}
          <button onClick={onClose} style={{ background: "#f1f5f9", border: "none", borderRadius: 8, width: 30, height: 30, cursor: "pointer", fontSize: 15 }}>✕</button>
        </div>
        {editId && existingFiles.length > 0 && (
          <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 10, padding: 10, marginBottom: 10 }}>
            <div style={{ fontSize: 12, fontWeight: 800, color: "#475569", marginBottom: 6 }}>الملفات الحالية ({existingFiles.length}) — يمكنك حذف أيٍّ منها وإضافة غيرها أدناه</div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
              {existingFiles.map(x => (
                <span key={x.id} style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "#fff", border: "1px solid #e2e8f0", borderRadius: 8, padding: "4px 8px", fontSize: 11.5 }}>
                  {x.kind === "image" ? "🖼" : x.kind === "video" ? "🎬" : "📄"} {x.file_name || x.kind}
                  <button type="button" onClick={() => removeExisting(x.id)} title="حذف الملف" style={{ background: "none", border: "none", color: "#dc2626", cursor: "pointer", fontSize: 13, padding: 0 }}>✕</button>
                </span>
              ))}
            </div>
          </div>
        )}
        <div style={{ display: "grid", gap: 10 }}>
          <div><label style={lblP}>اسم المشروع *</label><input value={f.name} onChange={e => set("name", e.target.value)} style={inpP} /></div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <div><label style={lblP}>اسم المطوّر</label>
              {newDev ? <input autoFocus placeholder="اسم مطوّر جديد…" value={f.developer_name} onChange={e => set("developer_name", e.target.value)} style={inpP} /> : (
                <select value={f.developer_name} onChange={e => { if (e.target.value === "__new__") { setNewDev(true); set("developer_name", ""); } else pickDev(e.target.value); }} style={{ ...inpP, appearance: "auto" }}>
                  <option value="">— اختر المطوّر —</option>
                  {(opts.developers || []).map(d => <option key={d.id} value={d.name}>{d.name}</option>)}
                  <option value="__new__">+ مطوّر جديد…</option>
                </select>)}
            </div>
            <div><label style={lblP}>رقم التواصل للمطوّر</label><input placeholder="05XXXXXXXX" value={f.developer_phone} onChange={e => set("developer_phone", e.target.value)} style={{ ...inpP, direction: "ltr", textAlign: "right" }} /></div>
            <div><label style={lblP}>المدينة</label>
              <select value={f.city} onChange={e => { set("city", e.target.value); set("district", ""); }} style={{ ...inpP, appearance: "auto" }}>
                {(opts.cities || ["جدة", "الرياض"]).map(c => <option key={c}>{c}</option>)}
              </select></div>
            <div><label style={lblP}>الحي</label>
              <input list="portal-districts" placeholder="اكتب للبحث ثم اختر…" value={f.district} onChange={e => set("district", e.target.value)} style={inpP} />
              <datalist id="portal-districts">{districts.map(d => <option key={d} value={d} />)}</datalist>
            </div>
          </div>

          {/* v3.4.053 — موقع المشروع: رابط خرائط / مستنتج من الملف / إدخال يدوي / اختيار على الخريطة */}
          <div style={{ background: "#f0fdfa", border: "1px solid #99f6e4", borderRadius: 12, padding: 10 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
              <span style={{ fontSize: 12, fontWeight: 800, color: "#0f766e" }}>📍 موقع المشروع *</span>
              {locFromFile && f.lat !== "" && <span style={{ fontSize: 9.5, fontWeight: 800, background: "#dbeafe", color: "#1d4ed8", borderRadius: 10, padding: "2px 8px" }}>مستنتج من الملف</span>}
            </div>

            <div style={{ fontSize: 10.5, color: "#64748b", marginBottom: 3 }}>١) الصق رابط خرائط جوجل</div>
            <div style={{ display: "flex", gap: 6 }}>
              <input value={f.maps_link} onChange={e => { set("maps_link", e.target.value); setLocState(null); }} onBlur={resolveLink}
                dir="ltr" placeholder="https://maps.app.goo.gl/..." style={{ ...inpP, flex: 1, fontSize: 12.5 }} />
              <button type="button" onClick={resolveLink} disabled={locState === "checking"}
                style={{ padding: "8px 14px", background: locState === "ok" ? "#15803d" : "#0f766e", color: "#fff", border: "none", borderRadius: 10, fontSize: 12, fontWeight: 800, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>
                {locState === "checking" ? "…" : locState === "ok" ? "✓ تم" : "تحقق"}
              </button>
            </div>

            <div style={{ fontSize: 10.5, color: "#64748b", margin: "8px 0 3px" }}>٢) أو اكتب الإحداثيات يدويًا</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6 }}>
              <input value={f.lat} onChange={e => { set("lat", e.target.value); setLocState(e.target.value ? "ok" : null); }} dir="ltr" placeholder="Lat — خط العرض" style={{ ...inpP, fontSize: 12.5 }} />
              <input value={f.lng} onChange={e => { set("lng", e.target.value); setLocState(e.target.value ? "ok" : null); }} dir="ltr" placeholder="Lng — خط الطول" style={{ ...inpP, fontSize: 12.5 }} />
            </div>

            <div style={{ fontSize: 10.5, color: "#64748b", margin: "8px 0 3px" }}>٣) أو اختر الموقع على الخريطة</div>
            <div style={{ display: "flex", gap: 6 }}>
              <button type="button" onClick={startPick} style={{ flex: 1, padding: "10px", background: "#0f766e", color: "#fff", border: "none", borderRadius: 10, fontSize: 13, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>🗺 اختر من الخريطة</button>
              <button type="button" onClick={() => { useCenter(); setLocState("ok"); }} title="أخذ مركز الخريطة الحالي مباشرة"
                style={{ padding: "10px 12px", background: "#fff", color: "#0f766e", border: "1.5px solid #99f6e4", borderRadius: 10, fontSize: 11.5, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>مركز الخريطة</button>
            </div>

            <div style={{ fontSize: 11, fontWeight: 700, marginTop: 8, textAlign: "center", color: locState === "fail" ? "#dc2626" : locState === "checking" ? "#b45309" : f.lat !== "" ? "#15803d" : "#94a3b8" }}>
              {locState === "checking" ? "⏳ جارٍ التحقق من الرابط…"
                : locState === "fail" ? "✗ لم يُستخرج موقع من الرابط — تأكد أنه رابط خرائط جوجل صحيح"
                : f.lat !== "" && f.lng !== "" ? `✓ الموقع محدد — ${f.lat}, ${f.lng}`
                : "لم يُحدد الموقع بعد"}
            </div>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <div><label style={lblP}>إجمالي الوحدات</label><input type="number" value={f.total_units} onChange={e => set("total_units", e.target.value)} style={{ ...inpP, direction: "ltr" }} /></div>
            <div><label style={lblP}>الوحدات المتاحة</label><input type="number" value={f.available_units} onChange={e => set("available_units", e.target.value)} style={{ ...inpP, direction: "ltr" }} /></div>
          </div>

          <div><label style={lblP}>نوع الوحدات المتوفرة (فعّل منها)</label>
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>{(opts.unit_types || []).map(t => chip(f.unit_types.includes(t), t, () => toggleType(t)))}</div></div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <div><label style={lblP}>الجاهزية</label><div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>{(opts.readiness || []).map(t => chip(f.readiness === t, t, () => set("readiness", f.readiness === t ? "" : t), "#1e40af"))}</div></div>
            <div><label style={lblP}>الحالة</label><div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>{(opts.statuses || []).map(t => chip(f.status === t, t, () => set("status", t), "#166534"))}</div></div>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <div><label style={lblP}>الأسعار من (ر.س)</label><input type="number" value={f.price_from} onChange={e => set("price_from", e.target.value)} style={{ ...inpP, direction: "ltr" }} /></div>
            <div><label style={lblP}>إلى (ر.س)</label><input type="number" value={f.price_to} onChange={e => set("price_to", e.target.value)} style={{ ...inpP, direction: "ltr" }} /></div>
          </div>
          <div><label style={lblP}>موعد التسليم</label><input placeholder="جاهز / Q4 2026 …" value={f.delivery_date} onChange={e => set("delivery_date", e.target.value)} style={inpP} /></div>
          <div><label style={lblP}>وصف المشروع</label><textarea value={f.description} onChange={e => set("description", e.target.value)} rows={3} style={{ ...inpP, resize: "vertical" }} /></div>

          <div style={{ background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 12, padding: 10 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
              <div style={{ fontSize: 12, fontWeight: 800, color: "#1e293b" }}>🏘 وحدات المشروع — النماذج ({f.units.length})</div>
              <button type="button" onClick={addUnit} style={{ padding: "5px 12px", background: "#0f766e", color: "#fff", border: "none", borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>+ نموذج</button>
            </div>
            {f.units.length === 0 && <div style={{ fontSize: 11, color: "#94a3b8" }}>أضف نموذجًا: نوع الوحدة (من الأنواع المفعلة أعلاه)، المساحة، الواجهة، السعر</div>}
            {f.units.map((u, i) => (
              <div key={i} style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, padding: 8, marginBottom: 6, display: "grid", gap: 6 }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr auto", gap: 6, alignItems: "end" }}>
                  <div><label style={lblP}>النموذج</label><input value={u.model_name} onChange={e => setUnit(i, "model_name", e.target.value)} style={{ ...inpP, padding: "8px 10px", fontWeight: 700 }} /></div>
                  <div><label style={lblP}>نوع الوحدة</label>
                    <select value={u.unit_type} onChange={e => setUnit(i, "unit_type", e.target.value)} style={{ ...inpP, padding: "8px 10px", appearance: "auto" }}>
                      <option value="">— اختر —</option>{modelTypes.map(t => <option key={t} value={t}>{t}</option>)}
                    </select></div>
                  <button type="button" onClick={() => delUnit(i)} style={{ background: "none", border: "1px solid #fecaca", color: "#dc2626", borderRadius: 8, padding: "8px 10px", cursor: "pointer", fontFamily: "inherit" }}>🗑</button>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 6 }}>
                  <div><label style={lblP}>المساحة م²</label><input type="number" value={u.area_from} onChange={e => setUnit(i, "area_from", e.target.value)} style={{ ...inpP, padding: "8px 10px", direction: "ltr" }} /></div>
                  <div><label style={lblP}>الواجهة</label>
                    <select value={u.facade} onChange={e => setUnit(i, "facade", e.target.value)} style={{ ...inpP, padding: "8px 10px", appearance: "auto" }}>
                      <option value="">— اختر —</option>{(opts.facades || []).map(t => <option key={t} value={t}>{t}</option>)}
                    </select></div>
                  <div><label style={lblP}>السعر (ر.س)</label><input type="number" value={u.price_from} onChange={e => setUnit(i, "price_from", e.target.value)} style={{ ...inpP, padding: "8px 10px", direction: "ltr" }} /></div>
                </div>
                <div style={{ display: "flex", gap: 6 }}>
                  {["متوفر", "مباع"].map(st => { const on = (u.availability || "متوفر") === st; const g = st === "متوفر"; return (
                    <button key={st} type="button" onClick={() => setUnit(i, "availability", st)}
                      style={{ flex: 1, padding: "7px", borderRadius: 8, fontSize: 12, cursor: "pointer", fontFamily: "inherit", fontWeight: on ? 800 : 500,
                        border: on ? `2px solid ${g ? "#166534" : "#991b1b"}` : "1px solid #e2e8f0", background: on ? (g ? "#dcfce7" : "#fee2e2") : "#fff", color: on ? (g ? "#166534" : "#991b1b") : "#94a3b8" }}>{st}</button>
                  ); })}
                </div>
              </div>
            ))}
          </div>

          {/* v3.3.958 — صور المشروع: اختيار متعدد مع معاينة وإزالة */}
          <div style={{ marginBottom: 10 }}>
            <label style={lblP}>📸 صور المشروع (متعددة — حتى 95MB للصورة)</label>
            <label style={{ ...inpP, display: "block", cursor: "pointer", color: imageFiles.length ? "#0f766e" : "#94a3b8", fontWeight: imageFiles.length ? 700 : 500 }}>
              🖼️ {imageFiles.length ? `${imageFiles.length} صورة محددة — اضغط لإضافة المزيد` : "اختر صورًا (يمكن تحديد عدة صور معًا)…"}
              <input type="file" accept="image/*" multiple style={{ display: "none" }}
                onChange={e => { const fl = Array.from(e.target.files || []); if (fl.length) setImageFiles(p => [...p, ...fl]); e.target.value = ""; }} />
            </label>
            {imageFiles.length > 0 && (
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 8 }}>
                {imageFiles.map((im, i) => (
                  <span key={i} style={{ position: "relative", display: "inline-block" }}>
                    <img src={URL.createObjectURL(im)} alt="" style={{ width: 64, height: 64, objectFit: "cover", borderRadius: 8, border: "1.5px solid #e2e8f0" }} />
                    <button type="button" onClick={() => setImageFiles(p => p.filter((_, j) => j !== i))}
                      style={{ position: "absolute", top: -6, left: -6, width: 20, height: 20, borderRadius: 999, background: "#dc2626", color: "#fff", border: "none", fontSize: 11, fontWeight: 800, cursor: "pointer", lineHeight: 1 }}>✕</button>
                  </span>
                ))}
              </div>
            )}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <div><label style={lblP}>ملف فيديو (رفع — حتى 95MB)</label>
              <label style={{ ...inpP, display: "block", cursor: "pointer", color: videoFile ? "#0f766e" : "#94a3b8", fontWeight: videoFile ? 700 : 500, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                🎬 {videoFile ? videoFile.name : "اختر ملف فيديو…"}<input type="file" accept="video/*" style={{ display: "none" }} onChange={e => setVideoFile(e.target.files?.[0] || null)} /></label></div>
            <div><label style={lblP}>ملف بروشور (PDF — حتى 95MB)</label>
              <label style={{ ...inpP, display: "block", cursor: "pointer", color: brochureFile ? "#0f766e" : "#94a3b8", fontWeight: brochureFile ? 700 : 500, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                📄 {brochureFile ? brochureFile.name : "اختر ملف بروشور…"}<input type="file" accept=".pdf,application/pdf,image/*" style={{ display: "none" }} onChange={e => setBrochureFile(e.target.files?.[0] || null)} /></label></div>
            <div><label style={lblP}>رابط فيديو خارجي — اختياري</label><input placeholder="https://youtu.be/…" value={f.video_url} onChange={e => set("video_url", e.target.value)} style={{ ...inpP, direction: "ltr" }} /></div>
            <div><label style={lblP}>رابط بروشور خارجي — اختياري</label><input placeholder="https://…/brochure.pdf" value={f.brochure_url} onChange={e => set("brochure_url", e.target.value)} style={{ ...inpP, direction: "ltr" }} /></div>
          </div>

          <button onClick={save} disabled={saving}
            style={{ padding: "13px", background: "linear-gradient(135deg,#0f766e,#14b8a6)", color: "#fff", border: "none", borderRadius: 12, fontSize: 15, fontWeight: 800, cursor: "pointer", fontFamily: "inherit", opacity: saving ? 0.6 : 1 }}>
            {saving ? (progress || "جاري الحفظ…") : "✓ حفظ العرض"}
          </button>
        </div>
      </div>
    </div>
  , document.body);
}

// ═══════ v3.3.838 — بوب أب التسجيل الجماعي: قالب Excel → رفع → مراجعة الأسماء → تأكيد ═══════
function BulkRegisterModal({ onClose, onDone }) {
  const [step, setStep] = useState("pick"); // pick | preview | done
  const [busy, setBusy] = useState(false);
  const [items, setItems] = useState([]);
  const [checked, setChecked] = useState({});
  const [result, setResult] = useState(null);
  const token = localStorage.getItem(TOKEN_KEY);

  const downloadTemplate = async () => {
    try {
      const res = await fetch("/api/portal/bulk-template", { headers: { Authorization: `Bearer ${token}` } });
      if (!res.ok) throw new Error();
      const blob = await res.blob();
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = "bulk_clients_template.xlsx";
      a.click();
      URL.revokeObjectURL(a.href);
    } catch { alert("تعذر تحميل القالب"); }
  };

  const onFile = async (file) => {
    if (!file) return;
    if (!file.name.toLowerCase().match(/\.(xlsx|xls|xlsm)$/)) return alert("الملف يجب أن يكون Excel (.xlsx)");
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const res = await fetch("/api/portal/bulk-preview", {
        method: "POST", headers: { Authorization: `Bearer ${token}` }, body: fd,
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || "فشل قراءة الملف");
      setItems(data.items || []);
      const c = {};
      (data.items || []).forEach((it, i) => { c[i] = it.status === "ok"; });
      setChecked(c);
      setStep("preview");
    } catch (e) { alert(e.message); }
    setBusy(false);
  };

  const confirm = async () => {
    const rows = items.filter((it, i) => checked[i] && it.status === "ok")
      .map(it => ({ name: it.name, phone: it.phone, client_category: it.client_category, source: it.source, interests: it.interests, notes: it.notes }));
    if (!rows.length) return alert("اختر عميلًا واحدًا على الأقل");
    setBusy(true);
    try {
      const r = await api("/bulk-register", { method: "POST", body: { rows } });
      setResult(r);
      setStep("done");
    } catch (e) { alert(e.message); }
    setBusy(false);
  };

  const okCount = items.filter((it, i) => checked[i] && it.status === "ok").length;
  const statusChip = (it) => {
    const m = {
      ok: { l: "جديد ✓", bg: "#dcfce7", c: "#166534" },
      dup_db: { l: "مسجل مسبقًا", bg: "#fee2e2", c: "#991b1b" },
      dup_file: { l: "مكرر بالملف", bg: "#fef3c7", c: "#92400e" },
      error: { l: it.reason || "خطأ", bg: "#fee2e2", c: "#991b1b" },
      skip: { l: it.reason || "متجاهل", bg: "#e2e8f0", c: "#475569" },
    }[it.status] || { l: it.status, bg: "#e2e8f0", c: "#475569" };
    return <span style={{ background: m.bg, color: m.c, borderRadius: 999, padding: "2px 8px", fontSize: 10.5, fontWeight: 800, whiteSpace: "nowrap" }}>{m.l}</span>;
  };

  return createPortal( /* v3.4.168 */
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.55)", zIndex: 1000,
      display: "flex", alignItems: "center", justifyContent: "center", padding: 14 }}>
      <div dir="rtl" onClick={e => e.stopPropagation()} style={{ background: "#fff", borderRadius: 18, width: "100%",
        maxWidth: 560, maxHeight: "88vh", display: "flex", flexDirection: "column", overflow: "hidden",
        boxShadow: "0 20px 60px rgba(0,0,0,0.3)", fontFamily: "inherit" }}>
        <div style={{ padding: "16px 18px", background: "linear-gradient(135deg,#6d28d9,#8b5cf6)", color: "#fff",
          display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ fontSize: 15, fontWeight: 800 }}>📥 تسجيل جماعي — ملف Excel</div>
          <button onClick={onClose} style={{ background: "rgba(255,255,255,0.2)", color: "#fff", border: "none",
            borderRadius: 8, width: 30, height: 30, fontSize: 16, cursor: "pointer" }}>✕</button>
        </div>

        <div style={{ padding: 18, overflowY: "auto", flex: 1 }}>
          {step === "pick" && (
            <>
              <div style={{ fontSize: 13, color: "#475569", lineHeight: 1.9, marginBottom: 14 }}>
                ١. حمّل ملف الإكسل المرجع وعبّئ بيانات العملاء (الاسم مطلوب).<br />
                ٢. ارفع الملف هنا لمراجعة الأسماء قبل التسجيل.<br />
                ٣. أكّد القائمة وسيتم تسجيل الجميع دفعة واحدة.
              </div>
              <button onClick={downloadTemplate}
                style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, width: "100%",
                  padding: "13px", marginBottom: 12, background: "#f0fdf4", color: "#166534",
                  border: "1.5px solid #86efac", borderRadius: 10, fontSize: 14, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>
                📄 تحميل ملف الإكسل المرجع
              </button>
              <label style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 8,
                padding: "26px 14px", background: busy ? "#f8fafc" : "#faf5ff", border: "2px dashed #c4b5fd", borderRadius: 12,
                cursor: busy ? "wait" : "pointer", textAlign: "center" }}>
                <div style={{ fontSize: 30 }}>{busy ? "⏳" : "📂"}</div>
                <div style={{ fontSize: 13.5, fontWeight: 800, color: "#6d28d9" }}>
                  {busy ? "جاري قراءة الملف..." : "اضغط لاختيار الملف المعبّأ (.xlsx)"}
                </div>
                <input type="file" accept=".xlsx,.xls,.xlsm" disabled={busy} style={{ display: "none" }}
                  onChange={e => { onFile(e.target.files?.[0]); e.target.value = ""; }} />
              </label>
            </>
          )}

          {step === "preview" && (
            <>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#475569", marginBottom: 10 }}>
                راجع الأسماء قبل التسجيل — سيُسجَّل <b style={{ color: "#6d28d9" }}>{okCount}</b> من أصل {items.length}
              </div>
              <div style={{ border: "1px solid #e2e8f0", borderRadius: 10, overflow: "hidden" }}>
                {items.map((it, i) => {
                  const selectable = it.status === "ok";
                  return (
                    <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "9px 12px",
                      borderBottom: i < items.length - 1 ? "1px solid #f1f5f9" : "none",
                      background: selectable ? "#fff" : "#f8fafc", opacity: selectable ? 1 : 0.75 }}>
                      <input type="checkbox" checked={!!checked[i]} disabled={!selectable}
                        onChange={e => setChecked(c => ({ ...c, [i]: e.target.checked }))}
                        style={{ width: 17, height: 17, accentColor: "#6d28d9", flexShrink: 0 }} />
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: 13.5, fontWeight: 800, color: "#1e293b", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{it.name || "—"}</div>
                        <div style={{ fontSize: 11.5, color: "#64748b", direction: "ltr", textAlign: "right" }}>{it.phone || "بدون جوال"}</div>
                      </div>
                      {statusChip(it)}
                    </div>
                  );
                })}
              </div>
              <div style={{ display: "flex", gap: 10, marginTop: 14 }}>
                <button onClick={() => { setStep("pick"); setItems([]); }} disabled={busy}
                  style={{ flex: 1, padding: "12px", background: "#f1f5f9", color: "#475569", border: "none",
                    borderRadius: 10, fontSize: 13.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>
                  ↩ ملف آخر
                </button>
                <button onClick={confirm} disabled={busy || !okCount}
                  style={{ flex: 2, padding: "12px", background: okCount ? "linear-gradient(135deg,#6d28d9,#8b5cf6)" : "#cbd5e1",
                    color: "#fff", border: "none", borderRadius: 10, fontSize: 13.5, fontWeight: 800,
                    cursor: okCount ? "pointer" : "default", fontFamily: "inherit", opacity: busy ? 0.7 : 1 }}>
                  {busy ? "جاري التسجيل..." : `✓ تأكيد وتسجيل ${okCount} عميل`}
                </button>
              </div>
            </>
          )}

          {step === "done" && result && (
            <div style={{ textAlign: "center", padding: "10px 0" }}>
              <div style={{ fontSize: 44, marginBottom: 8 }}>🎉</div>
              <div style={{ fontSize: 16, fontWeight: 800, color: "#166534", marginBottom: 6 }}>
                تم تسجيل {result.inserted} عميل بنجاح
              </div>
              {(result.skipped > 0 || result.failed > 0) && (
                <div style={{ fontSize: 12.5, color: "#64748b", marginBottom: 4 }}>
                  {result.skipped > 0 && `متجاهل (مكرر): ${result.skipped}`}
                  {result.skipped > 0 && result.failed > 0 && " • "}
                  {result.failed > 0 && `فشل: ${result.failed}`}
                </div>
              )}
              <button onClick={() => onDone(result.inserted)}
                style={{ marginTop: 12, padding: "12px 34px", background: "linear-gradient(135deg,#0f766e,#14b8a6)",
                  color: "#fff", border: "none", borderRadius: 10, fontSize: 14, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>
                إغلاق
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  , document.body);
}

// v3.4.156 — مكالماتي: سجل الاتصالات المستلمة على تحويلة الكول سنتر المخصصة لهذا الحساب
// v3.4.443 — «عقار»: المسوّق يضيف روابط إعلاناته في عقار ويتابعها (تُجلب بياناتها عبر جهاز المكتب خلال 30 دقيقة)
const AQ_STATUS = { queued: ["⏳ بانتظار الجلب", "#fef3c7", "#92400e"], active: ["✅ منشور", "#dcfce7", "#166534"], unavailable: ["⛔ غير متاح / منتهٍ", "#fee2e2", "#991b1b"], error: ["⚠ تعذّر الفحص", "#fef3c7", "#92400e"] };
function PortalAqar() {
  const [d, setD] = useState(null); const [err, setErr] = useState(null); const [text, setText] = useState(""); const [busy, setBusy] = useState(false); const [results, setResults] = useState(null);
  const load = useCallback(async () => { setErr(null); try { setD(await api("/aqar")); } catch (e) { setErr(e.message); setD({ listings: [], pending: [] }); } }, []);
  useEffect(() => { load(); }, [load]);
  const add = async () => {
    if (!text.trim()) return;
    setBusy(true); setResults(null);
    try { const r = await api("/aqar", { method: "POST", body: { text } }); setResults(r.results || []); if ((r.results || []).some(x => x.ok)) setText(""); await load(); }
    catch (e) { setResults([{ ok: false, input: "", error: e.message }]); }
    setBusy(false);
  };
  const fmtN = (n) => (n == null ? "—" : Number(n).toLocaleString("en-US"));
  const list = d?.listings || [];
  // v3.4.449 — تجميع الإعلانات حسب الحي (قابلة للطي والفتح)، الأكثر إعلانات أولًا
  const [openHoods, setOpenHoods] = useState({});
  const hoods = (() => { const m = new Map(); for (const it of list) { const k = String(it.locality || "").trim() || "بدون حي"; if (!m.has(k)) m.set(k, []); m.get(k).push(it); }
    return [...m.entries()].map(([k, items]) => ({ key: k, items, views: items.reduce((a, x) => a + (Number(x.views) || 0), 0) })).sort((a, b) => b.items.length - a.items.length || a.key.localeCompare(b.key, "ar")); })();
  const hoodOpen = (k) => openHoods[k] !== undefined ? openHoods[k] : true; // v3.4.460 — مفتوحة افتراضيًا
  const setAllHoods = (v) => setOpenHoods(Object.fromEntries(hoods.map(h => [h.key, v])));
  const card = { background: "#fff", borderRadius: 16, padding: "16px 14px", boxShadow: "0 4px 20px rgba(0,0,0,0.06)", marginBottom: 14 };
  return (
    <div>
      <div style={card}>
        <div style={{ fontSize: 15, fontWeight: 900, color: "#0f766e", marginBottom: 4 }}>🏷️ إعلاناتي في عقار</div>
        <div style={{ fontSize: 11.5, color: "#64748b", marginBottom: 10, lineHeight: 1.6 }}>الصق رابط إعلانك من تطبيق أو موقع عقار (رابط واحد أو أكثر، كل رابط في سطر). تظهر بيانات الإعلان خلال 30 دقيقة تقريبًا.</div>
        <textarea value={text} onChange={e => setText(e.target.value)} rows={3} placeholder={"https://sa.aqar.fm/ad/6747773\nhttps://sa.aqar.fm/r/xxxx"} dir="ltr" style={{ width: "100%", boxSizing: "border-box", padding: "10px 12px", border: "1.5px solid #e2e8f0", borderRadius: 10, fontSize: 13, fontFamily: "inherit", resize: "vertical" }} />
        <button type="button" disabled={busy || !text.trim()} onClick={add} style={{ marginTop: 8, width: "100%", padding: "12px", borderRadius: 10, border: "none", background: busy || !text.trim() ? "#94a3b8" : "#0f766e", color: "#fff", fontWeight: 900, fontSize: 14, cursor: busy ? "wait" : "pointer", fontFamily: "inherit" }}>{busy ? "⏳ جارٍ الإضافة…" : "➕ إضافة إعلاناتي"}</button>
        {results && results.length > 0 && (
          <div style={{ marginTop: 8, display: "grid", gap: 4 }}>
            {results.map((r, i) => <div key={i} style={{ fontSize: 11.5, padding: "5px 8px", borderRadius: 8, background: r.ok ? "#f0fdf4" : "#fef2f2", color: r.ok ? "#166534" : "#991b1b" }}>
              {r.ok ? (r.existing ? "✓ مضاف لديك مسبقًا" : r.pending ? "✓ أُضيف — رابط مختصر، يُحلّ ويُجلب قريبًا" : r.queued ? "✓ أُضيف — بانتظار الجلب" : "✓ أُضيف") : "✖ " + (r.error || "تعذّرت الإضافة")}
              {r.input && <span dir="ltr" style={{ opacity: 0.7, marginInlineStart: 6, fontSize: 10.5 }}>{String(r.input).slice(0, 48)}</span>}
            </div>)}
          </div>
        )}
      </div>
      <div style={{ ...card, display: "flex", alignItems: "center", gap: 8, padding: "10px 14px" }}>{/* v3.4.444 — كان نصًا أبيض غير مقروء على خلفية سطح المكتب الفاتحة */}
        <span style={{ fontSize: 14, fontWeight: 900, color: "#0f172a" }}>إعلاناتي ({list.length})</span>
        {(d?.pending || []).length > 0 && <span style={{ fontSize: 11, fontWeight: 800, color: "#92400e", background: "#fef3c7", borderRadius: 999, padding: "2px 9px" }}>+ {d.pending.length} قيد التحويل</span>}
        <button type="button" onClick={load} style={{ marginInlineStart: "auto", background: "#f0fdfa", border: "1px solid #99f6e4", color: "#0f766e", borderRadius: 8, padding: "6px 12px", fontSize: 12, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>↻ تحديث</button>
      </div>
      {err && <div style={{ ...card, color: "#991b1b", fontSize: 12.5 }}>{err}</div>}
      {!d && <div style={{ ...card, textAlign: "center", color: "#94a3b8", fontSize: 12.5 }}>جارٍ التحميل…</div>}
      {(d?.pending || []).length > 0 && <div style={{ ...card, background: "#fffbeb" }}>
        <div style={{ fontSize: 12, fontWeight: 900, color: "#92400e", marginBottom: 2 }}>🔗 روابط مختصرة قيد التحويل ({d.pending.length})</div>
        <div style={{ fontSize: 10.5, color: "#a16207", marginBottom: 6 }}>تُحوَّل تلقائيًا إلى إعلاناتها خلال 30 دقيقة تقريبًا، ثم تظهر في «إعلاناتي» ببياناتها وصورها.</div>{/* v3.4.444 */}
        {d.pending.map(k => <div key={k.id} dir="ltr" style={{ fontSize: 11, color: "#78350f", padding: "2px 0", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{k.url}</div>)}
      </div>}
      {d && list.length === 0 && (d?.pending || []).length === 0 && <div style={{ ...card, textAlign: "center", color: "#94a3b8", fontSize: 12.5 }}>لم تُضف إعلانات بعد — الصق رابط إعلانك في عقار أعلاه</div>}
      {hoods.length > 1 && <div style={{ display: "flex", gap: 6, justifyContent: "flex-end", margin: "-4px 2px 10px" }}>{/* v3.4.449 */}
        <button type="button" onClick={() => setAllHoods(true)} style={{ background: "#fff", border: "1px solid #e2e8f0", color: "#0f766e", borderRadius: 8, padding: "5px 10px", fontSize: 11.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>فتح الكل</button>
        <button type="button" onClick={() => setAllHoods(false)} style={{ background: "#fff", border: "1px solid #e2e8f0", color: "#64748b", borderRadius: 8, padding: "5px 10px", fontSize: 11.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit" }}>طيّ الكل</button>
      </div>}
      {hoods.map(h => { const open = hoodOpen(h.key); return (
      <div key={h.key} style={{ marginBottom: 12 }}>
        <button type="button" onClick={() => setOpenHoods(o => ({ ...o, [h.key]: !open }))} aria-expanded={open}
          style={{ width: "100%", display: "flex", alignItems: "center", gap: 8, padding: "11px 14px", background: open ? "#0f766e" : "#fff", color: open ? "#fff" : "#0f172a", border: "1px solid " + (open ? "#0f766e" : "#e2e8f0"), borderRadius: 14, cursor: "pointer", fontFamily: "inherit", boxShadow: "0 2px 10px rgba(0,0,0,.05)", marginBottom: open ? 8 : 0 }}>
          <span style={{ fontSize: 15 }}>📍</span>
          <span style={{ fontSize: 14, fontWeight: 900, flex: 1, textAlign: "right" }}>{h.key}</span>
          <span style={{ fontSize: 11, fontWeight: 800, borderRadius: 999, padding: "2px 9px", background: open ? "rgba(255,255,255,.2)" : "#f0fdfa", color: open ? "#fff" : "#0f766e" }}>{h.items.length} إعلان</span>
          {h.views > 0 && <span style={{ fontSize: 11, fontWeight: 800, borderRadius: 999, padding: "2px 9px", background: open ? "rgba(255,255,255,.2)" : "#f1f5f9", color: open ? "#fff" : "#475569" }}>👁 {fmtN(h.views)}</span>}
          <span style={{ fontSize: 10, transition: "transform .2s", transform: open ? "rotate(-90deg)" : "rotate(0)" }}>◀</span>
        </button>
      {open && h.items.map(it => { const st = AQ_STATUS[it.status] || AQ_STATUS.error; const img = (it.images || [])[0]; const src = typeof img === "string" ? img : img?.url || img?.contentUrl || null; return (
        <a key={it.id} href={it.url || `https://sa.aqar.fm/ad/${it.aqar_id}`} target="_blank" rel="noopener noreferrer" style={{ ...card, display: "flex", gap: 12, padding: 10, textDecoration: "none", color: "inherit" }}>
          <div style={{ width: 88, height: 88, borderRadius: 12, background: "#f1f5f9", flexShrink: 0, overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 26 }}>{src ? <img src={src} alt="" loading="lazy" style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : "🏷️"}</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: "flex", gap: 4, flexWrap: "wrap", marginBottom: 3 }}>
              <span style={{ fontSize: 10, fontWeight: 800, padding: "1px 8px", borderRadius: 999, background: st[1], color: st[2] }}>{st[0]}</span>
              {it.deal && <span style={{ fontSize: 10, fontWeight: 800, padding: "1px 8px", borderRadius: 999, background: "#dbeafe", color: "#1e40af" }}>{it.deal === "rent" ? "للإيجار" : "للبيع"}</span>}
            </div>
            <div style={{ fontSize: 13, fontWeight: 800, color: "#0f172a", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{it.title || `إعلان رقم ${it.aqar_id}`}</div>
            <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginTop: 2 }}>
              <span style={{ fontSize: 13, fontWeight: 900, color: "#0f766e" }}>{it.price != null ? fmtN(it.price) + " ر.س" : "—"}</span>
              {it.views != null && <span title={it.views_at ? "آخر تحديث للمشاهدات: " + new Date(it.views_at).toLocaleDateString("en-GB") : ""} style={{ fontSize: 11, fontWeight: 800, color: "#475569", background: "#f1f5f9", borderRadius: 999, padding: "1px 8px" }}>👁 {fmtN(it.views)} مشاهدة</span>}{/* v3.4.446 */}
            </div>
            <div style={{ fontSize: 10.5, color: "#94a3b8", marginTop: 2 }}>#{it.aqar_id}{it.locality ? " · " + it.locality : ""}{it.area ? " · " + fmtN(it.area) + " م²" : ""}</div>
          </div>
        </a>); })}
      </div>); })}{/* v3.4.449 — نهاية مجموعة الحي */}
    </div>
  );
}

function PortalCalls({ user, onAddClient }) { // v3.4.163 — onAddClient({ phone, name })
  const [rows, setRows] = useState(null);
  const [days, setDays] = useState(30);
  const [q, setQ] = useState("");
  const [err, setErr] = useState(null);
  const [scope, setScope] = useState("external"); // v3.4.162 — خارجية (افتراضي) | داخلية (عند الطلب)
  const DISPO = { ANSWERED: ["مجابة", "#dcfce7", "#166534"], "NO ANSWER": ["بلا رد", "#fef3c7", "#92400e"], BUSY: ["مشغول", "#fee2e2", "#991b1b"], FAILED: ["فاشلة", "#fee2e2", "#991b1b"], VOICEMAIL: ["بريد صوتي", "#e0e7ff", "#3730a3"] };
  const fmtDur = (s) => { const n = Number(s) || 0; return `${Math.floor(n / 60)}:${String(n % 60).padStart(2, "0")}`; };
  const load = useCallback(async () => {
    setRows(null); setErr(null);
    try { const r = await api(`/my-calls?days=${days}`); setRows(r.rows || []); }
    catch (e) { setErr(e.message); setRows([]); }
  }, [days]);
  useEffect(() => { load(); }, [load]);
  const scoped = (rows || []).filter(r => (scope === "internal") === !!r.internal); // v3.4.162
  const list = scoped.filter(r => !q.trim() || [r.other_number, r.other_name, r.other_match?.name, r.from_number, r.from_name].some(v => String(v || "").includes(q.trim())));
  const answered = scoped.filter(r => r.disposition === "ANSWERED").length;
  const missed = scoped.filter(r => r.direction !== "outbound" && r.disposition && r.disposition !== "ANSWERED").length;
  const outgoing = scoped.filter(r => r.direction === "outbound").length;
  return (
    <div style={{ background: "#fff", borderRadius: 16, padding: "16px 14px", boxShadow: "0 4px 20px rgba(0,0,0,0.06)", marginBottom: 18 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 10 }}>
        <div style={{ fontSize: 14.5, fontWeight: 800, color: "#0f766e" }}>📞 مكالماتي المستلمة</div>
        <span style={{ fontSize: 11, background: "#f1f5f9", color: "#475569", borderRadius: 10, padding: "2px 9px", fontWeight: 700, direction: "ltr" }}>تحويلة {user.yeastar_extension}</span>
        <button type="button" onClick={load} style={{ marginRight: "auto", background: "#f0fdfa", border: "1px solid #99f6e4", color: "#0f766e", borderRadius: 8, padding: "5px 10px", fontSize: 11.5, cursor: "pointer", fontFamily: "inherit" }}>↻ تحديث</button>
      </div>
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 10 }}>
        {[[7, "أسبوع"], [30, "شهر"], [90, "3 أشهر"]].map(([d, l]) => (
          <button key={d} type="button" onClick={() => setDays(d)} style={{ padding: "5px 12px", borderRadius: 999, border: days === d ? "2px solid #0f766e" : "1px solid #e2e8f0", background: days === d ? "#f0fdfa" : "#fff", color: days === d ? "#0f766e" : "#64748b", fontSize: 11.5, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>{l}</button>
        ))}
        <input value={q} onChange={e => setQ(e.target.value)} placeholder="🔍 رقم أو اسم" style={{ flex: 1, minWidth: 140, padding: "6px 10px", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 12, fontFamily: "inherit" }} />
      </div>
      {/* v3.4.162 — بوكسان: المكالمات الخارجية (افتراضي) / الداخلية (بين التحويلات — للاستعراض عند الطلب) */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 10 }}>
        {[["external", "🌐 المكالمات الخارجية", "مستلمة · فائتة · صادرة من التحويلة", "#0f766e", "#f0fdfa", "#99f6e4"], ["internal", "🏢 المكالمات الداخلية", "بين التحويلات داخل الشركة", "#5b21b6", "#f5f3ff", "#c4b5fd"]].map(([k, l, d, c, bg, br]) => (
          <button key={k} type="button" onClick={() => setScope(k)}
            style={{ textAlign: "right", padding: "9px 12px", borderRadius: 12, cursor: "pointer", fontFamily: "inherit", background: scope === k ? bg : "#fff", border: scope === k ? `2px solid ${c}` : "1px solid #e2e8f0", color: scope === k ? c : "#64748b" }}>
            <div style={{ fontSize: 13, fontWeight: 800 }}>{l} <span style={{ fontFamily: "monospace", fontSize: 12, background: "#fff", borderRadius: 8, padding: "0 6px", border: "1px solid #e2e8f0" }}>{(rows || []).filter(r => (k === "internal") === !!r.internal).length}</span></div>
            <div style={{ fontSize: 10.5, opacity: 0.85, marginTop: 2 }}>{d}</div>
          </button>
        ))}
      </div>
      {scoped.length > 0 && (
        <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
          <div style={{ flex: 1, background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 10, padding: "6px 10px", textAlign: "center" }}><div style={{ fontSize: 10, color: "#64748b" }}>الإجمالي</div><div style={{ fontSize: 17, fontWeight: 800 }}>{rows.length}</div></div>
          <div style={{ flex: 1, background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 10, padding: "6px 10px", textAlign: "center" }}><div style={{ fontSize: 10, color: "#166534" }}>مجابة</div><div style={{ fontSize: 17, fontWeight: 800, color: "#166534" }}>{answered}</div></div>
          <div style={{ flex: 1, background: "#fef3c7", border: "1px solid #fde68a", borderRadius: 10, padding: "6px 10px", textAlign: "center" }}><div style={{ fontSize: 10, color: "#92400e" }}>فائتة</div><div style={{ fontSize: 17, fontWeight: 800, color: "#92400e" }}>{missed}</div></div>
          <div style={{ flex: 1, background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 10, padding: "6px 10px", textAlign: "center" }}><div style={{ fontSize: 10, color: "#1e40af" }}>صادرة</div><div style={{ fontSize: 17, fontWeight: 800, color: "#1e40af" }}>{outgoing}</div></div>
        </div>
      )}
      {err && <div style={{ fontSize: 12, color: "#b91c1c", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: 10, marginBottom: 8 }}>✗ {err}</div>}
      {rows === null ? <div style={{ padding: 30, textAlign: "center", color: "#94a3b8", fontSize: 12 }}>⏳ جاري جلب المكالمات…</div>
        : list.length === 0 ? <div style={{ padding: 30, textAlign: "center", color: "#94a3b8", fontSize: 12 }}>{scope === "internal" ? "لا توجد مكالمات داخلية في هذه الفترة" : "لا توجد مكالمات خارجية في هذه الفترة"}</div>
        : (
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            {list.map(r => {
              const d = DISPO[r.disposition] || [r.disposition || "—", "#f1f5f9", "#475569"];
              const out = r.direction === "outbound"; // v3.4.162
              const num = r.other_number || r.from_number; const name = r.other_match?.name || r.other_name || r.from_match?.name || r.from_name || "";
              const icon = out ? "📤" : r.disposition === "ANSWERED" ? "📞" : "📵";
              return (
                <div key={r.id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "9px 10px", border: "1px solid #e2e8f0", borderRadius: 12, background: out ? "#f8fafc" : r.disposition === "ANSWERED" ? "#fff" : "#fffbeb" }}>
                  <div style={{ width: 34, height: 34, borderRadius: "50%", background: out ? "#dbeafe" : d[1], color: out ? "#1e40af" : d[2], display: "flex", alignItems: "center", justifyContent: "center", fontSize: 15 }}>{icon}</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 13, fontWeight: 800, color: "#0f172a", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{name || "رقم غير معروف"}{(r.other_match?.kind || r.from_match?.kind) ? <span style={{ fontSize: 10, color: "#64748b", fontWeight: 600 }}> · {r.other_match?.kind || r.from_match?.kind}</span> : null}<span style={{ fontSize: 10, color: out ? "#1e40af" : "#0f766e", fontWeight: 700 }}> · {out ? "صادرة" : "واردة"}</span></div>
                    <div style={{ fontSize: 11.5, color: "#475569", direction: "ltr", textAlign: "right" }}>
                      <a href={`tel:${num}`} style={{ color: "#1d4ed8", textDecoration: "none" }}>{num}</a>
                    </div>
                    <div style={{ fontSize: 10.5, color: "#94a3b8" }}>{String(r.time || "").replace("T", " ").slice(0, 16)}{r.duration ? ` · ${fmtDur(r.duration)}` : ""}</div>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 5 }}>
                    <span style={{ fontSize: 10.5, fontWeight: 800, padding: "3px 9px", borderRadius: 999, background: d[1], color: d[2], whiteSpace: "nowrap" }}>{d[0]}</span>
                    {/* v3.4.163 — إضافة المتصل إلى عملائي (خارجي فقط): يفتح نموذج التسجيل معبّأً بالرقم والاسم */}
                    {!r.internal && onAddClient && (
                      String(r.other_match?.kind || "").includes("عميل")
                        ? <span style={{ fontSize: 10, color: "#166534", fontWeight: 700 }}>✓ مسجّل ({r.other_match.kind})</span>
                        : <button type="button" onClick={() => onAddClient({ phone: num, name: name && name !== num ? name : "" })}
                            style={{ background: "#0f766e", color: "#fff", border: "none", borderRadius: 8, padding: "4px 9px", fontSize: 10.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>
                            ➕ إضافة لعملائي
                          </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
    </div>
  );
}

function PortalHome({ user, notify, toast }) {
  // v3.4.192 — الموارد البشرية: هل الحساب مرتبط بموظف؟ (يُظهر تبويب «الدوام»)
  const [hrLinked, setHrLinked] = useState(false);
  useEffect(() => { hrApi("/me").then((r) => setHrLinked(!!r.employee || !!r.manager)).catch(() => {}); }, []); // v3.4.558 — أو مدير موارد بشرية
  // v3.4.188 — تعبئة نموذج التسجيل من جهة اتصال (مكالمة أو محادثة واتس)
  const addClientFromContact = (c) => {
    const d = String(c.phone || "").replace(/[^0-9]/g, ""); const local = d.startsWith("966") ? "0" + d.slice(3) : d.startsWith("00966") ? "0" + d.slice(5) : d;
    setForm({ ...empty, phone: local, name: c.name || "" }); setView("home"); notify && notify("✅ عُبّئ الرقم — أكمل بيانات العميل واحفظ");
  };
  const empty = { name: "", phone: "", client_category: "", source: "", notes: "", interests: [] }; // v3.3.781 — بلا رقم هوية
  const [form, setForm] = useState(empty);
  const [busy, setBusy] = useState(false);
  const [mine, setMine] = useState(null);
  // v3.3.782 — قوائم الفورم من إعدادات النظام (نوع/مصدر: سيليكت، اهتمام: تشك ليست)
  const [opts, setOpts] = useState({ client_categories: [], sources: [], interests: [] });
  useEffect(() => {
    api("/options").then(setOpts).catch(() => {});
  }, []);
  const toggleInterest = (v) => setForm(f => ({
    ...f,
    interests: f.interests.includes(v) ? f.interests.filter(x => x !== v) : [...f.interests, v],
  }));

  // v3.3.772 — تسجيل صوتي للملاحظة + تفريغ نصي تلقائي أثناء الكلام (محرك التعرف بالمتصفح)
  const [recState, setRecState] = useState("idle"); // idle | recording | done
  const [recSeconds, setRecSeconds] = useState(0);
  const [audioBlob, setAudioBlob] = useState(null);
  const [audioUrl, setAudioUrl] = useState(null);
  const recRef = React.useRef({}); // {recorder, chunks, timer, recog, transcript}

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mime = ["audio/webm;codecs=opus", "audio/webm", "audio/mp4", ""].find(
        t => !t || (window.MediaRecorder && MediaRecorder.isTypeSupported(t)));
      const recorder = new MediaRecorder(stream, mime ? { mimeType: mime } : undefined);
      const chunks = [];
      recorder.ondataavailable = (e) => { if (e.data.size > 0) chunks.push(e.data); };
      recorder.onstop = () => {
        stream.getTracks().forEach(t => t.stop());
        const blob = new Blob(chunks, { type: recorder.mimeType || "audio/webm" });
        setAudioBlob(blob);
        setAudioUrl(URL.createObjectURL(blob));
        setRecState("done");
      };
      // التفريغ التلقائي: يكتب في خانة الملاحظات مباشرة أثناء الكلام
      const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
      let recog = null;
      if (SR) {
        recog = new SR();
        recog.lang = "ar-SA"; recog.continuous = true; recog.interimResults = false;
        recog.onresult = (e) => {
          let text = "";
          for (let i = e.resultIndex; i < e.results.length; i++)
            if (e.results[i].isFinal) text += e.results[i][0].transcript + " ";
          if (text.trim()) {
            recRef.current.transcript = (recRef.current.transcript || "") + text;
            setForm(f => ({ ...f, notes: (f.notes ? f.notes.replace(/\s+$/, "") + " " : "") + text.trim() }));
          }
        };
        recog.onend = () => { if (recRef.current.recording) { try { recog.start(); } catch {} } };
        try { recog.start(); } catch {}
      }
      recorder.start(1000); // v3.3.773 — البدء الفعلي للتسجيل (كان مفقودًا فيعلق زر الإيقاف)
      recRef.current = { recorder, chunks, recog, transcript: "", recording: true,
        timer: setInterval(() => setRecSeconds(s => s + 1), 1000) };
      setRecSeconds(0);
      setRecState("recording");
      if (!SR) notify("التسجيل يعمل — التفريغ النصي التلقائي غير مدعوم على هذا المتصفح", true);
    } catch {
      notify("تعذر الوصول للميكروفون — اسمح بالإذن من المتصفح", false);
    }
  };
  const stopRecording = () => {
    const r = recRef.current;
    r.recording = false;
    try { r.recog?.stop(); } catch {}
    clearInterval(r.timer);
    // v3.3.773 — إيقاف دفاعي: لو كان المسجل غير نشط لأي سبب لا يبقى الزر عالقًا أحمر
    if (r.recorder && r.recorder.state !== "inactive") {
      try { r.recorder.stop(); return; } catch {}
    }
    setRecState((r.chunks && r.chunks.length) ? "done" : "idle");
  };
  const deleteRecording = () => {
    if (audioUrl) URL.revokeObjectURL(audioUrl);
    setAudioBlob(null); setAudioUrl(null); setRecState("idle"); setRecSeconds(0);
  };
  const fmtSec = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;

  // v3.3.775 — استيراد بيانات العميل من جهات اتصال الهاتف (Contact Picker API)
  const contactsSupported = typeof navigator !== "undefined" && "contacts" in navigator && !!navigator.contacts?.select;
  const pickContact = async () => {
    // v3.3.782 — الزر ظاهر دائمًا؛ عند عدم الدعم نشرح بدل الاختفاء الصامت
    if (!contactsSupported) {
      return notify("استيراد جهات الاتصال متاح على أندرويد بمتصفح كروم (أو التطبيق المثبت منه) فقط", false);
    }
    try {
      const picked = await navigator.contacts.select(["name", "tel"], { multiple: false });
      const c = picked && picked[0];
      if (!c) return;
      setForm(f => ({
        ...f,
        name: (c.name && c.name[0]) || f.name,
        phone: (c.tel && c.tel[0]) || f.phone,
      }));
      notify("✅ تم استيراد بيانات جهة الاتصال");
    } catch { /* المستخدم ألغى الاختيار */ }
  };

  const loadMine = useCallback(() => {
    api("/prospects").then(r => setMine(r.prospects || [])).catch(() => setMine([]));
  }, []);

  // v3.3.838 — بوب أب التسجيل الجماعي (Excel)
  const [bulkOpen, setBulkOpen] = useState(false);

  // v3.3.786 — توسيع عميل بالضغط + تحميل تسجيله الصوتي عند الفتح (fetch بالتوكن → blob)
  const [expanded, setExpanded] = useState(null);
  const [voiceUrls, setVoiceUrls] = useState({});
  const toggleExpand = async (p) => {
    const next = expanded === p.id ? null : p.id;
    setExpanded(next);
    if (next && p.has_voice && !voiceUrls[p.id]) {
      try {
        const token = localStorage.getItem(TOKEN_KEY);
        const res = await fetch(`/api/portal/prospects/${p.id}/voice`, { headers: { Authorization: `Bearer ${token}` } });
        if (res.ok) {
          const blob = await res.blob();
          setVoiceUrls(v => ({ ...v, [p.id]: URL.createObjectURL(blob) }));
        }
      } catch { /* يبقى مؤشر التحميل */ }
    }
  };
  useEffect(() => { loadMine(); }, [loadMine]);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return notify("اسم العميل مطلوب", false);
    if (recState === "recording") return notify("أوقف التسجيل أولًا", false);
    setBusy(true);
    try {
      // v3.3.772 — إرفاق التسجيل الصوتي + تفريغه
      const body = { ...form };
      if (audioBlob) {
        body.voice_note_base64 = await new Promise((resolve, reject) => {
          const fr = new FileReader();
          fr.onload = () => resolve(String(fr.result).split(",")[1] || "");
          fr.onerror = reject;
          fr.readAsDataURL(audioBlob);
        });
        body.voice_note_mime = audioBlob.type || "audio/webm";
        body.voice_transcript = recRef.current.transcript || null;
        body.voice_duration = recSeconds;
      }
      await api("/prospects", { method: "POST", body });
      notify("✅ تم تسجيل العميل بنجاح");
      setForm(empty);
      deleteRecording();
      loadMine();
    } catch (err) { notify(err.message, false); }
    setBusy(false);
  };

  const fmtDate = (d) => String(d || "").slice(0, 10);

  // v3.3.806 — صفحات فرعية: إحصائياتي / خدمة العملاء + عدّاد الرسائل غير المقروءة
  // v3.4.095 — المسوّق يبدأ من «عملائي» ونموذج التسجيل يُفتح بزر «+» العائم (دمج التبويبين)
  const MSG_VIEWS = ["chat", "wa", "official", "company", "pwa"]; // v3.4.164 — الفيوهات المدمجة في زر «واتس» — v3.4.842 company
  const [view, setView] = useState(user.features && user.features.prospects ? "prospects" : (user.features ? user.features.clients : ["marketer", "ext_marketer"].includes(user.account_type)) ? "clients" : (user.features && user.features.tasks) ? "tasks" : "home"); /* v3.4.464 — v3.4.465: الموظف يبدأ من «مهامي» */ // v3.4.454 — من الصلاحيات
  const isDesktop = useIsDesktop(); // v3.4.232
  useEffect(() => { try { document.body.dataset.pview = view; } catch {} return () => { try { delete document.body.dataset.pview; } catch {} }; }, [view]); // v3.4.232 — عرض الحاوية حسب الشاشة // v3.4.124 — المسوّق الخارجي كالمسوّق // home | clients | offers | lands | stats | chat | wa | official
  const [unread, setUnread] = useState(0);
  const [waUnread, setWaUnread] = useState(0); // v3.4.061 — وارد واتس البزنس على رقم المسوّق
  const [waTarget, setWaTarget] = useState(null); // v3.4.090 — عميل يُفتح مباشرة في تبويب واتس قادمًا من «عملائي»
  const [off, setOff] = useState(null);           // v3.4.093 — الرقم الرسمي المشترك { exists, name, number, owner }
  const [offUnread, setOffUnread] = useState(0);
  const [pwaTarget, setPwaTarget] = useState(null); // v3.4.103 — عميل يُفتح في واتسابي الشخصي (الزر الأزرق)
  const [pwaUnread, setPwaUnread] = useState(0);
  useEffect(() => { api("/wa/official/info").then(r => setOff(r)).catch(() => setOff({ exists: false })); }, []);
  const [comp, setComp] = useState(null);         // v3.4.842 — واتساب الشركة الرسمي (الرقم الرئيسي) { exists, name, number, owner }
  const [compUnread, setCompUnread] = useState(0);
  useEffect(() => { api("/wa/company/info").then(r => setComp(r)).catch(() => setComp({ exists: false })); }, []);
  const [statsTotals, setStatsTotals] = useState(null);
  useEffect(() => {
    let alive = true;
    const tick = () => {
      api("/chat/unread").then(r => alive && setUnread(r.unread || 0)).catch(() => {});
      api("/wa/unread").then(r => alive && setWaUnread(r.unread || 0)).catch(() => {}); // v3.4.061
      api("/wa/official/unread").then(r => alive && setOffUnread(r.unread || 0)).catch(() => {}); // v3.4.093
      api("/wa/company/unread").then(r => alive && setCompUnread(r.unread || 0)).catch(() => {}); // v3.4.842
      if ((user.account_type || "rep") !== "rep") api("/pwa/unread").then(r => alive && setPwaUnread(r.unread || 0)).catch(() => {}); // v3.4.103
    };
    tick();
    api("/stats?view=daily").then(r => alive && setStatsTotals(r.totals || null)).catch(() => {});
    const t = setInterval(tick, 10000); // v3.3.808 — كل 10 ثوانٍ لتنبيه أسرع
    return () => { alive = false; clearInterval(t); };
  }, [view]);

  // v3.3.807 — شريط تنقّل ثابت بين الشاشات الثلاث (يبقى ظاهرًا في كل شاشة)
  // v3.3.812 — المسوّق: زر رابع "عملائي" (المخصص له + ما أضافه)
  const FEAT = user.features || null; // v3.4.454 — صلاحيات الحساب المحسوبة من الخادم (افتراضي النوع + استثناءات)
  const isEmp = !!(FEAT && (FEAT.tasks || FEAT.visitors)) && !(FEAT && (FEAT.prospects || FEAT.clients)); // v3.4.465 — موظف شركة: بلا شاشة تسجيل عميل
  const isSM = !!(FEAT && FEAT.prospects); // v3.4.464 — «العملاء المحتملون» (مديرة المبيعات) بدل «عملائي»/«إحصائياتي»
  const isMarketer = FEAT ? !!FEAT.clients : ["marketer", "ext_marketer"].includes(user.account_type); // v3.4.124 — v3.4.454: وضع «عملائي»
  // v3.4.061 — واتس البزنس: يظهر لمن أُسند له رقم من إدارة الحسابات
  // v3.4.063 — لكل الأنواع عدا المندوب (مسوّق/مشرف/مدير عام)
  const canHaveWa = FEAT ? !!FEAT.wa : (user.account_type || "rep") !== "rep"; // v3.4.454
  const hasWa = canHaveWa && !!user.wa_display_number;
  const isGM = user.account_type === "gm"; // v3.3.955 — المدير العام: خريطة عروض الأراضي
  // v3.4.095 — شريط تبويبات سفلي ثابت (نمط التطبيقات): 5 تبويبات ظاهرة والباقي بالتمرير الأفقي، وشارات للجديد
  // v3.4.096 — أيقونات خطية بدل الإيموجي + شريط عائم زجاجي بحواف دائرية (نمط التطبيقات الحديثة)
  const navItems = [
    ...(isSM ? [["prospects", FiUsers, "العملاء المحتملون", 0]] : isMarketer ? [["clients", FiUsers, "عملائي", 0]] : isEmp ? [] : [["home", FiEdit3, "تسجيل عميل", 0]]), /* v3.4.464 */
    ...((FEAT && FEAT.tasks) || user.has_staff_tasks ? [["tasks", FiCheckSquare, "مهامي", 0]] : []), /* v3.4.465 — v3.4.588 أو مسندة إليه مهام */
    ...(FEAT && FEAT.visitors ? [["visitors", FiUserCheck, "زوار المكتب", 0]] : []), /* v3.4.465 */ // المسوّق: التسجيل من زر «إضافة عميل جديد» أعلى القائمة
    ...((FEAT ? FEAT.offers : (isMarketer || isGM)) ? [["offers", FiHome, "العروض", 0]] : []), /* v3.4.454 */ // v3.3.846 / v3.3.955 للمدير العام أيضًا
    ...((FEAT ? FEAT.aqar : isMarketer) ? [["aqar", FiTag, "عقار", 0]] : []), /* v3.4.454 */ // v3.4.443 — إعلانات المسوّق في عقار
    ...((user.can_view_reservations || user.can_view_own_reservations) ? [["resv", FiFileText, "الحجوزات", 0]] : []), // v3.4.236/238 — v3.4.244: الكشف الكامل أو حجوزاته فقط
    ...((FEAT ? FEAT.lands : isGM) ? [["lands", FiMap, "الأراضي", 0]] : []), /* v3.4.454 */ // v3.3.955
    ...(isSM || isMarketer || (FEAT && !FEAT.stats) ? [] : [["stats", FiBarChart2, "إحصائياتي", 0]]), /* v3.4.464 */ /* v3.4.454 */ // v3.4.164 — للمسوّق: تبويب داخل «عملائي»
    // v3.4.164 — زر واحد «واتس» يجمع: خدمة العملاء + واتس البزنس + الرقم الرسمي + واتسابي (تبويبات داخلية)
    ["msgs", FaWhatsapp, "واتس", unread + waUnread + offUnread + pwaUnread],
    ...(user.yeastar_extension && (!FEAT || FEAT.calls) ? [["calls", FiPhoneIncoming, "مكالماتي", 0]] : []), /* v3.4.454 */ // v3.4.156 — يظهر فقط عند تخصيص تحويلة كول سنتر للحساب
    ...(hrLinked ? [["hr", FiClock, "دوامي", 0]] : []), /* v3.4.465 — «دوامي» */ // v3.4.192 — يظهر عند ربط الحساب بموظف في الموارد البشرية
  ];
  // v3.4.104 — شريط تبويبات سفلي ثابت بعرض الشاشة (نمط التطبيقات): ملتصق بالحافة السفلية بلا حواف عائمة،
  // وكل التبويبات تتقاسم العرض بالتساوي فتظهر كلها دون تمرير أفقي مهما زاد عددها؛ والمحتوى كله فوقه
  const NavBar = () => {
    const n = navItems.length, tight = n >= 6;
    if (isDesktop) { // v3.4.232 — شريط علوي لاصق على سطح المكتب (بدل الشريط السفلي)
      return (
        <nav dir="rtl" className="ptopnav">
          <div style={{ display: "flex", gap: 4, alignItems: "center", maxWidth: 1180, margin: "0 auto", flexWrap: "wrap" }}>
            {navItems.map(([k, Icon, l, badge]) => {
              const active = view === k || (k === "msgs" && MSG_VIEWS.includes(view)) || (k === "clients" && view === "stats" && isMarketer) || (k === "prospects" && (view === "prospects_ext" || view === "prospects_wa"));
              const alert = k === "msgs" && unread > 0 && !active;
              return (
                <button key={k} type="button" onClick={() => setView(k)} title={l}
                  style={{ display: "flex", alignItems: "center", gap: 8, border: "none", background: active ? "#f0fdfa" : "transparent", cursor: "pointer", fontFamily: "inherit",
                    padding: "12px 16px", borderBottom: active ? "3px solid #0f766e" : "3px solid transparent", color: active ? "#0f766e" : alert ? "#dc2626" : "#475569", fontWeight: active ? 900 : 700, fontSize: 13.5, position: "relative" }}>
                  <Icon size={18} /><span>{l}</span>
                  {badge > 0 && <span style={{ background: "#ef4444", color: "#fff", borderRadius: 999, minWidth: 18, height: 18, fontSize: 10.5, fontWeight: 800, display: "inline-flex", alignItems: "center", justifyContent: "center", padding: "0 5px" }}>{badge}</span>}
                </button>
              );
            })}
          </div>
        </nav>
      );
    }
    return (
    <>
      {createPortal(<nav dir="rtl" className="pnav-bar" style={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 900, /* v3.4.168 — على body */ /* v3.4.294 — pnav-bar: يُخفى أثناء ملء شاشة الخريطة */
        background: "rgba(255,255,255,.94)", backdropFilter: "blur(18px)", WebkitBackdropFilter: "blur(18px)",
        borderTop: "1px solid rgba(15,23,42,.08)", boxShadow: "0 -8px 28px rgba(15,23,42,.10)",
        paddingBottom: "env(safe-area-inset-bottom)" }}>
        <div className="pnav" style={{ display: "flex", gap: 0, padding: "5px 4px 4px", maxWidth: 1100, margin: "0 auto" }}>
          {navItems.map(([k, Icon, l, badge]) => {
            const active = view === k || (k === "msgs" && MSG_VIEWS.includes(view)) || (k === "clients" && view === "stats" && isMarketer) || (k === "prospects" && (view === "prospects_ext" || view === "prospects_wa")); // v3.4.164
            const alert = k === "msgs" && unread > 0 && !active; // v3.3.808 — تنبيه بارز عند رسالة/رد جديد
            return (
              <button key={k} type="button" onClick={() => setView(k)} title={l}
                style={{ flex: "1 1 0", minWidth: 0, border: "none", padding: tight ? "6px 1px 5px" : "7px 2px 6px", cursor: "pointer", fontFamily: "inherit",
                  position: "relative", borderRadius: 14, transition: "all .2s", background: "transparent",
                  color: active ? "#0f766e" : alert ? "#dc2626" : "#64748b",
                  animation: alert ? "portalPulse 1.4s ease-in-out infinite" : "none" }}>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 26, margin: "0 auto", width: tight ? 40 : 48, borderRadius: 13,
                  background: active ? "linear-gradient(135deg,#0f766e,#14b8a6)" : "transparent", color: active ? "#fff" : "inherit",
                  boxShadow: active ? "0 6px 16px rgba(15,118,110,.35)" : "none", transition: "all .2s" }}>
                  <Icon size={k === "wa" || k === "pwa" ? 20 : 18} />
                </div>
                <div style={{ fontSize: tight ? 9 : 10, fontWeight: 800, marginTop: 3, lineHeight: 1.2, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", opacity: active ? 1 : .9 }}>{l}</div>
                {badge > 0 && (
                  <span style={{ position: "absolute", top: 2, left: "calc(50% - 26px)", background: "#ef4444", color: "#fff", borderRadius: 999, border: "2px solid #fff",
                    minWidth: 18, height: 18, fontSize: 10, fontWeight: 800, display: "flex", alignItems: "center", justifyContent: "center", padding: "0 4px" }}>
                    {badge}
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </nav>, document.body)}
      <style>{`@keyframes portalPulse{0%,100%{transform:scale(1)}50%{transform:scale(1.04)}}`}</style>{/* v3.4.169 — أُزيل padding-bottom من body (التمرير داخل الحاوية منذ v3.4.166؛ كان يجعل المستند أطول من الشاشة) */}
    </>
    );
  };

  // v3.4.164 — شريط تبويبات داخلي موحّد
  const SubTabs = ({ items, current, onPick }) => (
    <div style={{ display: "flex", gap: 6, marginBottom: 12, overflowX: "auto", paddingBottom: 2 }}>
      {items.map(([k, l, badge]) => (
        <button key={k} type="button" onClick={() => onPick(k)}
          style={{ position: "relative", flex: "1 0 auto", padding: "8px 12px", borderRadius: 999, border: current === k ? "2px solid #0f766e" : "1px solid #e2e8f0", background: current === k ? "#f0fdfa" : "#fff", color: current === k ? "#0f766e" : "#64748b", fontSize: 12.5, fontWeight: 800, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" }}>
          {l}{badge > 0 && <span style={{ marginInlineStart: 6, background: "#ef4444", color: "#fff", borderRadius: 999, padding: "0 6px", fontSize: 10.5 }}>{badge}</span>}
        </button>
      ))}
    </div>
  );
  // v3.4.464 — مديرة المبيعات: «العملاء المحتملون» بتبويبين — عملاء مباشرون / عملاء من مسوّقين خارجيين (بلا إحصائيات)
  if (isSM && (view === "prospects" || view === "prospects_ext" || view === "prospects_wa" || view === "clients")) { // v3.4.762 — تبويبان: مباشرون / عملاء المسوّقين الخارجيين (دُمج تبويب واتساب)
    const cur = view === "prospects_ext" || view === "prospects_wa" ? "prospects_ext" : "prospects";
    const SCOPE = { prospects: "direct", prospects_ext: "ext" };
    const TITLE = { prospects: "🤝 عملاء مباشرون", prospects_ext: "🧑‍💼 عملاء المسوّقين الخارجيين" };
    const SUB = { prospects: "عملاؤك الذين لا مسوّق خارجي لهم: المخصصون لك من الشركة + ما أضفتِه بنفسك ولم يُخصَّص لغيرك — عالجي كل رقم وأضيفي ملاحظاتك", /* v3.4.762 */
      prospects_ext: "عملاؤك الذين لهم مسوّق خارجي في عمود «المسوّق» — سواء وصلوا بتحويل واتساب إلى الرقم الموحد 920012054 أو أُضيفوا يدويًا — مجمّعون حسب المسوّق" };
    return <><NavBar />
      <SubTabs items={[["prospects", "🤝 عملاء مباشرون", 0], ["prospects_ext", "🧑‍💼 عملاء المسوّقين الخارجيين", 0]]} current={cur} onPick={(k) => setView(k)} />
      <PortalMyClients key={cur} scope={SCOPE[cur]}
        title={TITLE[cur]}
        subtitle={SUB[cur]}
        onAdd={cur === "prospects" ? () => setView("home") : null}
        onWhatsApp={hasWa ? (c) => { setWaTarget({ phone: toWaPhone(c.phone), contact_name: c.name || "" }); setView("wa"); } : null}
        onPersonal={canHaveWa ? (c) => { setPwaTarget({ phone: toWaPhone(c.phone), contact_name: c.name || "" }); setView("pwa"); } : null} />
    </>;
  }
  // عملائي: تبويبان — عملائي / إحصائياتي (v3.4.164)
  if (view === "clients" || (view === "stats" && isMarketer)) {
    const tab = view === "stats" ? "stats" : "clients";
    return <><NavBar />
      <SubTabs items={[["clients", "👥 عملائي", 0], ["stats", "📊 إحصائياتي", 0]]} current={tab} onPick={(k) => setView(k)} />
      {tab === "stats" ? <PortalStats onBack={() => setView("clients")} /> : (
        <PortalMyClients onAdd={() => setView("home")} onWhatsApp={hasWa ? (c) => { setWaTarget({ phone: toWaPhone(c.phone), contact_name: c.name || "" }); setView("wa"); } : null}
          onPersonal={canHaveWa ? (c) => { setPwaTarget({ phone: toWaPhone(c.phone), contact_name: c.name || "" }); setView("pwa"); } : null} />
      )}
    </>; /* v3.4.090 / v3.4.096 / v3.4.103 / v3.4.164 */
  }
  // مركز الواتس: خدمة العملاء + واتس البزنس + الرقم الرسمي + واتسابي (v3.4.164)
  if (view === "msgs" || MSG_VIEWS.includes(view) || String(view).startsWith("wa:")) { // v3.4.276 — wa:<رقم> لصناديق الأرقام الإضافية
    const showWa = hasWa, showOff = canHaveWa && off?.exists && off.number !== user.wa_display_number, showPwa = canHaveWa;
    const showComp = canHaveWa && comp?.exists && comp.number !== user.wa_display_number && (!off?.exists || comp.number !== off.number); // v3.4.842
    const extraWa = canHaveWa ? (user.wa_numbers || []).filter(n => !n.primary && n.display_number !== user.wa_display_number && (!off?.exists || n.display_number !== off.number) && (!comp?.exists || n.display_number !== comp.number)) : [];
    const items = [
      ...(showPwa ? [["pwa", "واتسابي", pwaUnread]] : []),
      ...(showWa ? [["wa", extraWa.length ? (user.wa_number_name || user.wa_display_number) : "واتس البزنس", waUnread]] : []),
      ...extraWa.map(n => ["wa:" + n.display_number, n.name || n.display_number, 0]),
      ...(showComp ? [["company", "واتساب الشركة الرسمي", compUnread]] : []), // v3.4.842
      ...(showOff ? [["official", off.name || "الرقم الرسمي", offUnread]] : []),
      ["chat", "خدمة العملاء", unread],
    ];
    const cur = view === "msgs" ? items[0][0] : view;
    return <><NavBar />
      <SubTabs items={items} current={cur} onPick={(k) => setView(k)} />
      {cur === "pwa" && <PortalPersonalWa user={user} onRead={() => setPwaUnread(0)} initial={pwaTarget} onConsumed={() => setPwaTarget(null)} />}
      {cur === "chat" && <PortalChat user={user} onBack={() => setView(isSM ? "prospects" : isMarketer ? "clients" : isEmp && FEAT.tasks ? "tasks" : "home")} onRead={() => setUnread(0)} />}
      {String(cur).startsWith("wa:") && (() => { const num = cur.slice(3); const n = (user.wa_numbers || []).find(x => x.display_number === num); return <PortalWhatsApp key={num} user={user} onAddClient={addClientFromContact} onPersonal={canHaveWa ? (c) => { setPwaTarget({ phone: toWaPhone(c.phone), contact_name: c.name || "", draft: c.draft || "" }); setView("pwa"); } : null} onRead={() => {}} base={`/wa/n/${num}`} boxNumber={num} boxName={n?.name || ""} />; })()}{/* v3.4.276 */}
      {cur === "wa" && <PortalWhatsApp user={user} onAddClient={addClientFromContact} onPersonal={canHaveWa ? (c) => { setPwaTarget({ phone: toWaPhone(c.phone), contact_name: c.name || "", draft: c.draft || "" }); setView("pwa"); } : null} onRead={() => setWaUnread(0)} initial={waTarget} onConsumed={() => setWaTarget(null)} official={!!(off?.exists && off.number === user.wa_display_number)} owner boxName={off?.name} boxNumber={user.wa_display_number} base={off?.exists && off.number === user.wa_display_number ? "/wa/official" : "/wa"} />}
      {cur === "official" && <PortalWhatsApp user={user} onAddClient={addClientFromContact} onPersonal={canHaveWa ? (c) => { setPwaTarget({ phone: toWaPhone(c.phone), contact_name: c.name || "", draft: c.draft || "" }); setView("pwa"); } : null} onRead={() => setOffUnread(0)} base="/wa/official" official owner={!!off?.owner} boxName={off?.name} boxNumber={off?.number} />}
      {cur === "company" && <PortalWhatsApp key="company" user={user} onAddClient={addClientFromContact} onPersonal={canHaveWa ? (c) => { setPwaTarget({ phone: toWaPhone(c.phone), contact_name: c.name || "", draft: c.draft || "" }); setView("pwa"); } : null} onRead={() => setCompUnread(0)} base="/wa/company" official owner={!!comp?.owner} boxName={comp?.name || "واتساب الشركة الرسمي"} boxNumber={comp?.number} />}{/* v3.4.842 */}
    </>;
  }
  if (view === "tasks" && ((FEAT && FEAT.tasks) || user.has_staff_tasks)) return <><NavBar /><PortalTasks api={api} /></>; {/* v3.4.465 */}
  if (view === "visitors" && FEAT && FEAT.visitors) return <><NavBar /><PortalVisitors api={api} /></>; {/* v3.4.465 */}
  if (view === "hr") return <><NavBar /><HrAttendancePanel api={hrApi} blob={hrBlob} accent="#0f766e" /></>; {/* v3.4.192 */}
  if (view === "calls") return <><NavBar /><PortalCalls user={user} onAddClient={(c) => { /* v3.4.163 — تعبئة نموذج التسجيل من مكالمة */
    const d = String(c.phone || "").replace(/[^0-9]/g, ""); const local = d.startsWith("966") ? "0" + d.slice(3) : d.startsWith("00966") ? "0" + d.slice(5) : d;
    setForm({ ...empty, phone: local, name: c.name || "" }); setView("home"); notify && notify("✅ عُبّئ الرقم من المكالمة — أكمل بيانات العميل واحفظ");
  }} /></>; {/* v3.4.156 */}
  if (view === "resv") return <><NavBar /><PortalDalilakReservations user={user} /></>; {/* v3.4.236 */}
  if (view === "offers") return <><NavBar /><PortalOffers /></>; {/* v3.3.846 */}
  if (view === "aqar") return <><NavBar /><PortalAqar /></>; {/* v3.4.443 */}
  if (view === "lands") return <><NavBar /><PortalLands /></>; {/* v3.3.955 */}
  if (view === "stats") return <><NavBar /><PortalStats onBack={() => setView(isSM ? "prospects" : isMarketer ? "clients" : isEmp && FEAT.tasks ? "tasks" : "home")} /></>;
  // v3.4.164 — chat / wa / official / pwa صارت تبويبات داخل مركز الواتس أعلاه

  return (
    <>
      <NavBar />
      {(isMarketer || isSM) && ( // v3.4.095 — نموذج التسجيل يُفتح من «+»؛ زر رجوع إلى عملائي — v3.4.464: أو العملاء المحتملون
        <button type="button" onClick={() => setView(isSM ? "prospects" : "clients")}
          style={{ background: "#fff", border: "1.5px solid #e2e8f0", borderRadius: 10, padding: "8px 14px", fontSize: 12.5, fontWeight: 800, color: "#0f766e", cursor: "pointer", fontFamily: "inherit", marginBottom: 10 }}>
          {isSM ? "← العودة إلى العملاء المحتملين" : "← العودة إلى عملائي"}
        </button>
      )}

      <div style={{ background: "#fff", borderRadius: 16, padding: "20px 18px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.06)", marginBottom: 18 }}>
        <div style={{ fontSize: 15, fontWeight: 800, color: "#0f766e", marginBottom: 4 }}>
          👋 أهلًا {user.display_name || user.phone}
        </div>
        <div style={{ fontSize: 12, color: "#94a3b8", marginBottom: 16 }}>سجّل بيانات العميل المهتم وستصل للشركة فورًا</div>

        {/* v3.3.783 — التنبيهات هنا تحت رسالة الترحيب (كانت تختفي خلف نتوء الآيفون) */}
        <InlineToast toast={toast} />

        <form onSubmit={submit}>
          {/* v3.3.775 — استيراد الاسم والجوال من جهات اتصال الهاتف */}
          {/* v3.3.782 — ظاهر دائمًا (باهت عند عدم الدعم مع رسالة توضيحية عند الضغط) */}
          <button type="button" onClick={pickContact}
            style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, width: "100%",
              padding: "11px", marginBottom: 14, background: "#eff6ff", color: "#1d4ed8",
              border: "1.5px dashed #93c5fd", borderRadius: 10, fontSize: 13.5, fontWeight: 700,
              cursor: "pointer", fontFamily: "inherit", opacity: contactsSupported ? 1 : 0.55 }}>
            📇 استيراد من جهات الاتصال{contactsSupported ? "" : " (أندرويد/كروم)"}
          </button>
          <div style={{ marginBottom: 12 }}>
            <label style={labelS}>اسم العميل *</label>
            <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} style={inputS} />
          </div>
          {/* v3.3.781 — حُذف حقل رقم الهوية بطلب المشغّل */}
          <div style={{ marginBottom: 12 }}>
            <label style={labelS}>جوال العميل</label>
            <input value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })}
              type="tel" inputMode="tel" placeholder="05XXXXXXXX" style={{ ...inputS, direction: "ltr", textAlign: "right" }} />
          </div>
          {/* v3.3.782 — نوع العميل والمصدر: سيليكت من قوائم الإعدادات (سقوط لحقل نصي إن لم تُعرَّف خيارات) */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 12 }}>
            <div>
              <label style={labelS}>نوع العميل</label>
              {opts.client_categories.length ? (
                <select value={form.client_category} onChange={e => setForm({ ...form, client_category: e.target.value })}
                  style={{ ...inputS, appearance: "auto" }}>
                  <option value="">— اختر —</option>
                  {opts.client_categories.map(o => <option key={o} value={o}>{o}</option>)}
                </select>
              ) : (
                <input value={form.client_category} onChange={e => setForm({ ...form, client_category: e.target.value })}
                  placeholder="مستثمر، ساكن..." style={inputS} />
              )}
            </div>
            <div>
              <label style={labelS}>المصدر</label>
              {opts.sources.length ? (
                <select value={form.source} onChange={e => setForm({ ...form, source: e.target.value })}
                  style={{ ...inputS, appearance: "auto" }}>
                  <option value="">— اختر —</option>
                  {opts.sources.map(o => <option key={o} value={o}>{o}</option>)}
                </select>
              ) : (
                <input value={form.source} onChange={e => setForm({ ...form, source: e.target.value })}
                  placeholder="إعلان، توصية..." style={inputS} />
              )}
            </div>
          </div>

          {/* v3.3.782 — اهتمام العميل: تشك ليست متعدد الاختيار
              v3.3.784 — مجمّع: بوكس صغير لكل مجموعة، تظهر مجموعة بعد مجموعة */}
          {opts.interests.length > 0 && (
            <div style={{ marginBottom: 12 }}>
              <label style={labelS}>اهتمام العميل</label>
              {(() => {
                const order = [];
                const map = {};
                opts.interests.forEach(it => {
                  const label = typeof it === "string" ? it : it.label;
                  const g = (typeof it === "string" ? null : it.group) || "";
                  if (!map[g]) { map[g] = []; order.push(g); }
                  map[g].push(label);
                });
                const chip = (o) => {
                  const on = form.interests.includes(o);
                  return (
                    <button key={o} type="button" onClick={() => toggleInterest(o)}
                      style={{ padding: "8px 14px", borderRadius: 12, fontSize: 13, fontWeight: 700,
                        cursor: "pointer", fontFamily: "inherit", display: "inline-flex", alignItems: "center", gap: 6,
                        background: on ? "#0f766e" : "#fff", color: on ? "#fff" : "#475569",
                        border: `1.5px solid ${on ? "#0f766e" : "#e2e8f0"}` }}>
                      {on ? "✓" : "＋"} {o}
                    </button>
                  );
                };
                return (
                  <div style={{ display: "grid", gap: 10 }}>
                    {order.map(g => (
                      <div key={g || "_none"} style={g ? { background: "#f8fafc", border: "1px solid #e2e8f0",
                        borderRadius: 12, padding: "10px 12px" } : {}}>
                        {g && <div style={{ fontSize: 12, fontWeight: 800, color: "#0f766e", marginBottom: 8 }}>{g}</div>}
                        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                          {map[g].map(chip)}
                        </div>
                      </div>
                    ))}
                  </div>
                );
              })()}
            </div>
          )}
          <div style={{ marginBottom: 16 }}>
            <label style={labelS}>ملاحظات</label>
            <textarea value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} rows={3}
              placeholder={recState === "recording" ? "🎙 تكلم الآن — كلامك يتحول لنص هنا تلقائيًا..." : "اكتب أو سجّل صوتيًا 👇"}
              style={{ ...inputS, resize: "vertical",
                borderColor: recState === "recording" ? "#dc2626" : "#e2e8f0" }} />
            {/* v3.3.772 — التسجيل الصوتي مع التفريغ التلقائي */}
            <div style={{ marginTop: 8 }}>
              {recState === "idle" && (
                <button type="button" onClick={startRecording}
                  style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 18px", background: "#fff",
                    color: "#0f766e", border: "1.5px dashed #14b8a6", borderRadius: 10, fontSize: 13.5, fontWeight: 700,
                    cursor: "pointer", fontFamily: "inherit", width: "100%", justifyContent: "center" }}>
                  🎙 تسجيل ملاحظة صوتية (تتحول لنص تلقائيًا)
                </button>
              )}
              {recState === "recording" && (
                <button type="button" onClick={stopRecording}
                  style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 18px", background: "#dc2626",
                    color: "#fff", border: "none", borderRadius: 10, fontSize: 13.5, fontWeight: 800,
                    cursor: "pointer", fontFamily: "inherit", width: "100%", justifyContent: "center" }}>
                  <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#fff",
                    animation: "raelpulse 1s ease-in-out infinite" }} />
                  ⏹ إيقاف التسجيل — {fmtSec(recSeconds)}
                  <style>{"@keyframes raelpulse{50%{opacity:.3}}"}</style>
                </button>
              )}
              {recState === "done" && audioUrl && (
                <div style={{ display: "flex", alignItems: "center", gap: 8, background: "#f0fdfa",
                  border: "1px solid #99f6e4", borderRadius: 10, padding: "8px 10px" }}>
                  <audio controls src={audioUrl} style={{ flex: 1, height: 38 }} />
                  <span style={{ fontSize: 11, color: "#0f766e", fontWeight: 700, whiteSpace: "nowrap" }}>{fmtSec(recSeconds)}</span>
                  <button type="button" onClick={deleteRecording}
                    style={{ background: "#fff1f2", color: "#dc2626", border: "1px solid #fecaca", borderRadius: 8,
                      padding: "6px 10px", fontSize: 12, cursor: "pointer", fontFamily: "inherit" }}>🗑</button>
                </div>
              )}
            </div>
          </div>
          <button type="submit" disabled={busy} style={{ ...btnPrimary, opacity: busy ? 0.7 : 1 }}>
            {busy ? "جاري الحفظ..." : "＋ تسجيل العميل"}
          </button>
          {/* v3.3.838 — التسجيل الجماعي عبر ملف Excel */}
          <button type="button" onClick={() => setBulkOpen(true)}
            style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, width: "100%",
              padding: "12px", marginTop: 10, background: "#fff", color: "#7c3aed",
              border: "1.5px dashed #c4b5fd", borderRadius: 10, fontSize: 13.5, fontWeight: 800,
              cursor: "pointer", fontFamily: "inherit" }}>
            📥 تسجيل جماعي (ملف Excel)
          </button>
        </form>
      </div>

      {bulkOpen && (
        <BulkRegisterModal
          onClose={() => setBulkOpen(false)}
          onDone={(n) => { setBulkOpen(false); notify(`✅ تم تسجيل ${n} عميل بنجاح`); loadMine(); }}
        />
      )}

      {/* إدخالاتي — v3.3.786: مجمّعة بالتاريخ + كل عميل يتوسع بالضغط لعرض تفاصيله */}
      <div style={{ background: "#fff", borderRadius: 16, padding: "18px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.06)" }}>
        <div style={{ fontSize: 14, fontWeight: 800, color: "#1e293b", marginBottom: 12 }}>
          🗂️ عملائي المسجّلون {mine ? `(${mine.length})` : ""}
        </div>
        {mine === null ? (
          <div style={{ textAlign: "center", color: "#94a3b8", padding: 20, fontSize: 13 }}>جاري التحميل...</div>
        ) : mine.length === 0 ? (
          <div style={{ textAlign: "center", color: "#94a3b8", padding: 20, fontSize: 13 }}>لم تسجّل أي عميل بعد</div>
        ) : (
          (() => {
            const today = new Date().toISOString().slice(0, 10);
            const yest = new Date(Date.now() - 86400000).toISOString().slice(0, 10);
            const dayLabel = (d) => d === today ? "اليوم" : d === yest ? "أمس" : d;
            const order = [];
            const byDate = {};
            mine.forEach(p => {
              const d = fmtDate(p.created_at);
              if (!byDate[d]) { byDate[d] = []; order.push(d); }
              byDate[d].push(p);
            });
            const DetailRow = ({ l, v, ltr }) => (
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 10, padding: "5px 0", borderBottom: "1px dashed #f1f5f9" }}>
                <span style={{ fontSize: 11, color: "#94a3b8", fontWeight: 700, flexShrink: 0 }}>{l}</span>
                <span style={{ fontSize: 12.5, fontWeight: 600, color: "#1e293b", textAlign: "left",
                  direction: ltr ? "ltr" : "rtl", wordBreak: "break-word" }}>{v || "—"}</span>
              </div>
            );
            return (
              <div style={{ display: "grid", gap: 14 }}>
                {order.map(d => (
                  <div key={d}>
                    {/* رأس اليوم */}
                    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
                      <span style={{ background: "#0f766e", color: "#fff", borderRadius: 12, padding: "3px 14px", fontSize: 11.5, fontWeight: 800 }}>
                        📅 {dayLabel(d)}
                      </span>
                      <span style={{ fontSize: 10.5, color: "#94a3b8", fontWeight: 700 }}>{byDate[d].length} عميل</span>
                      <div style={{ flex: 1, height: 1, background: "#e2e8f0" }} />
                    </div>
                    <div style={{ display: "grid", gap: 8 }}>
                      {byDate[d].map(p => {
                        const open = expanded === p.id;
                        return (
                          <div key={p.id} style={{ border: `1.5px solid ${open ? "#99f6e4" : "#f1f5f9"}`,
                            background: open ? "#f0fdfa" : "#f8fafc", borderRadius: 12, overflow: "hidden" }}>
                            {/* الصف المضغوط — اضغط للتوسيع */}
                            <div onClick={() => toggleExpand(p)} style={{ padding: "10px 14px", cursor: "pointer",
                              display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10 }}>
                              <div style={{ minWidth: 0, display: "flex", alignItems: "center", gap: 8 }}>
                                <span style={{ fontSize: 13, color: "#0f766e", transform: open ? "rotate(90deg)" : "none", transition: "transform 0.15s", display: "inline-block" }}>◀</span>
                                <div>
                                  <div style={{ fontSize: 13.5, fontWeight: 700, color: "#1e293b" }}>
                                    {p.name} {p.has_voice && <span title="ملاحظة صوتية">🎙</span>}
                                  </div>
                                  <div style={{ fontSize: 11, color: "#64748b", direction: "ltr", textAlign: "right" }}>{p.phone || ""}</div>
                                </div>
                              </div>
                              <span style={{ background: "#dcfce7", color: "#166534", borderRadius: 12, padding: "2px 10px", fontSize: 10.5, fontWeight: 700, flexShrink: 0 }}>
                                {p.status || "رقم جديد"}{/* v3.4.231 */}
                              </span>
                            </div>
                            {/* التفاصيل الموسعة */}
                            {open && (
                              <div style={{ padding: "4px 16px 14px", borderTop: "1px solid #ccfbf1" }}>
                                <DetailRow l="نوع العميل" v={p.client_category} />
                                <DetailRow l="المصدر" v={p.source} />
                                <DetailRow l="الاهتمامات" v={p.portal_interests} />
                                <DetailRow l="الملاحظات" v={p.notes} />
                                {p.has_voice && (
                                  <div style={{ marginTop: 10 }}>
                                    <div style={{ fontSize: 11, color: "#94a3b8", fontWeight: 700, marginBottom: 5 }}>🎙 الملاحظة الصوتية</div>
                                    {voiceUrls[p.id]
                                      ? <audio controls src={voiceUrls[p.id]} style={{ width: "100%", height: 40 }} />
                                      : <div style={{ fontSize: 11.5, color: "#94a3b8" }}>جاري تحميل التسجيل...</div>}
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
            );
          })()
        )}
      </div>
    </>
  );
}
